var _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27, _use28, _use29, _use30, _use31, _use32, _use33, _use34, _use35, _use36, _use37, _use38, _use39, _use40, _use41, _use42, _use43, _use44, _use45, _use46, _use47, _use48, _use49, _use50, _use51, _use52, _use53, _use54, _use55, _use56, _use57, _use58, _use59, _use60, _use61, _use62, _use63, _use64, _use65, _use66, _use67, _use68, _use69, _use70, _use71, _use72, _use73, _use74, _use75, _use76, _use77, _use78, _use79, _use80, _use81, _use82, _use83, _use84, _use85, _use86, _use87, _use88, _use89, _use90, _use91, _use92, _use93, _use94, _use95, _use96, _use97, _use98, _use99, _use100, _use101, _use102, _use103, _use104, _use105, _use106, _use107, _use108, _use109, _use110, _use111, _use112, _use113, _use114, _use115, _use116, _use117, _use118, _use119, _use120, _use121, _use122, _use123, _use124, _use125, _use126, _use127, _use128, _use129, _use130, _use131, _use132, _use133, _use134, _use135, _use136, _use137, _use138, _use139, _use140, _use141, _use142, _use143, _use144, _use145, _use146, _use147, _use148, _use149, _use150, _use151, _use152, _use153, _use154, _use155, _use156, _use157, _use158, _use159, _use160, _use161, _use162, _use163, _use164, _use165, _use166, _use167, _use168, _use169, _use170, _use171, _use172, _use173, _use174, _use175, _use176, _use177, _use178, _use179, _use180, _use181, _use182, _use183, _use184, _use185, _use186, _use187, _use188, _use189, _use190, _use191, _use192, _use193, _use194, _use195, _use196, _use197, _use198, _use199, _use200, _use201, _use202, _use203, _use204, _use205, _use206, _use207, _use208, _use209, _use210, _use211, _use212, _use213, _use214, _use215, _use216, _use217, _use218, _use219, _use220, _use221, _use222, _use223, _use224, _use225, _use226, _use227, _use228, _use229, _use230, _use231, _use232, _use233, _use234, _use235, _use236, _use237, _use238, _use239, _use240, _use241, _use242, _use243, _use244, _use245, _use246, _use247, _use248, _use249, _use250, _use251, _use252, _use253, _use254, _use255, _use256, _use257, _use258, _use259, _use260, _use261, _use262, _use263, _use264, _use265, _use266, _use267, _use268, _use269, _use270, _use271, _use272, _use273, _use274, _use275, _use276, _use277, _use278, _use279, _use280, _use281, _use282, _use283, _use284, _use285, _use286, _use287, _use288, _use289, _use290, _use291, _use292, _use293, _use294, _use295, _use296, _use297, _use298, _use299, _use300, _use301, _use302, _use303, _use304, _use305, _use306, _use307, _use308, _use309, _use310, _use311, _use312, _use313, _use314, _use315, _use316, _use317, _use318, _use319, _use320, _use321, _use322, _use323, _use324, _use325, _use326, _use327, _use328, _use329, _use330, _use331, _use332, _use333, _use334, _use335, _use336, _use337, _use338, _use339, _use340, _use341, _use342, _use343, _use344, _use345, _use346, _use347, _use348, _use349;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPythonNanodegree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "792pt",
    height: "612pt",
    viewBox: "0 0 792 612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.125 -4.671875 L 3.234375 -3.5625 L 4.34375 -4.671875 L 4.78125 -4.234375 L 3.671875 -3.125 L 4.796875 -2 L 4.34375 -1.5625 L 3.234375 -2.671875 L 2.109375 -1.5625 L 1.65625 -2 L 2.78125 -3.125 L 1.671875 -4.234375 Z M 0.890625 0 L 5.5625 0 L 5.5625 -6.234375 L 0.890625 -6.234375 Z M 0.890625 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.078125 -6.234375 L 2.875 -0.484375 L 0.65625 -6.234375 L 0.203125 -6.234375 L 2.65625 0 L 3.09375 0 L 5.53125 -6.234375 Z M 5.078125 -6.234375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.21875 -6.234375 L 0.890625 -6.234375 L 0.890625 0 L 4.328125 0 L 4.328125 -0.34375 L 1.328125 -0.34375 L 1.328125 -2.96875 L 4.125 -2.96875 L 4.125 -3.3125 L 1.328125 -3.3125 L 1.328125 -5.890625 L 4.21875 -5.890625 Z M 4.21875 -6.234375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.328125 0 L 1.328125 -2.671875 L 2.875 -2.671875 L 4.3125 0 L 4.765625 0 L 3.28125 -2.734375 C 3.4375 -2.785156 3.597656 -2.859375 3.765625 -2.953125 C 3.941406 -3.054688 4.097656 -3.179688 4.234375 -3.328125 C 4.378906 -3.472656 4.492188 -3.640625 4.578125 -3.828125 C 4.671875 -4.023438 4.71875 -4.25 4.71875 -4.5 C 4.71875 -4.769531 4.664062 -5.007812 4.5625 -5.21875 C 4.457031 -5.425781 4.3125 -5.601562 4.125 -5.75 C 3.945312 -5.90625 3.734375 -6.019531 3.484375 -6.09375 C 3.242188 -6.175781 2.976562 -6.222656 2.6875 -6.234375 L 0.890625 -6.234375 L 0.890625 0 Z M 2.640625 -5.890625 C 3.160156 -5.890625 3.554688 -5.757812 3.828125 -5.5 C 4.109375 -5.238281 4.25 -4.878906 4.25 -4.421875 C 4.25 -4.222656 4.210938 -4.046875 4.140625 -3.890625 C 4.066406 -3.734375 3.972656 -3.59375 3.859375 -3.46875 C 3.742188 -3.351562 3.609375 -3.253906 3.453125 -3.171875 C 3.304688 -3.097656 3.15625 -3.046875 3 -3.015625 L 1.328125 -3.015625 L 1.328125 -5.890625 Z M 2.640625 -5.890625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.890625 0 L 1.3125 0 L 1.3125 -6.234375 L 0.890625 -6.234375 Z M 0.890625 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.125 -6.234375 L 0.890625 -6.234375 L 0.890625 0 L 1.328125 0 L 1.328125 -2.96875 L 3.90625 -2.96875 L 3.90625 -3.3125 L 1.328125 -3.3125 L 1.328125 -5.890625 L 4.125 -5.890625 Z M 4.125 -6.234375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.359375 0 C 2.785156 0 3.179688 -0.0703125 3.546875 -0.21875 C 3.921875 -0.363281 4.238281 -0.570312 4.5 -0.84375 C 4.769531 -1.113281 4.976562 -1.441406 5.125 -1.828125 C 5.28125 -2.210938 5.359375 -2.644531 5.359375 -3.125 C 5.359375 -3.570312 5.289062 -3.984375 5.15625 -4.359375 C 5.03125 -4.734375 4.84375 -5.054688 4.59375 -5.328125 C 4.34375 -5.609375 4.03125 -5.828125 3.65625 -5.984375 C 3.28125 -6.140625 2.847656 -6.222656 2.359375 -6.234375 L 0.890625 -6.234375 L 0.890625 0 Z M 1.3125 -0.34375 L 1.3125 -5.890625 L 2.359375 -5.890625 C 2.773438 -5.890625 3.140625 -5.820312 3.453125 -5.6875 C 3.773438 -5.550781 4.039062 -5.359375 4.25 -5.109375 C 4.457031 -4.859375 4.613281 -4.554688 4.71875 -4.203125 C 4.832031 -3.859375 4.890625 -3.472656 4.890625 -3.046875 C 4.890625 -2.617188 4.820312 -2.238281 4.6875 -1.90625 C 4.5625 -1.582031 4.378906 -1.300781 4.140625 -1.0625 C 3.910156 -0.832031 3.640625 -0.65625 3.328125 -0.53125 C 3.015625 -0.40625 2.675781 -0.34375 2.3125 -0.34375 Z M 1.3125 -0.34375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.515625 -3.09375 C 0.515625 -2.625 0.582031 -2.191406 0.71875 -1.796875 C 0.851562 -1.410156 1.050781 -1.078125 1.3125 -0.796875 C 1.570312 -0.515625 1.890625 -0.296875 2.265625 -0.140625 C 2.640625 0.015625 3.066406 0.09375 3.546875 0.09375 C 3.796875 0.09375 4.035156 0.0664062 4.265625 0.015625 C 4.492188 -0.0234375 4.703125 -0.0859375 4.890625 -0.171875 L 4.765625 -0.484375 C 4.640625 -0.429688 4.476562 -0.382812 4.28125 -0.34375 C 4.082031 -0.300781 3.875 -0.28125 3.65625 -0.28125 C 3.21875 -0.28125 2.832031 -0.34375 2.5 -0.46875 C 2.164062 -0.601562 1.882812 -0.796875 1.65625 -1.046875 C 1.4375 -1.304688 1.269531 -1.613281 1.15625 -1.96875 C 1.039062 -2.332031 0.984375 -2.738281 0.984375 -3.1875 C 0.984375 -3.625 1.039062 -4.015625 1.15625 -4.359375 C 1.269531 -4.703125 1.4375 -4.988281 1.65625 -5.21875 C 1.875 -5.457031 2.128906 -5.640625 2.421875 -5.765625 C 2.722656 -5.890625 3.054688 -5.953125 3.421875 -5.953125 C 3.648438 -5.941406 3.859375 -5.914062 4.046875 -5.875 C 4.242188 -5.832031 4.410156 -5.785156 4.546875 -5.734375 L 4.671875 -6.046875 C 4.503906 -6.117188 4.3125 -6.179688 4.09375 -6.234375 C 3.882812 -6.285156 3.671875 -6.316406 3.453125 -6.328125 C 2.984375 -6.316406 2.566406 -6.234375 2.203125 -6.078125 C 1.847656 -5.921875 1.539062 -5.695312 1.28125 -5.40625 C 1.03125 -5.113281 0.835938 -4.769531 0.703125 -4.375 C 0.578125 -3.988281 0.515625 -3.5625 0.515625 -3.09375 Z M 0.515625 -3.09375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.203125 -5.890625 L 2.125 -5.890625 L 2.125 0 L 2.546875 0 L 2.546875 -5.890625 L 4.46875 -5.890625 L 4.46875 -6.234375 L 0.203125 -6.234375 Z M 0.203125 -5.890625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-10"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.078125 0 L 5.53125 0 L 3.09375 -6.234375 L 2.65625 -6.234375 L 0.203125 0 L 0.65625 0 L 1.328125 -1.75 L 4.40625 -1.75 Z M 2.875 -5.75 L 4.28125 -2.09375 L 1.46875 -2.09375 Z M 2.875 -5.75 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-11"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.328125 -0.28125 C 2.960938 -0.28125 2.632812 -0.347656 2.34375 -0.484375 C 2.0625 -0.617188 1.816406 -0.8125 1.609375 -1.0625 C 1.410156 -1.320312 1.253906 -1.628906 1.140625 -1.984375 C 1.035156 -2.335938 0.984375 -2.738281 0.984375 -3.1875 C 0.984375 -3.59375 1.035156 -3.960938 1.140625 -4.296875 C 1.253906 -4.640625 1.410156 -4.929688 1.609375 -5.171875 C 1.816406 -5.421875 2.0625 -5.613281 2.34375 -5.75 C 2.625 -5.882812 2.929688 -5.953125 3.265625 -5.953125 C 3.609375 -5.953125 3.921875 -5.878906 4.203125 -5.734375 C 4.492188 -5.597656 4.742188 -5.398438 4.953125 -5.140625 C 5.160156 -4.890625 5.316406 -4.585938 5.421875 -4.234375 C 5.535156 -3.878906 5.597656 -3.484375 5.609375 -3.046875 C 5.597656 -2.628906 5.535156 -2.25 5.421875 -1.90625 C 5.304688 -1.570312 5.144531 -1.28125 4.9375 -1.03125 C 4.738281 -0.789062 4.5 -0.601562 4.21875 -0.46875 C 3.945312 -0.34375 3.648438 -0.28125 3.328125 -0.28125 Z M 3.265625 0.09375 C 3.679688 0.09375 4.054688 0.0195312 4.390625 -0.125 C 4.734375 -0.28125 5.03125 -0.5 5.28125 -0.78125 C 5.53125 -1.070312 5.722656 -1.414062 5.859375 -1.8125 C 5.992188 -2.207031 6.066406 -2.644531 6.078125 -3.125 C 6.066406 -3.59375 5.992188 -4.019531 5.859375 -4.40625 C 5.722656 -4.789062 5.53125 -5.125 5.28125 -5.40625 C 5.039062 -5.695312 4.753906 -5.921875 4.421875 -6.078125 C 4.085938 -6.234375 3.722656 -6.316406 3.328125 -6.328125 C 2.898438 -6.316406 2.515625 -6.234375 2.171875 -6.078125 C 1.835938 -5.921875 1.539062 -5.703125 1.28125 -5.421875 C 1.03125 -5.140625 0.835938 -4.800781 0.703125 -4.40625 C 0.578125 -4.007812 0.515625 -3.570312 0.515625 -3.09375 C 0.515625 -2.625 0.578125 -2.195312 0.703125 -1.8125 C 0.835938 -1.425781 1.03125 -1.085938 1.28125 -0.796875 C 1.53125 -0.515625 1.820312 -0.296875 2.15625 -0.140625 C 2.488281 0.015625 2.859375 0.09375 3.265625 0.09375 Z M 3.265625 0.09375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-12"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.890625 0 L 1.328125 0 L 1.328125 -5.8125 L 3.734375 -0.875 L 4.109375 -0.875 L 6.53125 -5.8125 L 6.53125 0 L 6.953125 0 L 6.953125 -6.234375 L 6.3125 -6.234375 L 3.921875 -1.375 L 1.53125 -6.234375 L 0.890625 -6.234375 Z M 0.890625 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-13"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.3125 0 L 1.3125 -2.578125 L 2.546875 -2.578125 C 2.847656 -2.578125 3.125 -2.613281 3.375 -2.6875 C 3.625 -2.769531 3.84375 -2.890625 4.03125 -3.046875 C 4.21875 -3.210938 4.363281 -3.410156 4.46875 -3.640625 C 4.570312 -3.867188 4.625 -4.128906 4.625 -4.421875 C 4.625 -4.691406 4.570312 -4.9375 4.46875 -5.15625 C 4.375 -5.382812 4.238281 -5.578125 4.0625 -5.734375 C 3.882812 -5.890625 3.671875 -6.007812 3.421875 -6.09375 C 3.171875 -6.175781 2.894531 -6.222656 2.59375 -6.234375 L 0.890625 -6.234375 L 0.890625 0 Z M 2.546875 -5.890625 C 3.085938 -5.890625 3.488281 -5.753906 3.75 -5.484375 C 4.019531 -5.222656 4.15625 -4.84375 4.15625 -4.34375 C 4.15625 -4.101562 4.117188 -3.894531 4.046875 -3.71875 C 3.972656 -3.550781 3.832031 -3.375 3.625 -3.1875 C 3.425781 -3.007812 3.082031 -2.921875 2.59375 -2.921875 L 1.3125 -2.921875 L 1.3125 -5.890625 Z M 2.546875 -5.890625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-14"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.078125 -0.34375 L 1.3125 -0.34375 L 1.3125 -6.234375 L 0.890625 -6.234375 L 0.890625 0 L 4.078125 0 Z M 4.078125 -0.34375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-15"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.8125 0 L 5.390625 0 L 5.390625 -6.234375 L 4.96875 -6.234375 L 4.96875 -0.53125 L 1.46875 -6.234375 L 0.890625 -6.234375 L 0.890625 0 L 1.328125 0 L 1.328125 -5.703125 Z M 4.8125 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.328125 -5.140625 L 3.5625 -3.921875 L 4.78125 -5.140625 L 5.265625 -4.65625 L 4.046875 -3.4375 L 5.28125 -2.203125 L 4.78125 -1.71875 L 3.5625 -2.9375 L 2.328125 -1.71875 L 1.828125 -2.203125 L 3.0625 -3.4375 L 1.84375 -4.65625 Z M 0.984375 0 L 6.125 0 L 6.125 -6.859375 L 0.984375 -6.859375 Z M 0.984375 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.984375 0 L 1.453125 0 L 1.453125 -6.40625 L 4.109375 -0.96875 L 4.515625 -0.96875 L 7.1875 -6.40625 L 7.1875 0 L 7.65625 0 L 7.65625 -6.859375 L 6.9375 -6.859375 L 4.3125 -1.515625 L 1.6875 -6.859375 L 0.984375 -6.859375 Z M 0.984375 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.125 -3.546875 C 4.125 -3.828125 4.085938 -4.078125 4.015625 -4.296875 C 3.941406 -4.523438 3.828125 -4.71875 3.671875 -4.875 C 3.523438 -5.039062 3.335938 -5.164062 3.109375 -5.25 C 2.890625 -5.332031 2.640625 -5.378906 2.359375 -5.390625 C 2.171875 -5.378906 1.992188 -5.359375 1.828125 -5.328125 C 1.660156 -5.296875 1.503906 -5.253906 1.359375 -5.203125 C 1.222656 -5.148438 1.101562 -5.097656 1 -5.046875 C 0.894531 -4.992188 0.816406 -4.945312 0.765625 -4.90625 L 0.9375 -4.609375 C 1.070312 -4.679688 1.226562 -4.75 1.40625 -4.8125 C 1.582031 -4.875 1.738281 -4.914062 1.875 -4.9375 C 2.019531 -4.96875 2.164062 -4.984375 2.3125 -4.984375 C 2.550781 -4.984375 2.753906 -4.945312 2.921875 -4.875 C 3.097656 -4.800781 3.265625 -4.664062 3.421875 -4.46875 C 3.585938 -4.28125 3.671875 -3.953125 3.671875 -3.484375 L 3.671875 -2.796875 C 3.222656 -2.847656 2.796875 -2.851562 2.390625 -2.8125 C 2.109375 -2.789062 1.851562 -2.738281 1.625 -2.65625 C 1.40625 -2.570312 1.210938 -2.460938 1.046875 -2.328125 C 0.878906 -2.203125 0.75 -2.046875 0.65625 -1.859375 C 0.5625 -1.679688 0.515625 -1.484375 0.515625 -1.265625 C 0.515625 -1.054688 0.550781 -0.867188 0.625 -0.703125 C 0.695312 -0.535156 0.800781 -0.390625 0.9375 -0.265625 C 1.070312 -0.148438 1.226562 -0.0625 1.40625 0 C 1.59375 0.0703125 1.789062 0.109375 2 0.109375 C 2.3125 0.109375 2.617188 0.03125 2.921875 -0.125 C 3.222656 -0.28125 3.488281 -0.507812 3.71875 -0.8125 C 3.71875 -0.5 3.785156 -0.265625 3.921875 -0.109375 C 4.054688 0.0351562 4.238281 0.109375 4.46875 0.109375 C 4.5625 0.109375 4.644531 0.09375 4.71875 0.0625 C 4.800781 0.0390625 4.859375 0.0195312 4.890625 0 L 4.828125 -0.296875 C 4.804688 -0.273438 4.769531 -0.257812 4.71875 -0.25 C 4.664062 -0.238281 4.609375 -0.234375 4.546875 -0.234375 C 4.410156 -0.234375 4.304688 -0.273438 4.234375 -0.359375 C 4.160156 -0.453125 4.125 -0.597656 4.125 -0.796875 Z M 1 -1.328125 C 1.007812 -1.660156 1.132812 -1.921875 1.375 -2.109375 C 1.613281 -2.296875 1.945312 -2.414062 2.375 -2.46875 C 2.800781 -2.519531 3.234375 -2.519531 3.671875 -2.46875 L 3.671875 -1.171875 C 3.472656 -0.910156 3.234375 -0.695312 2.953125 -0.53125 C 2.679688 -0.375 2.398438 -0.296875 2.109375 -0.296875 C 1.742188 -0.296875 1.46875 -0.390625 1.28125 -0.578125 C 1.09375 -0.765625 1 -1.015625 1 -1.328125 Z M 1 -1.328125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.984375 -5.28125 L 0.984375 0 L 1.4375 0 L 1.4375 -4.078125 C 1.539062 -4.160156 1.65625 -4.242188 1.78125 -4.328125 C 1.914062 -4.421875 2.097656 -4.519531 2.328125 -4.625 C 2.554688 -4.738281 2.847656 -4.828125 3.203125 -4.890625 L 3.203125 -5.375 C 2.867188 -5.320312 2.582031 -5.234375 2.34375 -5.109375 C 2.101562 -4.984375 1.910156 -4.863281 1.765625 -4.75 C 1.628906 -4.644531 1.503906 -4.539062 1.390625 -4.4375 L 1.3125 -5.28125 Z M 0.984375 -5.28125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.0625 -2.6875 C 1.0625 -3.039062 1.109375 -3.351562 1.203125 -3.625 C 1.296875 -3.90625 1.429688 -4.144531 1.609375 -4.34375 C 1.796875 -4.550781 2.019531 -4.707031 2.28125 -4.8125 C 2.539062 -4.925781 2.828125 -4.984375 3.140625 -4.984375 C 3.347656 -4.984375 3.535156 -4.960938 3.703125 -4.921875 C 3.867188 -4.890625 4.003906 -4.851562 4.109375 -4.8125 L 4.265625 -5.140625 C 4.160156 -5.191406 4.007812 -5.242188 3.8125 -5.296875 C 3.613281 -5.347656 3.394531 -5.378906 3.15625 -5.390625 C 2.769531 -5.378906 2.414062 -5.304688 2.09375 -5.171875 C 1.78125 -5.046875 1.507812 -4.859375 1.28125 -4.609375 C 1.050781 -4.367188 0.875 -4.078125 0.75 -3.734375 C 0.625 -3.390625 0.5625 -3.007812 0.5625 -2.59375 C 0.5625 -2.1875 0.617188 -1.816406 0.734375 -1.484375 C 0.859375 -1.160156 1.03125 -0.878906 1.25 -0.640625 C 1.476562 -0.398438 1.742188 -0.210938 2.046875 -0.078125 C 2.359375 0.046875 2.707031 0.109375 3.09375 0.109375 C 3.320312 0.109375 3.546875 0.0820312 3.765625 0.03125 C 3.984375 -0.0078125 4.1875 -0.0703125 4.375 -0.15625 L 4.25 -0.5 C 4.09375 -0.425781 3.914062 -0.367188 3.71875 -0.328125 C 3.53125 -0.296875 3.34375 -0.285156 3.15625 -0.296875 C 2.8125 -0.296875 2.507812 -0.347656 2.25 -0.453125 C 1.988281 -0.566406 1.769531 -0.726562 1.59375 -0.9375 C 1.414062 -1.144531 1.28125 -1.394531 1.1875 -1.6875 C 1.101562 -1.976562 1.0625 -2.3125 1.0625 -2.6875 Z M 1.0625 -2.6875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.984375 -7.53125 L 0.984375 0 L 1.4375 0 L 1.4375 -4.109375 C 1.5625 -4.210938 1.691406 -4.3125 1.828125 -4.40625 C 1.972656 -4.5 2.125 -4.585938 2.28125 -4.671875 C 2.445312 -4.753906 2.613281 -4.816406 2.78125 -4.859375 C 2.945312 -4.910156 3.113281 -4.941406 3.28125 -4.953125 C 3.707031 -4.941406 4.019531 -4.804688 4.21875 -4.546875 C 4.414062 -4.296875 4.515625 -3.910156 4.515625 -3.390625 L 4.515625 0 L 4.984375 0 L 4.984375 -3.46875 C 4.984375 -3.757812 4.953125 -4.019531 4.890625 -4.25 C 4.828125 -4.488281 4.726562 -4.691406 4.59375 -4.859375 C 4.46875 -5.023438 4.300781 -5.15625 4.09375 -5.25 C 3.894531 -5.34375 3.660156 -5.390625 3.390625 -5.390625 C 3.203125 -5.378906 3.015625 -5.347656 2.828125 -5.296875 C 2.648438 -5.253906 2.476562 -5.191406 2.3125 -5.109375 C 2.144531 -5.023438 1.988281 -4.929688 1.84375 -4.828125 C 1.695312 -4.734375 1.5625 -4.632812 1.4375 -4.53125 L 1.4375 -7.640625 Z M 0.984375 -7.53125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.359375 -0.359375 L 0.359375 0 L 3.671875 0 L 3.671875 -0.359375 L 2.359375 -0.375 L 2.359375 -6.96875 L 2.3125 -6.96875 C 2.15625 -6.9375 1.988281 -6.90625 1.8125 -6.875 C 1.632812 -6.851562 1.457031 -6.828125 1.28125 -6.796875 C 1.101562 -6.773438 0.929688 -6.753906 0.765625 -6.734375 C 0.609375 -6.710938 0.460938 -6.695312 0.328125 -6.6875 L 0.375 -6.359375 C 0.613281 -6.367188 0.863281 -6.390625 1.125 -6.421875 C 1.394531 -6.460938 1.648438 -6.5 1.890625 -6.53125 L 1.890625 -0.375 Z M 0.359375 -0.359375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.421875 1.671875 C 0.503906 1.617188 0.597656 1.550781 0.703125 1.46875 C 0.804688 1.382812 0.90625 1.28125 1 1.15625 C 1.09375 1.039062 1.171875 0.910156 1.234375 0.765625 C 1.296875 0.617188 1.328125 0.453125 1.328125 0.265625 C 1.328125 0.140625 1.3125 0.0234375 1.28125 -0.078125 C 1.257812 -0.191406 1.226562 -0.289062 1.1875 -0.375 C 1.15625 -0.457031 1.117188 -0.523438 1.078125 -0.578125 C 1.035156 -0.640625 1.003906 -0.6875 0.984375 -0.71875 L 0.515625 -0.59375 C 0.597656 -0.5 0.675781 -0.375 0.75 -0.21875 C 0.820312 -0.0625 0.859375 0.117188 0.859375 0.328125 C 0.859375 0.472656 0.835938 0.597656 0.796875 0.703125 C 0.753906 0.816406 0.695312 0.914062 0.625 1 C 0.550781 1.09375 0.476562 1.171875 0.40625 1.234375 C 0.332031 1.304688 0.265625 1.363281 0.203125 1.40625 Z M 0.421875 1.671875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.625 0 L 4.71875 0 L 4.71875 -0.375 L 1.171875 -0.375 C 1.734375 -0.976562 2.222656 -1.507812 2.640625 -1.96875 C 3.054688 -2.425781 3.398438 -2.835938 3.671875 -3.203125 C 3.953125 -3.566406 4.15625 -3.898438 4.28125 -4.203125 C 4.414062 -4.515625 4.484375 -4.828125 4.484375 -5.140625 C 4.484375 -5.421875 4.429688 -5.671875 4.328125 -5.890625 C 4.234375 -6.109375 4.09375 -6.296875 3.90625 -6.453125 C 3.726562 -6.617188 3.515625 -6.742188 3.265625 -6.828125 C 3.015625 -6.910156 2.734375 -6.953125 2.421875 -6.953125 C 2.234375 -6.953125 2.054688 -6.929688 1.890625 -6.890625 C 1.722656 -6.859375 1.566406 -6.816406 1.421875 -6.765625 C 1.285156 -6.710938 1.164062 -6.660156 1.0625 -6.609375 C 0.957031 -6.554688 0.875 -6.515625 0.8125 -6.484375 L 0.96875 -6.171875 C 1.03125 -6.203125 1.109375 -6.238281 1.203125 -6.28125 C 1.296875 -6.320312 1.398438 -6.363281 1.515625 -6.40625 C 1.640625 -6.445312 1.769531 -6.476562 1.90625 -6.5 C 2.050781 -6.53125 2.203125 -6.550781 2.359375 -6.5625 C 2.898438 -6.550781 3.300781 -6.414062 3.5625 -6.15625 C 3.832031 -5.90625 3.96875 -5.546875 3.96875 -5.078125 C 3.96875 -4.847656 3.914062 -4.601562 3.8125 -4.34375 C 3.71875 -4.09375 3.546875 -3.796875 3.296875 -3.453125 C 3.046875 -3.109375 2.703125 -2.6875 2.265625 -2.1875 C 1.828125 -1.695312 1.28125 -1.101562 0.625 -0.40625 Z M 0.625 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-10"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.328125 -0.296875 C 2.984375 -0.296875 2.675781 -0.367188 2.40625 -0.515625 C 2.132812 -0.671875 1.910156 -0.890625 1.734375 -1.171875 C 1.554688 -1.460938 1.421875 -1.800781 1.328125 -2.1875 C 1.234375 -2.582031 1.1875 -3.019531 1.1875 -3.5 C 1.1875 -3.96875 1.234375 -4.382812 1.328125 -4.75 C 1.421875 -5.125 1.554688 -5.441406 1.734375 -5.703125 C 1.921875 -5.972656 2.140625 -6.179688 2.390625 -6.328125 C 2.648438 -6.472656 2.941406 -6.550781 3.265625 -6.5625 C 3.609375 -6.550781 3.910156 -6.46875 4.171875 -6.3125 C 4.441406 -6.15625 4.664062 -5.9375 4.84375 -5.65625 C 5.019531 -5.375 5.15625 -5.035156 5.25 -4.640625 C 5.351562 -4.253906 5.40625 -3.828125 5.40625 -3.359375 C 5.40625 -2.878906 5.351562 -2.453125 5.25 -2.078125 C 5.144531 -1.703125 5 -1.378906 4.8125 -1.109375 C 4.632812 -0.847656 4.421875 -0.644531 4.171875 -0.5 C 3.921875 -0.363281 3.640625 -0.296875 3.328125 -0.296875 Z M 3.265625 0.109375 C 3.691406 0.109375 4.066406 0.0195312 4.390625 -0.15625 C 4.722656 -0.332031 5 -0.578125 5.21875 -0.890625 C 5.445312 -1.210938 5.617188 -1.585938 5.734375 -2.015625 C 5.847656 -2.453125 5.910156 -2.925781 5.921875 -3.4375 C 5.910156 -3.945312 5.84375 -4.410156 5.71875 -4.828125 C 5.601562 -5.253906 5.4375 -5.625 5.21875 -5.9375 C 5 -6.257812 4.726562 -6.507812 4.40625 -6.6875 C 4.09375 -6.863281 3.734375 -6.953125 3.328125 -6.953125 C 2.898438 -6.953125 2.519531 -6.863281 2.1875 -6.6875 C 1.851562 -6.507812 1.570312 -6.257812 1.34375 -5.9375 C 1.125 -5.625 0.957031 -5.25 0.84375 -4.8125 C 0.726562 -4.382812 0.671875 -3.921875 0.671875 -3.421875 C 0.671875 -2.910156 0.726562 -2.4375 0.84375 -2 C 0.957031 -1.570312 1.125 -1.195312 1.34375 -0.875 C 1.570312 -0.5625 1.847656 -0.316406 2.171875 -0.140625 C 2.492188 0.0234375 2.859375 0.109375 3.265625 0.109375 Z M 3.265625 0.109375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-11"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.765625 0.109375 C 3.015625 0.109375 3.265625 0.0703125 3.515625 0 C 3.773438 -0.0703125 4.007812 -0.179688 4.21875 -0.328125 C 4.4375 -0.472656 4.609375 -0.65625 4.734375 -0.875 C 4.867188 -1.09375 4.941406 -1.351562 4.953125 -1.65625 C 4.941406 -1.875 4.894531 -2.078125 4.8125 -2.265625 C 4.726562 -2.460938 4.613281 -2.640625 4.46875 -2.796875 C 4.320312 -2.960938 4.15625 -3.109375 3.96875 -3.234375 C 3.78125 -3.367188 3.582031 -3.488281 3.375 -3.59375 C 3.5625 -3.675781 3.738281 -3.769531 3.90625 -3.875 C 4.082031 -3.988281 4.234375 -4.113281 4.359375 -4.25 C 4.492188 -4.394531 4.597656 -4.554688 4.671875 -4.734375 C 4.753906 -4.921875 4.800781 -5.132812 4.8125 -5.375 C 4.800781 -5.613281 4.734375 -5.832031 4.609375 -6.03125 C 4.484375 -6.226562 4.320312 -6.394531 4.125 -6.53125 C 3.925781 -6.664062 3.710938 -6.769531 3.484375 -6.84375 C 3.265625 -6.914062 3.050781 -6.957031 2.84375 -6.96875 C 2.601562 -6.957031 2.363281 -6.910156 2.125 -6.828125 C 1.894531 -6.753906 1.675781 -6.644531 1.46875 -6.5 C 1.269531 -6.351562 1.109375 -6.171875 0.984375 -5.953125 C 0.867188 -5.742188 0.8125 -5.507812 0.8125 -5.25 C 0.8125 -5.039062 0.847656 -4.847656 0.921875 -4.671875 C 0.992188 -4.503906 1.09375 -4.347656 1.21875 -4.203125 C 1.351562 -4.066406 1.503906 -3.945312 1.671875 -3.84375 C 1.847656 -3.738281 2.035156 -3.648438 2.234375 -3.578125 C 2.035156 -3.472656 1.84375 -3.351562 1.65625 -3.21875 C 1.46875 -3.09375 1.296875 -2.945312 1.140625 -2.78125 C 0.992188 -2.625 0.878906 -2.441406 0.796875 -2.234375 C 0.710938 -2.023438 0.671875 -1.800781 0.671875 -1.5625 C 0.671875 -1.289062 0.734375 -1.046875 0.859375 -0.828125 C 0.984375 -0.617188 1.148438 -0.445312 1.359375 -0.3125 C 1.566406 -0.175781 1.789062 -0.0703125 2.03125 0 C 2.28125 0.0703125 2.523438 0.109375 2.765625 0.109375 Z M 1.28125 -5.328125 C 1.28125 -5.492188 1.316406 -5.648438 1.390625 -5.796875 C 1.460938 -5.941406 1.566406 -6.070312 1.703125 -6.1875 C 1.835938 -6.300781 1.992188 -6.390625 2.171875 -6.453125 C 2.347656 -6.515625 2.546875 -6.550781 2.765625 -6.5625 C 2.992188 -6.550781 3.203125 -6.515625 3.390625 -6.453125 C 3.585938 -6.390625 3.753906 -6.300781 3.890625 -6.1875 C 4.023438 -6.070312 4.128906 -5.9375 4.203125 -5.78125 C 4.285156 -5.625 4.328125 -5.457031 4.328125 -5.28125 C 4.328125 -5.082031 4.285156 -4.898438 4.203125 -4.734375 C 4.117188 -4.578125 4.007812 -4.4375 3.875 -4.3125 C 3.738281 -4.1875 3.578125 -4.078125 3.390625 -3.984375 C 3.210938 -3.890625 3.03125 -3.8125 2.84375 -3.75 C 2.613281 -3.8125 2.398438 -3.890625 2.203125 -3.984375 C 2.015625 -4.078125 1.851562 -4.1875 1.71875 -4.3125 C 1.582031 -4.4375 1.472656 -4.582031 1.390625 -4.75 C 1.316406 -4.925781 1.28125 -5.117188 1.28125 -5.328125 Z M 4.46875 -1.5625 C 4.46875 -1.375 4.421875 -1.203125 4.328125 -1.046875 C 4.242188 -0.898438 4.128906 -0.769531 3.984375 -0.65625 C 3.835938 -0.539062 3.664062 -0.453125 3.46875 -0.390625 C 3.269531 -0.328125 3.0625 -0.296875 2.84375 -0.296875 C 2.59375 -0.296875 2.363281 -0.328125 2.15625 -0.390625 C 1.945312 -0.453125 1.765625 -0.539062 1.609375 -0.65625 C 1.460938 -0.769531 1.347656 -0.910156 1.265625 -1.078125 C 1.179688 -1.242188 1.140625 -1.4375 1.140625 -1.65625 C 1.140625 -1.851562 1.1875 -2.039062 1.28125 -2.21875 C 1.375 -2.40625 1.5 -2.570312 1.65625 -2.71875 C 1.8125 -2.875 1.984375 -3.007812 2.171875 -3.125 C 2.367188 -3.238281 2.570312 -3.332031 2.78125 -3.40625 C 2.988281 -3.332031 3.191406 -3.238281 3.390625 -3.125 C 3.597656 -3.007812 3.78125 -2.875 3.9375 -2.71875 C 4.09375 -2.570312 4.21875 -2.398438 4.3125 -2.203125 C 4.414062 -2.003906 4.46875 -1.789062 4.46875 -1.5625 Z M 4.46875 -1.5625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-12"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.453125 0 L 5.9375 0 L 5.9375 -6.859375 L 5.453125 -6.859375 L 5.453125 -3.640625 L 1.453125 -3.640625 L 1.453125 -6.859375 L 0.984375 -6.859375 L 0.984375 0 L 1.453125 0 L 1.453125 -3.265625 L 5.453125 -3.265625 Z M 5.453125 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-13"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.484375 -0.265625 C 0.640625 -0.171875 0.851562 -0.0859375 1.125 -0.015625 C 1.394531 0.0546875 1.707031 0.0976562 2.0625 0.109375 C 2.332031 0.109375 2.578125 0.0703125 2.796875 0 C 3.015625 -0.0625 3.195312 -0.148438 3.34375 -0.265625 C 3.5 -0.390625 3.617188 -0.535156 3.703125 -0.703125 C 3.785156 -0.867188 3.828125 -1.054688 3.828125 -1.265625 C 3.828125 -1.617188 3.71875 -1.910156 3.5 -2.140625 C 3.28125 -2.367188 2.972656 -2.566406 2.578125 -2.734375 L 2.09375 -2.921875 C 1.863281 -3.003906 1.675781 -3.085938 1.53125 -3.171875 C 1.394531 -3.265625 1.289062 -3.351562 1.21875 -3.4375 C 1.144531 -3.519531 1.09375 -3.609375 1.0625 -3.703125 C 1.039062 -3.804688 1.035156 -3.914062 1.046875 -4.03125 C 1.046875 -4.3125 1.117188 -4.515625 1.265625 -4.640625 C 1.410156 -4.773438 1.550781 -4.863281 1.6875 -4.90625 C 1.832031 -4.957031 2 -4.984375 2.1875 -4.984375 C 2.332031 -4.984375 2.472656 -4.972656 2.609375 -4.953125 C 2.753906 -4.929688 2.910156 -4.894531 3.078125 -4.84375 C 3.242188 -4.800781 3.367188 -4.757812 3.453125 -4.71875 L 3.59375 -5.078125 C 3.550781 -5.097656 3.484375 -5.125 3.390625 -5.15625 C 3.304688 -5.1875 3.207031 -5.21875 3.09375 -5.25 C 2.976562 -5.289062 2.847656 -5.320312 2.703125 -5.34375 C 2.554688 -5.363281 2.398438 -5.378906 2.234375 -5.390625 C 1.992188 -5.378906 1.773438 -5.335938 1.578125 -5.265625 C 1.378906 -5.203125 1.203125 -5.109375 1.046875 -4.984375 C 0.890625 -4.867188 0.769531 -4.726562 0.6875 -4.5625 C 0.601562 -4.394531 0.5625 -4.207031 0.5625 -4 C 0.5625 -3.675781 0.648438 -3.40625 0.828125 -3.1875 C 1.015625 -2.96875 1.289062 -2.785156 1.65625 -2.640625 L 2.140625 -2.453125 C 2.359375 -2.359375 2.539062 -2.265625 2.6875 -2.171875 C 2.84375 -2.085938 2.96875 -2 3.0625 -1.90625 C 3.164062 -1.8125 3.238281 -1.707031 3.28125 -1.59375 C 3.332031 -1.488281 3.359375 -1.367188 3.359375 -1.234375 C 3.359375 -1.078125 3.328125 -0.941406 3.265625 -0.828125 C 3.203125 -0.710938 3.085938 -0.59375 2.921875 -0.46875 C 2.753906 -0.351562 2.488281 -0.296875 2.125 -0.296875 C 1.78125 -0.296875 1.476562 -0.328125 1.21875 -0.390625 C 0.96875 -0.460938 0.773438 -0.539062 0.640625 -0.625 Z M 0.484375 -0.265625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-14"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.828125 0 L 4.828125 -5.28125 L 4.359375 -5.28125 L 4.359375 -1.171875 C 4.234375 -1.066406 4.097656 -0.960938 3.953125 -0.859375 C 3.816406 -0.765625 3.671875 -0.675781 3.515625 -0.59375 C 3.359375 -0.519531 3.195312 -0.457031 3.03125 -0.40625 C 2.875 -0.363281 2.71875 -0.34375 2.5625 -0.34375 C 2.132812 -0.34375 1.820312 -0.46875 1.625 -0.71875 C 1.425781 -0.976562 1.328125 -1.367188 1.328125 -1.890625 L 1.328125 -5.28125 L 0.875 -5.28125 L 0.875 -1.8125 C 0.875 -1.507812 0.898438 -1.238281 0.953125 -1 C 1.015625 -0.769531 1.109375 -0.570312 1.234375 -0.40625 C 1.367188 -0.238281 1.535156 -0.109375 1.734375 -0.015625 C 1.929688 0.0664062 2.164062 0.109375 2.4375 0.109375 C 2.625 0.109375 2.804688 0.0820312 2.984375 0.03125 C 3.171875 -0.0195312 3.347656 -0.0859375 3.515625 -0.171875 C 3.691406 -0.265625 3.851562 -0.363281 4 -0.46875 C 4.144531 -0.570312 4.285156 -0.679688 4.421875 -0.796875 L 4.5 0 Z M 4.828125 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-15"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.578125 -2.59375 C 4.597656 -2.675781 4.628906 -2.800781 4.671875 -2.96875 C 4.710938 -3.132812 4.734375 -3.304688 4.734375 -3.484375 C 4.734375 -4.085938 4.578125 -4.550781 4.265625 -4.875 C 3.953125 -5.207031 3.503906 -5.378906 2.921875 -5.390625 C 2.566406 -5.378906 2.242188 -5.304688 1.953125 -5.171875 C 1.660156 -5.046875 1.410156 -4.859375 1.203125 -4.609375 C 0.992188 -4.367188 0.832031 -4.078125 0.71875 -3.734375 C 0.613281 -3.390625 0.5625 -3.007812 0.5625 -2.59375 C 0.5625 -2.1875 0.617188 -1.816406 0.734375 -1.484375 C 0.859375 -1.160156 1.03125 -0.878906 1.25 -0.640625 C 1.46875 -0.398438 1.726562 -0.210938 2.03125 -0.078125 C 2.332031 0.046875 2.671875 0.109375 3.046875 0.109375 C 3.148438 0.109375 3.265625 0.101562 3.390625 0.09375 C 3.515625 0.0820312 3.640625 0.0625 3.765625 0.03125 C 3.898438 0.0078125 4.023438 -0.015625 4.140625 -0.046875 C 4.265625 -0.078125 4.375 -0.113281 4.46875 -0.15625 L 4.34375 -0.5 C 4.25 -0.46875 4.148438 -0.4375 4.046875 -0.40625 C 3.941406 -0.382812 3.832031 -0.363281 3.71875 -0.34375 C 3.613281 -0.320312 3.507812 -0.304688 3.40625 -0.296875 C 3.300781 -0.296875 3.203125 -0.296875 3.109375 -0.296875 C 2.765625 -0.296875 2.46875 -0.347656 2.21875 -0.453125 C 1.96875 -0.554688 1.753906 -0.707031 1.578125 -0.90625 C 1.410156 -1.101562 1.28125 -1.34375 1.1875 -1.625 C 1.101562 -1.914062 1.0625 -2.238281 1.0625 -2.59375 Z M 2.859375 -4.984375 C 3.304688 -4.984375 3.648438 -4.859375 3.890625 -4.609375 C 4.128906 -4.367188 4.253906 -4.003906 4.265625 -3.515625 C 4.265625 -3.265625 4.242188 -3.070312 4.203125 -2.9375 L 1.0625 -2.9375 C 1.070312 -3.238281 1.117188 -3.507812 1.203125 -3.75 C 1.285156 -4 1.40625 -4.210938 1.5625 -4.390625 C 1.726562 -4.578125 1.914062 -4.722656 2.125 -4.828125 C 2.332031 -4.929688 2.578125 -4.984375 2.859375 -4.984375 Z M 2.859375 -4.984375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-16"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.640625 -5.90625 C 1.628906 -6.34375 1.722656 -6.671875 1.921875 -6.890625 C 2.117188 -7.117188 2.429688 -7.234375 2.859375 -7.234375 C 3.015625 -7.234375 3.148438 -7.21875 3.265625 -7.1875 C 3.378906 -7.164062 3.472656 -7.148438 3.546875 -7.140625 L 3.640625 -7.5 C 3.554688 -7.53125 3.445312 -7.554688 3.3125 -7.578125 C 3.175781 -7.609375 3.03125 -7.628906 2.875 -7.640625 C 2.601562 -7.628906 2.363281 -7.582031 2.15625 -7.5 C 1.945312 -7.414062 1.769531 -7.300781 1.625 -7.15625 C 1.476562 -7.007812 1.367188 -6.832031 1.296875 -6.625 C 1.222656 -6.425781 1.1875 -6.207031 1.1875 -5.96875 L 1.1875 -5.25 L 0.234375 -5.203125 L 0.234375 -4.90625 L 1.1875 -4.90625 L 1.1875 0 L 1.640625 0 L 1.640625 -4.90625 L 3 -4.90625 L 3 -5.28125 L 1.640625 -5.28125 Z M 1.640625 -5.90625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-17"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.984375 -7.53125 L 0.984375 0 L 1.4375 0 L 1.4375 -7.640625 Z M 0.984375 -7.53125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-18"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.546875 -5.28125 L 2.765625 -0.421875 L 0.671875 -5.28125 L 0.1875 -5.28125 L 2.53125 0.078125 C 2.414062 0.367188 2.300781 0.617188 2.1875 0.828125 C 2.070312 1.046875 1.945312 1.222656 1.8125 1.359375 C 1.6875 1.492188 1.546875 1.59375 1.390625 1.65625 C 1.242188 1.71875 1.066406 1.75 0.859375 1.75 C 0.753906 1.75 0.65625 1.738281 0.5625 1.71875 C 0.476562 1.695312 0.40625 1.675781 0.34375 1.65625 L 0.21875 2.03125 C 0.289062 2.0625 0.378906 2.085938 0.484375 2.109375 C 0.597656 2.128906 0.722656 2.140625 0.859375 2.140625 C 1.117188 2.148438 1.347656 2.113281 1.546875 2.03125 C 1.742188 1.957031 1.925781 1.832031 2.09375 1.65625 C 2.257812 1.476562 2.421875 1.242188 2.578125 0.953125 C 2.734375 0.660156 2.894531 0.300781 3.0625 -0.125 L 5.03125 -5.28125 Z M 4.546875 -5.28125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-19"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.890625 0.109375 C 3.242188 0.109375 3.566406 0.0390625 3.859375 -0.09375 C 4.148438 -0.226562 4.398438 -0.414062 4.609375 -0.65625 C 4.828125 -0.894531 4.992188 -1.1875 5.109375 -1.53125 C 5.222656 -1.875 5.28125 -2.257812 5.28125 -2.6875 C 5.28125 -3.09375 5.222656 -3.457031 5.109375 -3.78125 C 4.992188 -4.113281 4.832031 -4.398438 4.625 -4.640625 C 4.425781 -4.878906 4.179688 -5.0625 3.890625 -5.1875 C 3.609375 -5.3125 3.296875 -5.378906 2.953125 -5.390625 C 2.585938 -5.378906 2.257812 -5.304688 1.96875 -5.171875 C 1.675781 -5.046875 1.425781 -4.859375 1.21875 -4.609375 C 1.007812 -4.367188 0.847656 -4.078125 0.734375 -3.734375 C 0.617188 -3.390625 0.5625 -3.007812 0.5625 -2.59375 C 0.5625 -2.1875 0.613281 -1.816406 0.71875 -1.484375 C 0.832031 -1.160156 0.988281 -0.878906 1.1875 -0.640625 C 1.394531 -0.398438 1.640625 -0.210938 1.921875 -0.078125 C 2.210938 0.046875 2.535156 0.109375 2.890625 0.109375 Z M 2.953125 -0.296875 C 2.660156 -0.296875 2.394531 -0.347656 2.15625 -0.453125 C 1.925781 -0.566406 1.726562 -0.726562 1.5625 -0.9375 C 1.394531 -1.144531 1.269531 -1.394531 1.1875 -1.6875 C 1.101562 -1.976562 1.0625 -2.3125 1.0625 -2.6875 C 1.0625 -3.039062 1.101562 -3.351562 1.1875 -3.625 C 1.269531 -3.90625 1.390625 -4.144531 1.546875 -4.34375 C 1.710938 -4.550781 1.90625 -4.707031 2.125 -4.8125 C 2.351562 -4.925781 2.609375 -4.984375 2.890625 -4.984375 C 3.179688 -4.984375 3.441406 -4.925781 3.671875 -4.8125 C 3.898438 -4.707031 4.097656 -4.550781 4.265625 -4.34375 C 4.429688 -4.132812 4.554688 -3.878906 4.640625 -3.578125 C 4.734375 -3.285156 4.78125 -2.957031 4.78125 -2.59375 C 4.78125 -2.238281 4.734375 -1.921875 4.640625 -1.640625 C 4.554688 -1.359375 4.4375 -1.113281 4.28125 -0.90625 C 4.125 -0.707031 3.929688 -0.554688 3.703125 -0.453125 C 3.472656 -0.347656 3.222656 -0.296875 2.953125 -0.296875 Z M 2.953125 -0.296875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-20"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.984375 -5.28125 L 0.984375 0 L 1.4375 0 L 1.4375 -4.109375 C 1.550781 -4.210938 1.675781 -4.3125 1.8125 -4.40625 C 1.957031 -4.5 2.109375 -4.585938 2.265625 -4.671875 C 2.421875 -4.753906 2.578125 -4.816406 2.734375 -4.859375 C 2.898438 -4.910156 3.0625 -4.941406 3.21875 -4.953125 C 3.632812 -4.941406 3.9375 -4.804688 4.125 -4.546875 C 4.320312 -4.296875 4.421875 -3.910156 4.421875 -3.390625 L 4.421875 0 L 4.875 0 L 4.875 -4.109375 C 4.988281 -4.210938 5.113281 -4.3125 5.25 -4.40625 C 5.394531 -4.5 5.546875 -4.585938 5.703125 -4.671875 C 5.859375 -4.753906 6.015625 -4.816406 6.171875 -4.859375 C 6.328125 -4.910156 6.488281 -4.941406 6.65625 -4.953125 C 7.0625 -4.941406 7.359375 -4.804688 7.546875 -4.546875 C 7.742188 -4.296875 7.84375 -3.910156 7.84375 -3.390625 L 7.84375 0 L 8.3125 0 L 8.3125 -3.46875 C 8.3125 -3.757812 8.28125 -4.019531 8.21875 -4.25 C 8.15625 -4.488281 8.054688 -4.691406 7.921875 -4.859375 C 7.796875 -5.023438 7.632812 -5.15625 7.4375 -5.25 C 7.25 -5.34375 7.023438 -5.390625 6.765625 -5.390625 C 6.421875 -5.378906 6.078125 -5.285156 5.734375 -5.109375 C 5.390625 -4.929688 5.054688 -4.695312 4.734375 -4.40625 C 4.628906 -4.71875 4.457031 -4.957031 4.21875 -5.125 C 3.988281 -5.289062 3.695312 -5.378906 3.34375 -5.390625 C 3.144531 -5.378906 2.953125 -5.347656 2.765625 -5.296875 C 2.585938 -5.242188 2.414062 -5.171875 2.25 -5.078125 C 2.082031 -4.992188 1.925781 -4.898438 1.78125 -4.796875 C 1.632812 -4.691406 1.503906 -4.585938 1.390625 -4.484375 L 1.3125 -5.28125 Z M 0.984375 -5.28125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-21"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.984375 -5.28125 L 0.984375 2.046875 L 1.4375 2.046875 L 1.4375 -0.328125 C 1.550781 -0.253906 1.671875 -0.191406 1.796875 -0.140625 C 1.921875 -0.0859375 2.078125 -0.0351562 2.265625 0.015625 C 2.453125 0.078125 2.65625 0.109375 2.875 0.109375 C 3.226562 0.109375 3.5625 0.046875 3.875 -0.078125 C 4.1875 -0.210938 4.457031 -0.398438 4.6875 -0.640625 C 4.925781 -0.890625 5.113281 -1.1875 5.25 -1.53125 C 5.382812 -1.875 5.453125 -2.257812 5.453125 -2.6875 C 5.453125 -3.082031 5.398438 -3.441406 5.296875 -3.765625 C 5.191406 -4.097656 5.039062 -4.382812 4.84375 -4.625 C 4.644531 -4.863281 4.398438 -5.046875 4.109375 -5.171875 C 3.828125 -5.304688 3.507812 -5.378906 3.15625 -5.390625 C 3 -5.390625 2.835938 -5.367188 2.671875 -5.328125 C 2.515625 -5.285156 2.359375 -5.222656 2.203125 -5.140625 C 2.046875 -5.066406 1.894531 -4.972656 1.75 -4.859375 C 1.613281 -4.753906 1.492188 -4.632812 1.390625 -4.5 L 1.3125 -5.28125 Z M 1.4375 -4.109375 C 1.507812 -4.203125 1.597656 -4.300781 1.703125 -4.40625 C 1.816406 -4.507812 1.945312 -4.601562 2.09375 -4.6875 C 2.238281 -4.78125 2.394531 -4.851562 2.5625 -4.90625 C 2.726562 -4.957031 2.894531 -4.984375 3.0625 -4.984375 C 3.375 -4.984375 3.644531 -4.925781 3.875 -4.8125 C 4.113281 -4.707031 4.3125 -4.550781 4.46875 -4.34375 C 4.632812 -4.132812 4.757812 -3.882812 4.84375 -3.59375 C 4.925781 -3.300781 4.96875 -2.96875 4.96875 -2.59375 C 4.957031 -2.238281 4.898438 -1.921875 4.796875 -1.640625 C 4.703125 -1.359375 4.5625 -1.113281 4.375 -0.90625 C 4.195312 -0.707031 3.988281 -0.554688 3.75 -0.453125 C 3.507812 -0.347656 3.242188 -0.296875 2.953125 -0.296875 C 2.660156 -0.296875 2.390625 -0.332031 2.140625 -0.40625 C 1.898438 -0.476562 1.664062 -0.585938 1.4375 -0.734375 Z M 1.4375 -4.109375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-22"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.640625 -6.546875 L 1.21875 -6.453125 L 1.1875 -5.25 L 0.234375 -5.203125 L 0.234375 -4.90625 L 1.1875 -4.90625 L 1.1875 -1.28125 C 1.1875 -0.8125 1.3125 -0.460938 1.5625 -0.234375 C 1.8125 -0.00390625 2.171875 0.109375 2.640625 0.109375 C 2.796875 0.109375 2.945312 0.09375 3.09375 0.0625 C 3.25 0.0390625 3.375 0.0078125 3.46875 -0.03125 L 3.390625 -0.375 C 3.304688 -0.351562 3.203125 -0.332031 3.078125 -0.3125 C 2.953125 -0.300781 2.828125 -0.296875 2.703125 -0.296875 C 2.335938 -0.285156 2.066406 -0.363281 1.890625 -0.53125 C 1.722656 -0.707031 1.644531 -1 1.65625 -1.40625 L 1.65625 -4.90625 L 3.28125 -4.90625 L 3.28125 -5.28125 L 1.640625 -5.28125 Z M 1.640625 -6.546875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-23"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.046875 0 L 5.046875 -7.640625 L 4.578125 -7.53125 L 4.578125 -4.953125 C 4.335938 -5.085938 4.125 -5.179688 3.9375 -5.234375 C 3.75 -5.285156 3.59375 -5.320312 3.46875 -5.34375 C 3.351562 -5.375 3.25 -5.390625 3.15625 -5.390625 C 2.78125 -5.378906 2.4375 -5.304688 2.125 -5.171875 C 1.820312 -5.046875 1.550781 -4.859375 1.3125 -4.609375 C 1.070312 -4.367188 0.882812 -4.078125 0.75 -3.734375 C 0.625 -3.398438 0.5625 -3.019531 0.5625 -2.59375 C 0.5625 -2.1875 0.613281 -1.816406 0.71875 -1.484375 C 0.820312 -1.160156 0.972656 -0.878906 1.171875 -0.640625 C 1.367188 -0.398438 1.609375 -0.210938 1.890625 -0.078125 C 2.179688 0.046875 2.507812 0.109375 2.875 0.109375 C 3.019531 0.109375 3.171875 0.0859375 3.328125 0.046875 C 3.492188 0.00390625 3.65625 -0.0507812 3.8125 -0.125 C 3.96875 -0.195312 4.113281 -0.285156 4.25 -0.390625 C 4.394531 -0.503906 4.519531 -0.632812 4.625 -0.78125 L 4.71875 0 Z M 4.578125 -1.171875 C 4.503906 -1.066406 4.410156 -0.960938 4.296875 -0.859375 C 4.179688 -0.753906 4.050781 -0.660156 3.90625 -0.578125 C 3.769531 -0.492188 3.617188 -0.425781 3.453125 -0.375 C 3.285156 -0.320312 3.117188 -0.296875 2.953125 -0.296875 C 2.328125 -0.296875 1.851562 -0.503906 1.53125 -0.921875 C 1.21875 -1.335938 1.0625 -1.925781 1.0625 -2.6875 C 1.0625 -3.03125 1.109375 -3.34375 1.203125 -3.625 C 1.296875 -3.90625 1.429688 -4.144531 1.609375 -4.34375 C 1.796875 -4.550781 2.007812 -4.707031 2.25 -4.8125 C 2.5 -4.925781 2.769531 -4.984375 3.0625 -4.984375 C 3.351562 -4.984375 3.625 -4.941406 3.875 -4.859375 C 4.125 -4.785156 4.359375 -4.679688 4.578125 -4.546875 Z M 4.578125 -1.171875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 6.140625 -13.5625 L 9.375 -10.34375 L 12.59375 -13.5625 L 13.875 -12.28125 L 10.65625 -9.0625 L 13.90625 -5.8125 L 12.609375 -4.515625 L 9.375 -7.734375 L 6.125 -4.515625 L 4.828125 -5.8125 L 8.078125 -9.0625 L 4.859375 -12.28125 Z M 2.578125 0 L 16.15625 0 L 16.15625 -18.09375 L 2.578125 -18.09375 Z M 2.578125 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.578125 0 L 3.828125 0 L 3.828125 -16.875 L 10.84375 -2.5625 L 11.90625 -2.5625 L 18.9375 -16.875 L 18.9375 0 L 20.171875 0 L 20.171875 -18.078125 L 18.296875 -18.078125 L 11.375 -4.015625 L 4.453125 -18.078125 L 2.578125 -18.078125 Z M 2.578125 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 10.890625 -9.359375 C 10.878906 -10.085938 10.773438 -10.75 10.578125 -11.34375 C 10.378906 -11.9375 10.082031 -12.441406 9.6875 -12.859375 C 9.289062 -13.285156 8.800781 -13.613281 8.21875 -13.84375 C 7.632812 -14.070312 6.960938 -14.1875 6.203125 -14.1875 C 5.722656 -14.1875 5.257812 -14.140625 4.8125 -14.046875 C 4.375 -13.953125 3.972656 -13.835938 3.609375 -13.703125 C 3.242188 -13.566406 2.925781 -13.425781 2.65625 -13.28125 C 2.382812 -13.144531 2.175781 -13.03125 2.03125 -12.9375 L 2.484375 -12.140625 C 2.816406 -12.347656 3.222656 -12.53125 3.703125 -12.6875 C 4.179688 -12.84375 4.597656 -12.957031 4.953125 -13.03125 C 5.316406 -13.101562 5.695312 -13.140625 6.09375 -13.140625 C 6.738281 -13.140625 7.285156 -13.046875 7.734375 -12.859375 C 8.191406 -12.671875 8.628906 -12.316406 9.046875 -11.796875 C 9.472656 -11.285156 9.679688 -10.410156 9.671875 -9.171875 L 9.671875 -7.359375 C 8.492188 -7.503906 7.367188 -7.523438 6.296875 -7.421875 C 5.566406 -7.347656 4.898438 -7.203125 4.296875 -6.984375 C 3.703125 -6.765625 3.179688 -6.484375 2.734375 -6.140625 C 2.296875 -5.804688 1.957031 -5.398438 1.71875 -4.921875 C 1.476562 -4.453125 1.359375 -3.921875 1.359375 -3.328125 C 1.359375 -2.785156 1.453125 -2.289062 1.640625 -1.84375 C 1.835938 -1.40625 2.113281 -1.023438 2.46875 -0.703125 C 2.832031 -0.390625 3.25 -0.148438 3.71875 0.015625 C 4.195312 0.179688 4.710938 0.265625 5.265625 0.265625 C 6.085938 0.265625 6.894531 0.0625 7.6875 -0.34375 C 8.476562 -0.757812 9.179688 -1.359375 9.796875 -2.140625 C 9.796875 -1.328125 9.972656 -0.722656 10.328125 -0.328125 C 10.691406 0.0664062 11.175781 0.265625 11.78125 0.265625 C 12.03125 0.265625 12.253906 0.234375 12.453125 0.171875 C 12.648438 0.117188 12.789062 0.0664062 12.875 0.015625 L 12.71875 -0.78125 C 12.65625 -0.738281 12.554688 -0.695312 12.421875 -0.65625 C 12.296875 -0.625 12.148438 -0.609375 11.984375 -0.609375 C 11.640625 -0.597656 11.367188 -0.710938 11.171875 -0.953125 C 10.984375 -1.191406 10.890625 -1.570312 10.890625 -2.09375 Z M 2.65625 -3.5 C 2.664062 -4.382812 2.984375 -5.070312 3.609375 -5.5625 C 4.242188 -6.0625 5.117188 -6.378906 6.234375 -6.515625 C 7.378906 -6.640625 8.523438 -6.632812 9.671875 -6.5 L 9.671875 -3.09375 C 9.140625 -2.394531 8.515625 -1.832031 7.796875 -1.40625 C 7.085938 -0.988281 6.347656 -0.78125 5.578125 -0.78125 C 4.617188 -0.78125 3.890625 -1.023438 3.390625 -1.515625 C 2.898438 -2.015625 2.65625 -2.675781 2.65625 -3.5 Z M 2.65625 -3.5 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.578125 -13.921875 L 2.578125 0 L 3.8125 0 L 3.8125 -10.828125 C 4.113281 -11.109375 4.453125 -11.375 4.828125 -11.625 C 5.210938 -11.875 5.613281 -12.101562 6.03125 -12.3125 C 6.457031 -12.519531 6.890625 -12.691406 7.328125 -12.828125 C 7.773438 -12.960938 8.210938 -13.03125 8.640625 -13.03125 C 9.765625 -13.03125 10.59375 -12.6875 11.125 -12 C 11.65625 -11.320312 11.921875 -10.304688 11.921875 -8.953125 L 11.921875 0 L 13.140625 0 L 13.140625 -9.15625 C 13.140625 -9.925781 13.050781 -10.617188 12.875 -11.234375 C 12.707031 -11.859375 12.453125 -12.382812 12.109375 -12.8125 C 11.765625 -13.25 11.328125 -13.585938 10.796875 -13.828125 C 10.265625 -14.066406 9.648438 -14.1875 8.953125 -14.1875 C 8.421875 -14.1875 7.910156 -14.113281 7.421875 -13.96875 C 6.929688 -13.832031 6.457031 -13.644531 6 -13.40625 C 5.550781 -13.175781 5.128906 -12.921875 4.734375 -12.640625 C 4.335938 -12.359375 3.984375 -12.082031 3.671875 -11.8125 L 3.453125 -13.921875 Z M 2.578125 -13.921875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 14.71875 -8.96875 L 9.671875 -8.96875 L 9.671875 -8 L 13.46875 -8 L 13.46875 -1.5 C 13.144531 -1.332031 12.6875 -1.175781 12.09375 -1.03125 C 11.5 -0.882812 10.832031 -0.804688 10.09375 -0.796875 C 8.90625 -0.796875 7.859375 -0.988281 6.953125 -1.375 C 6.054688 -1.757812 5.300781 -2.320312 4.6875 -3.0625 C 4.082031 -3.800781 3.625 -4.6875 3.3125 -5.71875 C 3 -6.757812 2.847656 -7.9375 2.859375 -9.25 C 2.859375 -10.53125 3.03125 -11.664062 3.375 -12.65625 C 3.726562 -13.65625 4.222656 -14.492188 4.859375 -15.171875 C 5.503906 -15.859375 6.28125 -16.378906 7.1875 -16.734375 C 8.09375 -17.085938 9.109375 -17.269531 10.234375 -17.28125 C 10.984375 -17.257812 11.671875 -17.171875 12.296875 -17.015625 C 12.921875 -16.867188 13.410156 -16.734375 13.765625 -16.609375 L 14.15625 -17.53125 C 13.976562 -17.601562 13.753906 -17.6875 13.484375 -17.78125 C 13.222656 -17.875 12.921875 -17.960938 12.578125 -18.046875 C 12.242188 -18.128906 11.882812 -18.195312 11.5 -18.25 C 11.113281 -18.3125 10.722656 -18.347656 10.328125 -18.359375 C 8.910156 -18.347656 7.648438 -18.109375 6.546875 -17.640625 C 5.441406 -17.171875 4.515625 -16.515625 3.765625 -15.671875 C 3.023438 -14.835938 2.460938 -13.851562 2.078125 -12.71875 C 1.691406 -11.582031 1.5 -10.34375 1.5 -9 C 1.5 -7.632812 1.679688 -6.378906 2.046875 -5.234375 C 2.410156 -4.097656 2.953125 -3.117188 3.671875 -2.296875 C 4.398438 -1.484375 5.285156 -0.851562 6.328125 -0.40625 C 7.367188 0.0390625 8.554688 0.265625 9.890625 0.265625 C 10.367188 0.265625 10.84375 0.234375 11.3125 0.171875 C 11.78125 0.117188 12.332031 0.0078125 12.96875 -0.15625 C 13.613281 -0.332031 14.195312 -0.597656 14.71875 -0.953125 Z M 14.71875 -8.96875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 13.296875 0 L 13.296875 -20.125 L 12.078125 -19.84375 L 12.078125 -13.0625 C 11.441406 -13.414062 10.875 -13.660156 10.375 -13.796875 C 9.875 -13.941406 9.46875 -14.039062 9.15625 -14.09375 C 8.851562 -14.15625 8.578125 -14.1875 8.328125 -14.1875 C 7.347656 -14.1875 6.445312 -14.007812 5.625 -13.65625 C 4.800781 -13.3125 4.078125 -12.816406 3.453125 -12.171875 C 2.835938 -11.523438 2.359375 -10.753906 2.015625 -9.859375 C 1.671875 -8.960938 1.5 -7.957031 1.5 -6.84375 C 1.5 -5.78125 1.628906 -4.8125 1.890625 -3.9375 C 2.160156 -3.070312 2.554688 -2.320312 3.078125 -1.6875 C 3.597656 -1.0625 4.234375 -0.578125 4.984375 -0.234375 C 5.742188 0.0976562 6.601562 0.265625 7.5625 0.265625 C 7.945312 0.265625 8.351562 0.210938 8.78125 0.109375 C 9.21875 0.015625 9.640625 -0.128906 10.046875 -0.328125 C 10.460938 -0.523438 10.851562 -0.765625 11.21875 -1.046875 C 11.59375 -1.335938 11.921875 -1.671875 12.203125 -2.046875 L 12.421875 0 Z M 12.078125 -3.09375 C 11.878906 -2.8125 11.628906 -2.53125 11.328125 -2.25 C 11.023438 -1.976562 10.6875 -1.734375 10.3125 -1.515625 C 9.945312 -1.296875 9.546875 -1.117188 9.109375 -0.984375 C 8.671875 -0.847656 8.234375 -0.78125 7.796875 -0.78125 C 6.140625 -0.78125 4.890625 -1.332031 4.046875 -2.4375 C 3.210938 -3.539062 2.796875 -5.085938 2.796875 -7.078125 C 2.796875 -7.984375 2.921875 -8.804688 3.171875 -9.546875 C 3.429688 -10.285156 3.796875 -10.921875 4.265625 -11.453125 C 4.742188 -11.992188 5.304688 -12.410156 5.953125 -12.703125 C 6.609375 -12.992188 7.320312 -13.140625 8.09375 -13.140625 C 8.84375 -13.140625 9.546875 -13.035156 10.203125 -12.828125 C 10.859375 -12.628906 11.484375 -12.351562 12.078125 -12 Z M 12.078125 -3.09375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.578125 -19.84375 L 2.578125 0 L 3.8125 0 L 3.8125 -10.828125 C 4.113281 -11.109375 4.453125 -11.375 4.828125 -11.625 C 5.210938 -11.875 5.613281 -12.101562 6.03125 -12.3125 C 6.457031 -12.519531 6.890625 -12.691406 7.328125 -12.828125 C 7.773438 -12.960938 8.210938 -13.03125 8.640625 -13.03125 C 9.765625 -13.03125 10.59375 -12.6875 11.125 -12 C 11.65625 -11.320312 11.921875 -10.304688 11.921875 -8.953125 L 11.921875 0 L 13.140625 0 L 13.140625 -9.15625 C 13.140625 -9.925781 13.050781 -10.617188 12.875 -11.234375 C 12.707031 -11.859375 12.453125 -12.382812 12.109375 -12.8125 C 11.765625 -13.25 11.328125 -13.585938 10.796875 -13.828125 C 10.265625 -14.066406 9.648438 -14.1875 8.953125 -14.1875 C 8.441406 -14.1875 7.945312 -14.117188 7.46875 -13.984375 C 6.988281 -13.847656 6.53125 -13.671875 6.09375 -13.453125 C 5.664062 -13.234375 5.257812 -12.992188 4.875 -12.734375 C 4.488281 -12.472656 4.132812 -12.207031 3.8125 -11.9375 L 3.8125 -20.125 Z M 2.578125 -19.84375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.578125 -13.921875 L 2.578125 0 L 3.8125 0 L 3.8125 -13.921875 Z M 2.234375 -18.296875 C 2.234375 -18.023438 2.316406 -17.800781 2.484375 -17.625 C 2.660156 -17.445312 2.875 -17.351562 3.125 -17.34375 C 3.40625 -17.34375 3.644531 -17.441406 3.84375 -17.640625 C 4.039062 -17.835938 4.140625 -18.097656 4.140625 -18.421875 C 4.140625 -18.679688 4.050781 -18.898438 3.875 -19.078125 C 3.695312 -19.253906 3.488281 -19.347656 3.25 -19.359375 C 2.945312 -19.347656 2.703125 -19.242188 2.515625 -19.046875 C 2.328125 -18.847656 2.234375 -18.597656 2.234375 -18.296875 Z M 2.234375 -18.296875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.65625 -10.296875 L 7.125 -7.84375 L 9.546875 -10.296875 L 10.53125 -9.3125 L 8.09375 -6.875 L 10.546875 -4.40625 L 9.578125 -3.421875 L 7.125 -5.875 L 4.640625 -3.421875 L 3.65625 -4.40625 L 6.125 -6.875 L 3.6875 -9.3125 Z M 1.953125 0 L 12.25 0 L 12.25 -13.734375 L 1.953125 -13.734375 Z M 1.953125 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.90625 0 L 2.90625 -5.6875 L 5.59375 -5.6875 C 6.269531 -5.6875 6.882812 -5.769531 7.4375 -5.9375 C 7.988281 -6.113281 8.46875 -6.375 8.875 -6.71875 C 9.28125 -7.070312 9.597656 -7.5 9.828125 -8 C 10.054688 -8.507812 10.175781 -9.085938 10.1875 -9.734375 C 10.175781 -10.335938 10.066406 -10.882812 9.859375 -11.375 C 9.648438 -11.863281 9.347656 -12.28125 8.953125 -12.625 C 8.554688 -12.976562 8.082031 -13.242188 7.53125 -13.421875 C 6.988281 -13.609375 6.382812 -13.707031 5.71875 -13.71875 L 1.953125 -13.71875 L 1.953125 0 Z M 5.59375 -12.96875 C 6.789062 -12.96875 7.679688 -12.671875 8.265625 -12.078125 C 8.859375 -11.492188 9.15625 -10.648438 9.15625 -9.546875 C 9.15625 -9.035156 9.070312 -8.585938 8.90625 -8.203125 C 8.75 -7.828125 8.445312 -7.4375 8 -7.03125 C 7.550781 -6.625 6.789062 -6.421875 5.71875 -6.421875 L 2.90625 -6.421875 L 2.90625 -12.96875 Z M 5.59375 -12.96875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 9.109375 -10.5625 L 5.515625 -0.828125 L 1.328125 -10.5625 L 0.359375 -10.5625 L 5.046875 0.171875 C 4.828125 0.742188 4.601562 1.238281 4.375 1.65625 C 4.144531 2.082031 3.898438 2.429688 3.640625 2.703125 C 3.390625 2.972656 3.109375 3.171875 2.796875 3.296875 C 2.484375 3.429688 2.128906 3.5 1.734375 3.5 C 1.515625 3.5 1.316406 3.476562 1.140625 3.4375 C 0.960938 3.40625 0.8125 3.363281 0.6875 3.3125 L 0.4375 4.046875 C 0.582031 4.117188 0.757812 4.175781 0.96875 4.21875 C 1.1875 4.269531 1.441406 4.296875 1.734375 4.296875 C 2.242188 4.296875 2.695312 4.21875 3.09375 4.0625 C 3.488281 3.914062 3.851562 3.664062 4.1875 3.3125 C 4.519531 2.96875 4.84375 2.503906 5.15625 1.921875 C 5.46875 1.335938 5.785156 0.613281 6.109375 -0.25 L 10.078125 -10.5625 Z M 9.109375 -10.5625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.28125 -13.09375 L 2.4375 -12.90625 L 2.375 -10.515625 L 0.46875 -10.40625 L 0.46875 -9.8125 L 2.375 -9.8125 L 2.375 -2.5625 C 2.375 -1.613281 2.625 -0.910156 3.125 -0.453125 C 3.625 -0.00390625 4.347656 0.210938 5.296875 0.203125 C 5.585938 0.203125 5.882812 0.175781 6.1875 0.125 C 6.488281 0.0820312 6.742188 0.0195312 6.953125 -0.0625 L 6.78125 -0.765625 C 6.613281 -0.710938 6.40625 -0.671875 6.15625 -0.640625 C 5.90625 -0.609375 5.660156 -0.59375 5.421875 -0.59375 C 4.671875 -0.570312 4.128906 -0.734375 3.796875 -1.078125 C 3.460938 -1.421875 3.296875 -2 3.296875 -2.8125 L 3.296875 -9.8125 L 6.5625 -9.8125 L 6.5625 -10.5625 L 3.28125 -10.5625 Z M 3.28125 -13.09375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.953125 -15.0625 L 1.953125 0 L 2.890625 0 L 2.890625 -8.21875 C 3.117188 -8.425781 3.378906 -8.625 3.671875 -8.8125 C 3.960938 -9.007812 4.265625 -9.1875 4.578125 -9.34375 C 4.898438 -9.5 5.226562 -9.625 5.5625 -9.71875 C 5.894531 -9.820312 6.222656 -9.878906 6.546875 -9.890625 C 7.410156 -9.878906 8.039062 -9.613281 8.4375 -9.09375 C 8.84375 -8.582031 9.046875 -7.8125 9.046875 -6.78125 L 9.046875 0 L 9.96875 0 L 9.96875 -6.953125 C 9.96875 -7.523438 9.898438 -8.046875 9.765625 -8.515625 C 9.640625 -8.992188 9.445312 -9.394531 9.1875 -9.71875 C 8.925781 -10.050781 8.59375 -10.304688 8.1875 -10.484375 C 7.789062 -10.671875 7.320312 -10.765625 6.78125 -10.765625 C 6.394531 -10.765625 6.019531 -10.710938 5.65625 -10.609375 C 5.300781 -10.503906 4.957031 -10.367188 4.625 -10.203125 C 4.300781 -10.035156 3.992188 -9.851562 3.703125 -9.65625 C 3.410156 -9.457031 3.140625 -9.257812 2.890625 -9.0625 L 2.890625 -15.265625 Z M 1.953125 -15.0625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.78125 0.203125 C 6.488281 0.203125 7.132812 0.0703125 7.71875 -0.1875 C 8.3125 -0.457031 8.816406 -0.832031 9.234375 -1.3125 C 9.648438 -1.800781 9.972656 -2.382812 10.203125 -3.0625 C 10.429688 -3.75 10.550781 -4.519531 10.5625 -5.375 C 10.550781 -6.175781 10.429688 -6.90625 10.203125 -7.5625 C 9.984375 -8.21875 9.664062 -8.785156 9.25 -9.265625 C 8.84375 -9.742188 8.351562 -10.113281 7.78125 -10.375 C 7.21875 -10.632812 6.59375 -10.765625 5.90625 -10.765625 C 5.175781 -10.765625 4.519531 -10.628906 3.9375 -10.359375 C 3.351562 -10.085938 2.851562 -9.707031 2.4375 -9.21875 C 2.019531 -8.726562 1.695312 -8.140625 1.46875 -7.453125 C 1.25 -6.773438 1.140625 -6.019531 1.140625 -5.1875 C 1.140625 -4.375 1.242188 -3.632812 1.453125 -2.96875 C 1.671875 -2.3125 1.984375 -1.742188 2.390625 -1.265625 C 2.804688 -0.796875 3.296875 -0.429688 3.859375 -0.171875 C 4.429688 0.078125 5.070312 0.203125 5.78125 0.203125 Z M 5.90625 -0.59375 C 5.3125 -0.59375 4.78125 -0.695312 4.3125 -0.90625 C 3.851562 -1.125 3.457031 -1.441406 3.125 -1.859375 C 2.789062 -2.273438 2.539062 -2.773438 2.375 -3.359375 C 2.207031 -3.953125 2.125 -4.625 2.125 -5.375 C 2.125 -6.070312 2.207031 -6.703125 2.375 -7.265625 C 2.539062 -7.828125 2.785156 -8.304688 3.109375 -8.703125 C 3.429688 -9.109375 3.816406 -9.421875 4.265625 -9.640625 C 4.710938 -9.859375 5.21875 -9.96875 5.78125 -9.96875 C 6.351562 -9.96875 6.867188 -9.851562 7.328125 -9.625 C 7.796875 -9.40625 8.195312 -9.085938 8.53125 -8.671875 C 8.863281 -8.265625 9.117188 -7.765625 9.296875 -7.171875 C 9.472656 -6.578125 9.566406 -5.914062 9.578125 -5.1875 C 9.566406 -4.476562 9.472656 -3.835938 9.296875 -3.265625 C 9.128906 -2.703125 8.882812 -2.21875 8.5625 -1.8125 C 8.25 -1.414062 7.863281 -1.113281 7.40625 -0.90625 C 6.945312 -0.695312 6.445312 -0.59375 5.90625 -0.59375 Z M 5.90625 -0.59375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.953125 -10.5625 L 1.953125 0 L 2.890625 0 L 2.890625 -8.21875 C 3.117188 -8.425781 3.378906 -8.625 3.671875 -8.8125 C 3.960938 -9.007812 4.265625 -9.1875 4.578125 -9.34375 C 4.898438 -9.5 5.226562 -9.625 5.5625 -9.71875 C 5.894531 -9.820312 6.222656 -9.878906 6.546875 -9.890625 C 7.410156 -9.878906 8.039062 -9.613281 8.4375 -9.09375 C 8.84375 -8.582031 9.046875 -7.8125 9.046875 -6.78125 L 9.046875 0 L 9.96875 0 L 9.96875 -6.953125 C 9.96875 -7.523438 9.898438 -8.046875 9.765625 -8.515625 C 9.640625 -8.992188 9.445312 -9.394531 9.1875 -9.71875 C 8.925781 -10.050781 8.59375 -10.304688 8.1875 -10.484375 C 7.789062 -10.671875 7.320312 -10.765625 6.78125 -10.765625 C 6.382812 -10.765625 6 -10.707031 5.625 -10.59375 C 5.257812 -10.488281 4.90625 -10.347656 4.5625 -10.171875 C 4.21875 -9.992188 3.894531 -9.796875 3.59375 -9.578125 C 3.289062 -9.367188 3.019531 -9.164062 2.78125 -8.96875 L 2.625 -10.5625 Z M 1.953125 -10.5625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 9.078125 -13.71875 L 1.953125 -13.71875 L 1.953125 0 L 2.90625 0 L 2.90625 -6.546875 L 8.609375 -6.546875 L 8.609375 -7.28125 L 2.90625 -7.28125 L 2.90625 -12.96875 L 9.078125 -12.96875 Z M 9.078125 -13.71875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 9.671875 0 L 9.671875 -10.5625 L 8.734375 -10.5625 L 8.734375 -2.34375 C 8.492188 -2.125 8.226562 -1.914062 7.9375 -1.71875 C 7.644531 -1.53125 7.34375 -1.351562 7.03125 -1.1875 C 6.726562 -1.03125 6.410156 -0.90625 6.078125 -0.8125 C 5.753906 -0.726562 5.4375 -0.6875 5.125 -0.6875 C 4.28125 -0.6875 3.660156 -0.941406 3.265625 -1.453125 C 2.867188 -1.972656 2.675781 -2.75 2.6875 -3.78125 L 2.6875 -10.5625 L 1.765625 -10.5625 L 1.765625 -3.609375 C 1.765625 -3.015625 1.820312 -2.484375 1.9375 -2.015625 C 2.0625 -1.554688 2.25 -1.15625 2.5 -0.8125 C 2.757812 -0.476562 3.082031 -0.222656 3.46875 -0.046875 C 3.863281 0.117188 4.335938 0.203125 4.890625 0.203125 C 5.273438 0.203125 5.648438 0.148438 6.015625 0.046875 C 6.378906 -0.0546875 6.726562 -0.191406 7.0625 -0.359375 C 7.40625 -0.535156 7.722656 -0.726562 8.015625 -0.9375 C 8.316406 -1.15625 8.59375 -1.375 8.84375 -1.59375 L 9.015625 0 Z M 9.671875 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-10"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 10.09375 0 L 10.09375 -15.265625 L 9.15625 -15.0625 L 9.15625 -9.90625 C 8.675781 -10.175781 8.242188 -10.363281 7.859375 -10.46875 C 7.484375 -10.582031 7.179688 -10.660156 6.953125 -10.703125 C 6.722656 -10.742188 6.507812 -10.765625 6.3125 -10.765625 C 5.570312 -10.765625 4.890625 -10.628906 4.265625 -10.359375 C 3.640625 -10.097656 3.09375 -9.722656 2.625 -9.234375 C 2.15625 -8.742188 1.789062 -8.15625 1.53125 -7.46875 C 1.269531 -6.789062 1.140625 -6.03125 1.140625 -5.1875 C 1.140625 -4.382812 1.238281 -3.648438 1.4375 -2.984375 C 1.644531 -2.328125 1.941406 -1.757812 2.328125 -1.28125 C 2.722656 -0.800781 3.207031 -0.429688 3.78125 -0.171875 C 4.363281 0.078125 5.015625 0.203125 5.734375 0.203125 C 6.023438 0.203125 6.332031 0.164062 6.65625 0.09375 C 6.988281 0.0195312 7.3125 -0.0859375 7.625 -0.234375 C 7.9375 -0.390625 8.234375 -0.578125 8.515625 -0.796875 C 8.796875 -1.015625 9.046875 -1.269531 9.265625 -1.5625 L 9.421875 0 Z M 9.15625 -2.34375 C 9.007812 -2.125 8.820312 -1.910156 8.59375 -1.703125 C 8.363281 -1.503906 8.109375 -1.316406 7.828125 -1.140625 C 7.546875 -0.972656 7.238281 -0.835938 6.90625 -0.734375 C 6.582031 -0.640625 6.25 -0.59375 5.90625 -0.59375 C 4.65625 -0.59375 3.710938 -1.007812 3.078125 -1.84375 C 2.441406 -2.6875 2.125 -3.863281 2.125 -5.375 C 2.125 -6.0625 2.21875 -6.6875 2.40625 -7.25 C 2.601562 -7.8125 2.878906 -8.289062 3.234375 -8.6875 C 3.597656 -9.09375 4.023438 -9.40625 4.515625 -9.625 C 5.015625 -9.851562 5.554688 -9.96875 6.140625 -9.96875 C 6.710938 -9.96875 7.242188 -9.890625 7.734375 -9.734375 C 8.234375 -9.585938 8.707031 -9.378906 9.15625 -9.109375 Z M 9.15625 -2.34375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-11"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 8.265625 -7.09375 C 8.253906 -7.65625 8.171875 -8.160156 8.015625 -8.609375 C 7.867188 -9.054688 7.644531 -9.441406 7.34375 -9.765625 C 7.050781 -10.085938 6.679688 -10.332031 6.234375 -10.5 C 5.785156 -10.675781 5.273438 -10.765625 4.703125 -10.765625 C 4.335938 -10.765625 3.988281 -10.726562 3.65625 -10.65625 C 3.320312 -10.582031 3.015625 -10.492188 2.734375 -10.390625 C 2.460938 -10.296875 2.222656 -10.191406 2.015625 -10.078125 C 1.804688 -9.972656 1.644531 -9.882812 1.53125 -9.8125 L 1.890625 -9.21875 C 2.140625 -9.375 2.445312 -9.507812 2.8125 -9.625 C 3.175781 -9.75 3.492188 -9.835938 3.765625 -9.890625 C 4.035156 -9.941406 4.320312 -9.96875 4.625 -9.96875 C 5.113281 -9.96875 5.53125 -9.894531 5.875 -9.75 C 6.21875 -9.613281 6.546875 -9.347656 6.859375 -8.953125 C 7.179688 -8.554688 7.335938 -7.894531 7.328125 -6.96875 L 7.328125 -5.578125 C 6.441406 -5.691406 5.59375 -5.707031 4.78125 -5.625 C 4.226562 -5.570312 3.722656 -5.460938 3.265625 -5.296875 C 2.804688 -5.128906 2.410156 -4.914062 2.078125 -4.65625 C 1.742188 -4.40625 1.484375 -4.097656 1.296875 -3.734375 C 1.117188 -3.378906 1.03125 -2.976562 1.03125 -2.53125 C 1.03125 -2.113281 1.101562 -1.734375 1.25 -1.390625 C 1.394531 -1.054688 1.601562 -0.769531 1.875 -0.53125 C 2.15625 -0.289062 2.472656 -0.109375 2.828125 0.015625 C 3.179688 0.140625 3.566406 0.203125 3.984375 0.203125 C 4.617188 0.203125 5.234375 0.046875 5.828125 -0.265625 C 6.429688 -0.578125 6.96875 -1.03125 7.4375 -1.625 C 7.4375 -1.007812 7.570312 -0.550781 7.84375 -0.25 C 8.113281 0.0507812 8.476562 0.203125 8.9375 0.203125 C 9.125 0.203125 9.289062 0.179688 9.4375 0.140625 C 9.59375 0.0976562 9.703125 0.0546875 9.765625 0.015625 L 9.640625 -0.59375 C 9.597656 -0.5625 9.523438 -0.53125 9.421875 -0.5 C 9.328125 -0.476562 9.21875 -0.46875 9.09375 -0.46875 C 8.832031 -0.457031 8.628906 -0.539062 8.484375 -0.71875 C 8.335938 -0.894531 8.265625 -1.1875 8.265625 -1.59375 Z M 2.015625 -2.65625 C 2.015625 -3.320312 2.253906 -3.84375 2.734375 -4.21875 C 3.222656 -4.59375 3.890625 -4.832031 4.734375 -4.9375 C 5.597656 -5.03125 6.460938 -5.03125 7.328125 -4.9375 L 7.328125 -2.34375 C 6.929688 -1.8125 6.460938 -1.382812 5.921875 -1.0625 C 5.378906 -0.75 4.816406 -0.59375 4.234375 -0.59375 C 3.503906 -0.59375 2.953125 -0.78125 2.578125 -1.15625 C 2.203125 -1.53125 2.015625 -2.03125 2.015625 -2.65625 Z M 2.015625 -2.65625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-12"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.953125 -10.5625 L 1.953125 0 L 2.890625 0 L 2.890625 -10.5625 Z M 1.6875 -13.890625 C 1.6875 -13.679688 1.75 -13.507812 1.875 -13.375 C 2.007812 -13.238281 2.175781 -13.164062 2.375 -13.15625 C 2.582031 -13.15625 2.757812 -13.226562 2.90625 -13.375 C 3.0625 -13.53125 3.140625 -13.734375 3.140625 -13.984375 C 3.140625 -14.179688 3.070312 -14.34375 2.9375 -14.46875 C 2.800781 -14.601562 2.644531 -14.675781 2.46875 -14.6875 C 2.238281 -14.675781 2.050781 -14.59375 1.90625 -14.4375 C 1.757812 -14.289062 1.6875 -14.109375 1.6875 -13.890625 Z M 1.6875 -13.890625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-13"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 10.609375 0 L 11.890625 0 L 11.890625 -13.71875 L 10.9375 -13.71875 L 10.9375 -1.15625 L 3.234375 -13.71875 L 1.953125 -13.71875 L 1.953125 0 L 2.90625 0 L 2.90625 -12.5625 Z M 10.609375 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-14"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 9.15625 -5.1875 C 9.207031 -5.363281 9.269531 -5.613281 9.34375 -5.9375 C 9.414062 -6.257812 9.457031 -6.601562 9.46875 -6.96875 C 9.457031 -8.175781 9.140625 -9.109375 8.515625 -9.765625 C 7.890625 -10.421875 7.003906 -10.753906 5.859375 -10.765625 C 5.140625 -10.765625 4.488281 -10.628906 3.90625 -10.359375 C 3.332031 -10.085938 2.835938 -9.707031 2.421875 -9.21875 C 2.003906 -8.726562 1.6875 -8.140625 1.46875 -7.453125 C 1.25 -6.773438 1.140625 -6.019531 1.140625 -5.1875 C 1.140625 -4.375 1.253906 -3.632812 1.484375 -2.96875 C 1.722656 -2.3125 2.054688 -1.742188 2.484375 -1.265625 C 2.921875 -0.796875 3.441406 -0.429688 4.046875 -0.171875 C 4.660156 0.078125 5.335938 0.203125 6.078125 0.203125 C 6.296875 0.203125 6.53125 0.191406 6.78125 0.171875 C 7.039062 0.148438 7.296875 0.113281 7.546875 0.0625 C 7.804688 0.0195312 8.050781 -0.03125 8.28125 -0.09375 C 8.519531 -0.164062 8.738281 -0.238281 8.9375 -0.3125 L 8.671875 -1 C 8.503906 -0.925781 8.3125 -0.863281 8.09375 -0.8125 C 7.882812 -0.769531 7.671875 -0.726562 7.453125 -0.6875 C 7.234375 -0.65625 7.015625 -0.628906 6.796875 -0.609375 C 6.585938 -0.597656 6.390625 -0.59375 6.203125 -0.59375 C 5.535156 -0.59375 4.945312 -0.695312 4.4375 -0.90625 C 3.925781 -1.113281 3.5 -1.414062 3.15625 -1.8125 C 2.820312 -2.207031 2.566406 -2.6875 2.390625 -3.25 C 2.210938 -3.820312 2.117188 -4.46875 2.109375 -5.1875 Z M 5.71875 -9.96875 C 6.613281 -9.96875 7.300781 -9.722656 7.78125 -9.234375 C 8.269531 -8.742188 8.519531 -8.007812 8.53125 -7.03125 C 8.53125 -6.539062 8.488281 -6.160156 8.40625 -5.890625 L 2.125 -5.890625 C 2.144531 -6.472656 2.238281 -7.007812 2.40625 -7.5 C 2.582031 -8 2.828125 -8.429688 3.140625 -8.796875 C 3.453125 -9.160156 3.820312 -9.445312 4.25 -9.65625 C 4.675781 -9.863281 5.164062 -9.96875 5.71875 -9.96875 Z M 5.71875 -9.96875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-15"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.65625 -3.4375 C 5.164062 -3.4375 5.644531 -3.53125 6.09375 -3.71875 C 6.539062 -3.90625 6.9375 -4.164062 7.28125 -4.5 C 7.625 -4.84375 7.894531 -5.238281 8.09375 -5.6875 C 8.289062 -6.132812 8.390625 -6.617188 8.390625 -7.140625 C 8.390625 -7.617188 8.316406 -8.054688 8.171875 -8.453125 C 8.035156 -8.847656 7.84375 -9.203125 7.59375 -9.515625 C 7.851562 -9.679688 8.1875 -9.800781 8.59375 -9.875 C 9 -9.957031 9.414062 -9.96875 9.84375 -9.90625 L 9.84375 -10.71875 C 9.519531 -10.75 9.222656 -10.75 8.953125 -10.71875 C 8.679688 -10.6875 8.375 -10.613281 8.03125 -10.5 C 7.6875 -10.382812 7.390625 -10.203125 7.140625 -9.953125 C 6.816406 -10.203125 6.457031 -10.398438 6.0625 -10.546875 C 5.664062 -10.691406 5.25 -10.765625 4.8125 -10.765625 C 4.28125 -10.765625 3.785156 -10.664062 3.328125 -10.46875 C 2.878906 -10.28125 2.484375 -10.015625 2.140625 -9.671875 C 1.796875 -9.328125 1.53125 -8.9375 1.34375 -8.5 C 1.15625 -8.0625 1.0625 -7.582031 1.0625 -7.0625 C 1.070312 -6.207031 1.28125 -5.488281 1.6875 -4.90625 C 2.09375 -4.320312 2.640625 -3.910156 3.328125 -3.671875 C 3.148438 -3.554688 2.984375 -3.4375 2.828125 -3.3125 C 2.671875 -3.1875 2.5 -3.007812 2.3125 -2.78125 C 2.132812 -2.550781 2.039062 -2.253906 2.03125 -1.890625 C 2.039062 -1.523438 2.109375 -1.25 2.234375 -1.0625 C 2.367188 -0.882812 2.488281 -0.753906 2.59375 -0.671875 C 2.707031 -0.585938 2.828125 -0.519531 2.953125 -0.46875 C 2.679688 -0.34375 2.421875 -0.191406 2.171875 -0.015625 C 1.929688 0.148438 1.71875 0.335938 1.53125 0.546875 C 1.34375 0.765625 1.191406 1 1.078125 1.25 C 0.972656 1.5 0.921875 1.765625 0.921875 2.046875 C 0.921875 2.429688 1.015625 2.78125 1.203125 3.09375 C 1.398438 3.40625 1.679688 3.664062 2.046875 3.875 C 2.421875 4.082031 2.859375 4.238281 3.359375 4.34375 C 3.859375 4.445312 4.421875 4.5 5.046875 4.5 C 5.753906 4.5 6.390625 4.425781 6.953125 4.28125 C 7.515625 4.132812 7.992188 3.925781 8.390625 3.65625 C 8.796875 3.394531 9.109375 3.082031 9.328125 2.71875 C 9.546875 2.363281 9.660156 1.96875 9.671875 1.53125 C 9.660156 1.125 9.566406 0.765625 9.390625 0.453125 C 9.210938 0.148438 8.976562 -0.0976562 8.6875 -0.296875 C 8.394531 -0.503906 8.0625 -0.660156 7.6875 -0.765625 C 7.320312 -0.867188 6.945312 -0.921875 6.5625 -0.921875 L 4.171875 -0.921875 C 3.742188 -0.921875 3.425781 -1.015625 3.21875 -1.203125 C 3.007812 -1.398438 2.90625 -1.664062 2.90625 -2 C 2.90625 -2.28125 3.015625 -2.550781 3.234375 -2.8125 C 3.460938 -3.070312 3.734375 -3.296875 4.046875 -3.484375 C 4.242188 -3.453125 4.445312 -3.4375 4.65625 -3.4375 Z M 4.71875 -4.203125 C 4.3125 -4.203125 3.941406 -4.269531 3.609375 -4.40625 C 3.273438 -4.539062 2.984375 -4.738281 2.734375 -5 C 2.484375 -5.257812 2.289062 -5.570312 2.15625 -5.9375 C 2.019531 -6.3125 1.953125 -6.734375 1.953125 -7.203125 C 1.953125 -7.585938 2.019531 -7.945312 2.15625 -8.28125 C 2.300781 -8.625 2.5 -8.921875 2.75 -9.171875 C 3 -9.429688 3.289062 -9.632812 3.625 -9.78125 C 3.96875 -9.925781 4.34375 -10 4.75 -10 C 5.125 -10 5.476562 -9.925781 5.8125 -9.78125 C 6.15625 -9.644531 6.453125 -9.445312 6.703125 -9.1875 C 6.953125 -8.925781 7.144531 -8.609375 7.28125 -8.234375 C 7.425781 -7.867188 7.503906 -7.460938 7.515625 -7.015625 C 7.503906 -6.617188 7.425781 -6.25 7.28125 -5.90625 C 7.132812 -5.5625 6.929688 -5.257812 6.671875 -5 C 6.421875 -4.75 6.128906 -4.550781 5.796875 -4.40625 C 5.460938 -4.269531 5.101562 -4.203125 4.71875 -4.203125 Z M 5.28125 3.703125 C 4.164062 3.703125 3.316406 3.546875 2.734375 3.234375 C 2.148438 2.929688 1.859375 2.472656 1.859375 1.859375 C 1.859375 1.628906 1.90625 1.410156 2 1.203125 C 2.09375 1.003906 2.21875 0.820312 2.375 0.65625 C 2.53125 0.488281 2.707031 0.34375 2.90625 0.21875 C 3.101562 0.09375 3.316406 -0.015625 3.546875 -0.109375 L 6.40625 -0.109375 C 7.144531 -0.109375 7.710938 0.0351562 8.109375 0.328125 C 8.515625 0.628906 8.71875 1.070312 8.71875 1.65625 C 8.71875 1.957031 8.628906 2.234375 8.453125 2.484375 C 8.285156 2.742188 8.050781 2.960938 7.75 3.140625 C 7.445312 3.316406 7.082031 3.453125 6.65625 3.546875 C 6.238281 3.648438 5.78125 3.703125 5.28125 3.703125 Z M 5.28125 3.703125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-16"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.953125 -10.5625 L 1.96875 0 L 2.890625 0 L 2.890625 -8.15625 C 3.085938 -8.320312 3.316406 -8.492188 3.578125 -8.671875 C 3.835938 -8.847656 4.191406 -9.046875 4.640625 -9.265625 C 5.097656 -9.492188 5.691406 -9.660156 6.421875 -9.765625 L 6.421875 -10.765625 C 5.753906 -10.660156 5.179688 -10.476562 4.703125 -10.21875 C 4.222656 -9.957031 3.84375 -9.722656 3.5625 -9.515625 C 3.28125 -9.304688 3.023438 -9.085938 2.796875 -8.859375 L 2.625 -10.5625 Z M 1.953125 -10.5625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.546875 -5.609375 L 3.875 -4.28125 L 5.203125 -5.609375 L 5.734375 -5.078125 L 4.40625 -3.75 L 5.75 -2.40625 L 5.21875 -1.859375 L 3.875 -3.203125 L 2.53125 -1.859375 L 2 -2.40625 L 3.34375 -3.75 L 2 -5.078125 Z M 1.0625 0 L 6.6875 0 L 6.6875 -7.484375 L 1.0625 -7.484375 Z M 1.0625 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.78125 0 L 6.484375 0 L 6.484375 -7.484375 L 5.953125 -7.484375 L 5.953125 -0.625 L 1.765625 -7.484375 L 1.0625 -7.484375 L 1.0625 0 L 1.578125 0 L 1.578125 -6.84375 Z M 5.78125 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 6.09375 0 L 6.640625 0 L 3.703125 -7.484375 L 3.1875 -7.484375 L 0.25 0 L 0.796875 0 L 1.609375 -2.109375 L 5.28125 -2.109375 Z M 3.453125 -6.890625 L 5.140625 -2.5 L 1.75 -2.5 Z M 3.453125 -6.890625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.984375 -0.328125 C 3.554688 -0.328125 3.171875 -0.410156 2.828125 -0.578125 C 2.484375 -0.742188 2.1875 -0.976562 1.9375 -1.28125 C 1.6875 -1.582031 1.5 -1.945312 1.375 -2.375 C 1.25 -2.8125 1.1875 -3.296875 1.1875 -3.828125 C 1.1875 -4.316406 1.25 -4.765625 1.375 -5.171875 C 1.507812 -5.578125 1.695312 -5.925781 1.9375 -6.21875 C 2.1875 -6.507812 2.476562 -6.734375 2.8125 -6.890625 C 3.144531 -7.054688 3.507812 -7.140625 3.90625 -7.140625 C 4.332031 -7.140625 4.71875 -7.054688 5.0625 -6.890625 C 5.40625 -6.722656 5.695312 -6.484375 5.9375 -6.171875 C 6.1875 -5.867188 6.378906 -5.503906 6.515625 -5.078125 C 6.648438 -4.648438 6.71875 -4.175781 6.71875 -3.65625 C 6.71875 -3.15625 6.648438 -2.703125 6.515625 -2.296875 C 6.378906 -1.890625 6.1875 -1.535156 5.9375 -1.234375 C 5.695312 -0.941406 5.410156 -0.71875 5.078125 -0.5625 C 4.742188 -0.40625 4.378906 -0.328125 3.984375 -0.328125 Z M 3.90625 0.109375 C 4.40625 0.109375 4.859375 0.0195312 5.265625 -0.15625 C 5.679688 -0.34375 6.039062 -0.609375 6.34375 -0.953125 C 6.644531 -1.296875 6.875 -1.703125 7.03125 -2.171875 C 7.195312 -2.648438 7.28125 -3.175781 7.28125 -3.75 C 7.28125 -4.3125 7.195312 -4.820312 7.03125 -5.28125 C 6.875 -5.75 6.648438 -6.15625 6.359375 -6.5 C 6.066406 -6.84375 5.71875 -7.109375 5.3125 -7.296875 C 4.90625 -7.484375 4.460938 -7.582031 3.984375 -7.59375 C 3.484375 -7.582031 3.023438 -7.484375 2.609375 -7.296875 C 2.203125 -7.109375 1.847656 -6.84375 1.546875 -6.5 C 1.242188 -6.164062 1.015625 -5.757812 0.859375 -5.28125 C 0.703125 -4.8125 0.625 -4.289062 0.625 -3.71875 C 0.625 -3.15625 0.703125 -2.640625 0.859375 -2.171875 C 1.015625 -1.703125 1.238281 -1.296875 1.53125 -0.953125 C 1.832031 -0.617188 2.179688 -0.359375 2.578125 -0.171875 C 2.984375 0.015625 3.425781 0.109375 3.90625 0.109375 Z M 3.90625 0.109375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.828125 0 C 3.347656 0 3.828125 -0.0820312 4.265625 -0.25 C 4.703125 -0.425781 5.082031 -0.675781 5.40625 -1 C 5.726562 -1.332031 5.976562 -1.726562 6.15625 -2.1875 C 6.332031 -2.65625 6.425781 -3.175781 6.4375 -3.75 C 6.4375 -4.28125 6.359375 -4.769531 6.203125 -5.21875 C 6.046875 -5.675781 5.816406 -6.070312 5.515625 -6.40625 C 5.210938 -6.738281 4.835938 -7 4.390625 -7.1875 C 3.941406 -7.375 3.421875 -7.472656 2.828125 -7.484375 L 1.0625 -7.484375 L 1.0625 0 Z M 1.578125 -0.40625 L 1.578125 -7.078125 L 2.828125 -7.078125 C 3.328125 -7.066406 3.765625 -6.976562 4.140625 -6.8125 C 4.523438 -6.65625 4.84375 -6.425781 5.09375 -6.125 C 5.351562 -5.820312 5.546875 -5.460938 5.671875 -5.046875 C 5.796875 -4.628906 5.863281 -4.164062 5.875 -3.65625 C 5.863281 -3.144531 5.78125 -2.691406 5.625 -2.296875 C 5.46875 -1.898438 5.25 -1.5625 4.96875 -1.28125 C 4.695312 -1 4.375 -0.78125 4 -0.625 C 3.625 -0.476562 3.21875 -0.40625 2.78125 -0.40625 Z M 1.578125 -0.40625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.078125 -7.484375 L 1.0625 -7.484375 L 1.0625 0 L 5.203125 0 L 5.203125 -0.40625 L 1.578125 -0.40625 L 1.578125 -3.5625 L 4.953125 -3.5625 L 4.953125 -3.96875 L 1.578125 -3.96875 L 1.578125 -7.078125 L 5.078125 -7.078125 Z M 5.078125 -7.484375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 6.09375 -3.71875 L 4 -3.71875 L 4 -3.3125 L 5.578125 -3.3125 L 5.578125 -0.625 C 5.441406 -0.550781 5.25 -0.484375 5 -0.421875 C 4.757812 -0.367188 4.484375 -0.335938 4.171875 -0.328125 C 3.679688 -0.328125 3.25 -0.40625 2.875 -0.5625 C 2.507812 -0.726562 2.195312 -0.960938 1.9375 -1.265625 C 1.6875 -1.566406 1.492188 -1.929688 1.359375 -2.359375 C 1.234375 -2.796875 1.175781 -3.285156 1.1875 -3.828125 C 1.1875 -4.359375 1.253906 -4.828125 1.390625 -5.234375 C 1.535156 -5.648438 1.738281 -6 2 -6.28125 C 2.269531 -6.5625 2.59375 -6.773438 2.96875 -6.921875 C 3.34375 -7.066406 3.765625 -7.140625 4.234375 -7.140625 C 4.546875 -7.140625 4.828125 -7.109375 5.078125 -7.046875 C 5.335938 -6.984375 5.546875 -6.925781 5.703125 -6.875 L 5.859375 -7.25 C 5.785156 -7.28125 5.691406 -7.3125 5.578125 -7.34375 C 5.472656 -7.382812 5.347656 -7.421875 5.203125 -7.453125 C 5.066406 -7.492188 4.914062 -7.523438 4.75 -7.546875 C 4.59375 -7.566406 4.429688 -7.582031 4.265625 -7.59375 C 3.679688 -7.582031 3.160156 -7.476562 2.703125 -7.28125 C 2.253906 -7.09375 1.875 -6.828125 1.5625 -6.484375 C 1.25 -6.140625 1.015625 -5.726562 0.859375 -5.25 C 0.703125 -4.78125 0.625 -4.269531 0.625 -3.71875 C 0.625 -3.15625 0.695312 -2.640625 0.84375 -2.171875 C 1 -1.703125 1.222656 -1.296875 1.515625 -0.953125 C 1.816406 -0.609375 2.179688 -0.34375 2.609375 -0.15625 C 3.046875 0.0195312 3.539062 0.109375 4.09375 0.109375 C 4.289062 0.109375 4.484375 0.0976562 4.671875 0.078125 C 4.867188 0.0546875 5.097656 0.0078125 5.359375 -0.0625 C 5.628906 -0.132812 5.875 -0.242188 6.09375 -0.390625 Z M 6.09375 -3.71875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.578125 0 L 1.578125 -3.203125 L 3.453125 -3.203125 L 5.171875 0 L 5.71875 0 L 3.9375 -3.296875 C 4.132812 -3.359375 4.332031 -3.445312 4.53125 -3.5625 C 4.726562 -3.675781 4.910156 -3.816406 5.078125 -3.984375 C 5.253906 -4.160156 5.394531 -4.363281 5.5 -4.59375 C 5.601562 -4.832031 5.660156 -5.101562 5.671875 -5.40625 C 5.660156 -5.71875 5.59375 -6 5.46875 -6.25 C 5.351562 -6.507812 5.1875 -6.726562 4.96875 -6.90625 C 4.75 -7.09375 4.488281 -7.234375 4.1875 -7.328125 C 3.894531 -7.421875 3.578125 -7.472656 3.234375 -7.484375 L 1.0625 -7.484375 L 1.0625 0 Z M 3.171875 -7.078125 C 3.796875 -7.066406 4.269531 -6.90625 4.59375 -6.59375 C 4.925781 -6.289062 5.097656 -5.859375 5.109375 -5.296875 C 5.097656 -5.066406 5.050781 -4.859375 4.96875 -4.671875 C 4.882812 -4.484375 4.769531 -4.316406 4.625 -4.171875 C 4.488281 -4.035156 4.332031 -3.914062 4.15625 -3.8125 C 3.976562 -3.71875 3.796875 -3.648438 3.609375 -3.609375 L 1.578125 -3.609375 L 1.578125 -7.078125 Z M 3.171875 -7.078125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.578125 0 L 1.578125 -3.09375 L 3.046875 -3.09375 C 3.410156 -3.09375 3.742188 -3.140625 4.046875 -3.234375 C 4.359375 -3.335938 4.625 -3.484375 4.84375 -3.671875 C 5.0625 -3.859375 5.234375 -4.085938 5.359375 -4.359375 C 5.484375 -4.640625 5.546875 -4.957031 5.546875 -5.3125 C 5.546875 -5.632812 5.488281 -5.925781 5.375 -6.1875 C 5.257812 -6.457031 5.09375 -6.6875 4.875 -6.875 C 4.65625 -7.070312 4.394531 -7.21875 4.09375 -7.3125 C 3.800781 -7.414062 3.472656 -7.472656 3.109375 -7.484375 L 1.0625 -7.484375 L 1.0625 0 Z M 3.046875 -7.078125 C 3.703125 -7.066406 4.1875 -6.898438 4.5 -6.578125 C 4.820312 -6.265625 4.984375 -5.804688 4.984375 -5.203125 C 4.984375 -4.929688 4.9375 -4.6875 4.84375 -4.46875 C 4.757812 -4.257812 4.597656 -4.046875 4.359375 -3.828125 C 4.117188 -3.609375 3.703125 -3.5 3.109375 -3.5 L 1.578125 -3.5 L 1.578125 -7.078125 Z M 3.046875 -7.078125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-10"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.0625 0 L 1.578125 0 L 1.578125 -6.984375 L 4.484375 -1.0625 L 4.921875 -1.0625 L 7.828125 -6.984375 L 7.828125 0 L 8.34375 0 L 8.34375 -7.484375 L 7.5625 -7.484375 L 4.703125 -1.65625 L 1.84375 -7.484375 L 1.0625 -7.484375 Z M 1.0625 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.90625 -4.203125 L 2.90625 -3.203125 L 3.90625 -4.203125 L 4.3125 -3.8125 L 3.3125 -2.8125 L 4.3125 -1.796875 L 3.921875 -1.40625 L 2.90625 -2.40625 L 1.90625 -1.40625 L 1.5 -1.796875 L 2.5 -2.8125 L 1.5 -3.8125 Z M 0.796875 0 L 5.015625 0 L 5.015625 -5.609375 L 0.796875 -5.609375 Z M 0.796875 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.046875 -5.609375 L 0.65625 -5.609375 L 0.65625 -2.125 C 0.65625 -1.769531 0.695312 -1.457031 0.78125 -1.1875 C 0.875 -0.914062 1.046875 -0.632812 1.296875 -0.34375 C 1.554688 -0.0625 1.992188 0.078125 2.609375 0.078125 C 2.921875 0.078125 3.203125 0.03125 3.453125 -0.0625 C 3.703125 -0.164062 3.914062 -0.3125 4.09375 -0.5 C 4.269531 -0.695312 4.398438 -0.929688 4.484375 -1.203125 C 4.578125 -1.484375 4.628906 -1.800781 4.640625 -2.15625 L 4.640625 -5.609375 L 4.25 -5.609375 L 4.25 -2.09375 C 4.25 -1.800781 4.210938 -1.539062 4.140625 -1.3125 C 4.066406 -1.082031 3.925781 -0.847656 3.71875 -0.609375 C 3.507812 -0.367188 3.160156 -0.25 2.671875 -0.25 C 2.148438 -0.25 1.75 -0.410156 1.46875 -0.734375 C 1.1875 -1.066406 1.046875 -1.550781 1.046875 -2.1875 Z M 1.046875 -5.609375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.125 0 L 4.125 -6.25 L 3.75 -6.15625 L 3.75 -4.046875 C 3.550781 -4.160156 3.375 -4.238281 3.21875 -4.28125 C 3.0625 -4.320312 2.9375 -4.351562 2.84375 -4.375 C 2.75 -4.394531 2.660156 -4.40625 2.578125 -4.40625 C 2.273438 -4.40625 1.992188 -4.347656 1.734375 -4.234375 C 1.484375 -4.128906 1.257812 -3.972656 1.0625 -3.765625 C 0.875 -3.566406 0.726562 -3.328125 0.625 -3.046875 C 0.519531 -2.773438 0.46875 -2.46875 0.46875 -2.125 C 0.46875 -1.789062 0.507812 -1.488281 0.59375 -1.21875 C 0.675781 -0.945312 0.796875 -0.710938 0.953125 -0.515625 C 1.117188 -0.328125 1.316406 -0.179688 1.546875 -0.078125 C 1.785156 0.0234375 2.050781 0.078125 2.34375 0.078125 C 2.46875 0.078125 2.59375 0.0625 2.71875 0.03125 C 2.851562 0 2.984375 -0.0390625 3.109375 -0.09375 C 3.242188 -0.15625 3.367188 -0.226562 3.484375 -0.3125 C 3.597656 -0.40625 3.695312 -0.515625 3.78125 -0.640625 L 3.859375 0 Z M 3.75 -0.953125 C 3.6875 -0.867188 3.609375 -0.785156 3.515625 -0.703125 C 3.421875 -0.617188 3.316406 -0.539062 3.203125 -0.46875 C 3.085938 -0.394531 2.960938 -0.335938 2.828125 -0.296875 C 2.691406 -0.253906 2.554688 -0.234375 2.421875 -0.234375 C 1.910156 -0.242188 1.523438 -0.414062 1.265625 -0.75 C 1.003906 -1.09375 0.875 -1.578125 0.875 -2.203125 C 0.875 -2.484375 0.910156 -2.738281 0.984375 -2.96875 C 1.066406 -3.195312 1.179688 -3.394531 1.328125 -3.5625 C 1.472656 -3.726562 1.644531 -3.851562 1.84375 -3.9375 C 2.050781 -4.03125 2.273438 -4.078125 2.515625 -4.078125 C 2.742188 -4.078125 2.957031 -4.046875 3.15625 -3.984375 C 3.363281 -3.921875 3.5625 -3.832031 3.75 -3.71875 Z M 3.75 -0.953125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.375 -2.90625 C 3.375 -3.132812 3.34375 -3.335938 3.28125 -3.515625 C 3.21875 -3.703125 3.125 -3.859375 3 -3.984375 C 2.882812 -4.117188 2.734375 -4.222656 2.546875 -4.296875 C 2.367188 -4.367188 2.160156 -4.40625 1.921875 -4.40625 C 1.773438 -4.40625 1.632812 -4.390625 1.5 -4.359375 C 1.363281 -4.328125 1.238281 -4.289062 1.125 -4.25 C 1.007812 -4.207031 0.910156 -4.164062 0.828125 -4.125 C 0.742188 -4.082031 0.675781 -4.046875 0.625 -4.015625 L 0.765625 -3.765625 C 0.867188 -3.828125 0.992188 -3.882812 1.140625 -3.9375 C 1.296875 -3.988281 1.425781 -4.023438 1.53125 -4.046875 C 1.644531 -4.066406 1.765625 -4.078125 1.890625 -4.078125 C 2.085938 -4.078125 2.253906 -4.046875 2.390625 -3.984375 C 2.535156 -3.929688 2.671875 -3.820312 2.796875 -3.65625 C 2.929688 -3.5 3 -3.226562 3 -2.84375 L 3 -2.28125 C 2.632812 -2.320312 2.285156 -2.328125 1.953125 -2.296875 C 1.722656 -2.273438 1.515625 -2.226562 1.328125 -2.15625 C 1.148438 -2.09375 0.988281 -2.007812 0.84375 -1.90625 C 0.707031 -1.800781 0.601562 -1.675781 0.53125 -1.53125 C 0.457031 -1.382812 0.421875 -1.21875 0.421875 -1.03125 C 0.421875 -0.863281 0.453125 -0.707031 0.515625 -0.5625 C 0.578125 -0.425781 0.660156 -0.3125 0.765625 -0.21875 C 0.878906 -0.125 1.007812 -0.0507812 1.15625 0 C 1.300781 0.0507812 1.457031 0.078125 1.625 0.078125 C 1.882812 0.078125 2.132812 0.015625 2.375 -0.109375 C 2.625 -0.234375 2.847656 -0.414062 3.046875 -0.65625 C 3.046875 -0.40625 3.097656 -0.21875 3.203125 -0.09375 C 3.316406 0.0195312 3.46875 0.078125 3.65625 0.078125 C 3.726562 0.078125 3.796875 0.0664062 3.859375 0.046875 C 3.921875 0.0351562 3.96875 0.0195312 4 0 L 3.9375 -0.234375 C 3.925781 -0.222656 3.898438 -0.210938 3.859375 -0.203125 C 3.816406 -0.191406 3.769531 -0.1875 3.71875 -0.1875 C 3.613281 -0.1875 3.53125 -0.222656 3.46875 -0.296875 C 3.40625 -0.367188 3.375 -0.488281 3.375 -0.65625 Z M 0.828125 -1.09375 C 0.828125 -1.363281 0.925781 -1.570312 1.125 -1.71875 C 1.320312 -1.875 1.59375 -1.972656 1.9375 -2.015625 C 2.289062 -2.054688 2.644531 -2.054688 3 -2.015625 L 3 -0.953125 C 2.832031 -0.742188 2.640625 -0.570312 2.421875 -0.4375 C 2.203125 -0.3125 1.972656 -0.242188 1.734375 -0.234375 C 1.429688 -0.242188 1.203125 -0.320312 1.046875 -0.46875 C 0.898438 -0.625 0.828125 -0.832031 0.828125 -1.09375 Z M 0.828125 -1.09375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.875 -2.203125 C 0.875 -2.484375 0.910156 -2.738281 0.984375 -2.96875 C 1.066406 -3.195312 1.179688 -3.394531 1.328125 -3.5625 C 1.472656 -3.726562 1.648438 -3.851562 1.859375 -3.9375 C 2.078125 -4.03125 2.316406 -4.078125 2.578125 -4.078125 C 2.742188 -4.078125 2.894531 -4.0625 3.03125 -4.03125 C 3.164062 -4 3.273438 -3.96875 3.359375 -3.9375 L 3.484375 -4.203125 C 3.398438 -4.253906 3.273438 -4.296875 3.109375 -4.328125 C 2.953125 -4.367188 2.78125 -4.394531 2.59375 -4.40625 C 2.269531 -4.40625 1.976562 -4.347656 1.71875 -4.234375 C 1.457031 -4.128906 1.234375 -3.972656 1.046875 -3.765625 C 0.859375 -3.566406 0.710938 -3.328125 0.609375 -3.046875 C 0.515625 -2.765625 0.46875 -2.457031 0.46875 -2.125 C 0.46875 -1.789062 0.515625 -1.488281 0.609375 -1.21875 C 0.703125 -0.945312 0.835938 -0.710938 1.015625 -0.515625 C 1.203125 -0.328125 1.421875 -0.179688 1.671875 -0.078125 C 1.929688 0.0234375 2.21875 0.078125 2.53125 0.078125 C 2.71875 0.078125 2.898438 0.0546875 3.078125 0.015625 C 3.265625 -0.015625 3.429688 -0.0625 3.578125 -0.125 L 3.46875 -0.40625 C 3.34375 -0.351562 3.203125 -0.3125 3.046875 -0.28125 C 2.890625 -0.25 2.738281 -0.234375 2.59375 -0.234375 C 2.3125 -0.234375 2.0625 -0.273438 1.84375 -0.359375 C 1.625 -0.453125 1.441406 -0.582031 1.296875 -0.75 C 1.148438 -0.925781 1.039062 -1.132812 0.96875 -1.375 C 0.894531 -1.613281 0.863281 -1.890625 0.875 -2.203125 Z M 0.875 -2.203125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.796875 -4.328125 L 0.796875 0 L 1.1875 0 L 1.1875 -4.328125 Z M 0.6875 -5.671875 C 0.6875 -5.585938 0.710938 -5.519531 0.765625 -5.46875 C 0.828125 -5.414062 0.894531 -5.390625 0.96875 -5.390625 C 1.050781 -5.390625 1.125 -5.414062 1.1875 -5.46875 C 1.25 -5.53125 1.28125 -5.613281 1.28125 -5.71875 C 1.28125 -5.800781 1.253906 -5.867188 1.203125 -5.921875 C 1.148438 -5.972656 1.085938 -6.003906 1.015625 -6.015625 C 0.921875 -6.003906 0.84375 -5.96875 0.78125 -5.90625 C 0.71875 -5.84375 0.6875 -5.765625 0.6875 -5.671875 Z M 0.6875 -5.671875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.34375 -5.359375 L 1 -5.28125 L 0.96875 -4.296875 L 0.1875 -4.25 L 0.1875 -4.015625 L 0.96875 -4.015625 L 0.96875 -1.046875 C 0.96875 -0.660156 1.066406 -0.375 1.265625 -0.1875 C 1.472656 0 1.773438 0.0859375 2.171875 0.078125 C 2.285156 0.078125 2.40625 0.0664062 2.53125 0.046875 C 2.65625 0.0351562 2.757812 0.0078125 2.84375 -0.03125 L 2.765625 -0.3125 C 2.703125 -0.289062 2.617188 -0.269531 2.515625 -0.25 C 2.410156 -0.238281 2.3125 -0.234375 2.21875 -0.234375 C 1.914062 -0.234375 1.691406 -0.300781 1.546875 -0.4375 C 1.410156 -0.582031 1.34375 -0.820312 1.34375 -1.15625 L 1.34375 -4.015625 L 2.6875 -4.015625 L 2.6875 -4.328125 L 1.34375 -4.328125 Z M 1.34375 -5.359375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.71875 -4.328125 L 2.25 -0.34375 L 0.546875 -4.328125 L 0.140625 -4.328125 L 2.0625 0.0625 C 1.96875 0.300781 1.875 0.503906 1.78125 0.671875 C 1.695312 0.847656 1.597656 0.992188 1.484375 1.109375 C 1.378906 1.222656 1.265625 1.304688 1.140625 1.359375 C 1.015625 1.410156 0.867188 1.4375 0.703125 1.4375 C 0.617188 1.4375 0.539062 1.425781 0.46875 1.40625 C 0.394531 1.394531 0.332031 1.378906 0.28125 1.359375 L 0.171875 1.65625 C 0.234375 1.6875 0.304688 1.707031 0.390625 1.71875 C 0.484375 1.738281 0.585938 1.75 0.703125 1.75 C 0.910156 1.757812 1.097656 1.726562 1.265625 1.65625 C 1.429688 1.59375 1.582031 1.488281 1.71875 1.34375 C 1.851562 1.207031 1.984375 1.019531 2.109375 0.78125 C 2.234375 0.539062 2.363281 0.25 2.5 -0.09375 L 4.125 -4.328125 Z M 3.71875 -4.328125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.796875 -6.15625 L 0.796875 0 L 1.1875 0 L 1.1875 -3.359375 C 1.28125 -3.441406 1.382812 -3.519531 1.5 -3.59375 C 1.613281 -3.675781 1.738281 -3.75 1.875 -3.8125 C 2.007812 -3.882812 2.144531 -3.941406 2.28125 -3.984375 C 2.414062 -4.023438 2.546875 -4.046875 2.671875 -4.046875 C 3.023438 -4.046875 3.285156 -3.9375 3.453125 -3.71875 C 3.617188 -3.507812 3.703125 -3.195312 3.703125 -2.78125 L 3.703125 0 L 4.078125 0 L 4.078125 -2.84375 C 4.078125 -3.082031 4.050781 -3.296875 4 -3.484375 C 3.945312 -3.679688 3.863281 -3.847656 3.75 -3.984375 C 3.644531 -4.117188 3.507812 -4.222656 3.34375 -4.296875 C 3.1875 -4.367188 3 -4.40625 2.78125 -4.40625 C 2.625 -4.40625 2.46875 -4.382812 2.3125 -4.34375 C 2.164062 -4.300781 2.023438 -4.242188 1.890625 -4.171875 C 1.753906 -4.109375 1.625 -4.035156 1.5 -3.953125 C 1.382812 -3.867188 1.28125 -3.785156 1.1875 -3.703125 L 1.1875 -6.25 Z M 0.796875 -6.15625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-10"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.40625 -0.21875 C 0.519531 -0.132812 0.6875 -0.0625 0.90625 0 C 1.132812 0.0507812 1.394531 0.078125 1.6875 0.078125 C 1.914062 0.078125 2.117188 0.0507812 2.296875 0 C 2.472656 -0.0507812 2.625 -0.125 2.75 -0.21875 C 2.875 -0.3125 2.96875 -0.425781 3.03125 -0.5625 C 3.101562 -0.707031 3.140625 -0.863281 3.140625 -1.03125 C 3.128906 -1.320312 3.035156 -1.5625 2.859375 -1.75 C 2.679688 -1.9375 2.429688 -2.097656 2.109375 -2.234375 L 1.71875 -2.390625 C 1.53125 -2.460938 1.378906 -2.53125 1.265625 -2.59375 C 1.148438 -2.664062 1.0625 -2.738281 1 -2.8125 C 0.9375 -2.882812 0.894531 -2.957031 0.875 -3.03125 C 0.851562 -3.113281 0.847656 -3.203125 0.859375 -3.296875 C 0.859375 -3.523438 0.914062 -3.691406 1.03125 -3.796875 C 1.15625 -3.898438 1.273438 -3.972656 1.390625 -4.015625 C 1.503906 -4.054688 1.632812 -4.078125 1.78125 -4.078125 C 1.90625 -4.078125 2.023438 -4.066406 2.140625 -4.046875 C 2.253906 -4.035156 2.378906 -4.007812 2.515625 -3.96875 C 2.648438 -3.925781 2.753906 -3.890625 2.828125 -3.859375 L 2.9375 -4.15625 C 2.90625 -4.175781 2.851562 -4.195312 2.78125 -4.21875 C 2.707031 -4.25 2.625 -4.273438 2.53125 -4.296875 C 2.4375 -4.328125 2.328125 -4.351562 2.203125 -4.375 C 2.085938 -4.394531 1.960938 -4.40625 1.828125 -4.40625 C 1.640625 -4.40625 1.460938 -4.375 1.296875 -4.3125 C 1.128906 -4.257812 0.984375 -4.179688 0.859375 -4.078125 C 0.734375 -3.984375 0.632812 -3.863281 0.5625 -3.71875 C 0.5 -3.582031 0.46875 -3.429688 0.46875 -3.265625 C 0.457031 -3.003906 0.523438 -2.78125 0.671875 -2.59375 C 0.828125 -2.414062 1.054688 -2.269531 1.359375 -2.15625 L 1.75 -2 C 1.925781 -1.925781 2.078125 -1.851562 2.203125 -1.78125 C 2.328125 -1.707031 2.425781 -1.628906 2.5 -1.546875 C 2.582031 -1.472656 2.644531 -1.390625 2.6875 -1.296875 C 2.726562 -1.210938 2.75 -1.117188 2.75 -1.015625 C 2.75 -0.890625 2.722656 -0.773438 2.671875 -0.671875 C 2.617188 -0.578125 2.523438 -0.476562 2.390625 -0.375 C 2.253906 -0.28125 2.039062 -0.234375 1.75 -0.234375 C 1.46875 -0.242188 1.21875 -0.273438 1 -0.328125 C 0.789062 -0.378906 0.632812 -0.441406 0.53125 -0.515625 Z M 0.40625 -0.21875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-11"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.359375 0.078125 C 2.648438 0.078125 2.914062 0.0234375 3.15625 -0.078125 C 3.394531 -0.179688 3.597656 -0.332031 3.765625 -0.53125 C 3.941406 -0.726562 4.078125 -0.96875 4.171875 -1.25 C 4.265625 -1.53125 4.316406 -1.847656 4.328125 -2.203125 C 4.316406 -2.523438 4.265625 -2.820312 4.171875 -3.09375 C 4.078125 -3.363281 3.945312 -3.59375 3.78125 -3.78125 C 3.613281 -3.976562 3.414062 -4.128906 3.1875 -4.234375 C 2.957031 -4.347656 2.703125 -4.40625 2.421875 -4.40625 C 2.117188 -4.40625 1.847656 -4.347656 1.609375 -4.234375 C 1.367188 -4.128906 1.160156 -3.972656 0.984375 -3.765625 C 0.816406 -3.566406 0.6875 -3.328125 0.59375 -3.046875 C 0.507812 -2.765625 0.46875 -2.457031 0.46875 -2.125 C 0.46875 -1.789062 0.507812 -1.488281 0.59375 -1.21875 C 0.6875 -0.945312 0.816406 -0.710938 0.984375 -0.515625 C 1.148438 -0.328125 1.347656 -0.179688 1.578125 -0.078125 C 1.816406 0.0234375 2.078125 0.078125 2.359375 0.078125 Z M 2.421875 -0.234375 C 2.171875 -0.234375 1.953125 -0.273438 1.765625 -0.359375 C 1.578125 -0.453125 1.414062 -0.582031 1.28125 -0.75 C 1.144531 -0.925781 1.039062 -1.132812 0.96875 -1.375 C 0.90625 -1.613281 0.875 -1.890625 0.875 -2.203125 C 0.875 -2.484375 0.90625 -2.738281 0.96875 -2.96875 C 1.039062 -3.195312 1.140625 -3.394531 1.265625 -3.5625 C 1.398438 -3.726562 1.554688 -3.851562 1.734375 -3.9375 C 1.921875 -4.03125 2.128906 -4.078125 2.359375 -4.078125 C 2.597656 -4.078125 2.8125 -4.03125 3 -3.9375 C 3.1875 -3.851562 3.347656 -3.722656 3.484375 -3.546875 C 3.628906 -3.378906 3.734375 -3.171875 3.796875 -2.921875 C 3.867188 -2.679688 3.910156 -2.414062 3.921875 -2.125 C 3.910156 -1.832031 3.867188 -1.566406 3.796875 -1.328125 C 3.734375 -1.097656 3.632812 -0.898438 3.5 -0.734375 C 3.375 -0.578125 3.21875 -0.453125 3.03125 -0.359375 C 2.84375 -0.273438 2.640625 -0.234375 2.421875 -0.234375 Z M 2.421875 -0.234375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-12"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.796875 -4.328125 L 0.796875 0 L 1.1875 0 L 1.1875 -3.359375 C 1.28125 -3.441406 1.382812 -3.519531 1.5 -3.59375 C 1.613281 -3.675781 1.738281 -3.75 1.875 -3.8125 C 2.007812 -3.882812 2.144531 -3.941406 2.28125 -3.984375 C 2.414062 -4.023438 2.546875 -4.046875 2.671875 -4.046875 C 3.023438 -4.046875 3.285156 -3.9375 3.453125 -3.71875 C 3.617188 -3.507812 3.703125 -3.195312 3.703125 -2.78125 L 3.703125 0 L 4.078125 0 L 4.078125 -2.84375 C 4.078125 -3.082031 4.050781 -3.296875 4 -3.484375 C 3.945312 -3.679688 3.863281 -3.847656 3.75 -3.984375 C 3.644531 -4.117188 3.507812 -4.222656 3.34375 -4.296875 C 3.1875 -4.367188 3 -4.40625 2.78125 -4.40625 C 2.613281 -4.40625 2.453125 -4.378906 2.296875 -4.328125 C 2.148438 -4.285156 2.003906 -4.226562 1.859375 -4.15625 C 1.722656 -4.082031 1.59375 -4.003906 1.46875 -3.921875 C 1.34375 -3.835938 1.234375 -3.753906 1.140625 -3.671875 L 1.078125 -4.328125 Z M 0.796875 -4.328125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-13"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.34375 -4.828125 C 1.332031 -5.191406 1.40625 -5.460938 1.5625 -5.640625 C 1.726562 -5.828125 1.984375 -5.921875 2.328125 -5.921875 C 2.460938 -5.921875 2.578125 -5.910156 2.671875 -5.890625 C 2.765625 -5.867188 2.84375 -5.851562 2.90625 -5.84375 L 2.96875 -6.125 C 2.90625 -6.15625 2.816406 -6.179688 2.703125 -6.203125 C 2.597656 -6.222656 2.476562 -6.238281 2.34375 -6.25 C 2.125 -6.238281 1.929688 -6.195312 1.765625 -6.125 C 1.597656 -6.0625 1.453125 -5.96875 1.328125 -5.84375 C 1.210938 -5.726562 1.125 -5.585938 1.0625 -5.421875 C 1 -5.265625 0.96875 -5.085938 0.96875 -4.890625 L 0.96875 -4.296875 L 0.1875 -4.25 L 0.1875 -4.015625 L 0.96875 -4.015625 L 0.96875 0 L 1.34375 0 L 1.34375 -4.015625 L 2.453125 -4.015625 L 2.453125 -4.328125 L 1.34375 -4.328125 Z M 1.34375 -4.828125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-14"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.796875 -4.328125 L 0.8125 0 L 1.1875 0 L 1.1875 -3.328125 C 1.257812 -3.398438 1.347656 -3.472656 1.453125 -3.546875 C 1.566406 -3.617188 1.71875 -3.695312 1.90625 -3.78125 C 2.09375 -3.875 2.332031 -3.945312 2.625 -4 L 2.625 -4.40625 C 2.351562 -4.363281 2.117188 -4.285156 1.921875 -4.171875 C 1.722656 -4.066406 1.566406 -3.972656 1.453125 -3.890625 C 1.335938 -3.804688 1.234375 -3.71875 1.140625 -3.625 L 1.078125 -4.328125 Z M 0.796875 -4.328125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-15"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.796875 -4.328125 L 0.796875 0 L 1.1875 0 L 1.1875 -3.359375 C 1.28125 -3.441406 1.378906 -3.519531 1.484375 -3.59375 C 1.597656 -3.675781 1.71875 -3.75 1.84375 -3.8125 C 1.976562 -3.882812 2.109375 -3.941406 2.234375 -3.984375 C 2.367188 -4.023438 2.503906 -4.046875 2.640625 -4.046875 C 2.972656 -4.046875 3.21875 -3.9375 3.375 -3.71875 C 3.53125 -3.507812 3.609375 -3.195312 3.609375 -2.78125 L 3.609375 0 L 3.984375 0 L 3.984375 -3.359375 C 4.078125 -3.441406 4.179688 -3.519531 4.296875 -3.59375 C 4.410156 -3.675781 4.53125 -3.75 4.65625 -3.8125 C 4.789062 -3.882812 4.921875 -3.941406 5.046875 -3.984375 C 5.179688 -4.023438 5.3125 -4.046875 5.4375 -4.046875 C 5.769531 -4.046875 6.015625 -3.9375 6.171875 -3.71875 C 6.335938 -3.507812 6.421875 -3.195312 6.421875 -2.78125 L 6.421875 0 L 6.796875 0 L 6.796875 -2.84375 C 6.796875 -3.082031 6.769531 -3.296875 6.71875 -3.484375 C 6.664062 -3.679688 6.585938 -3.847656 6.484375 -3.984375 C 6.378906 -4.117188 6.25 -4.222656 6.09375 -4.296875 C 5.9375 -4.367188 5.753906 -4.40625 5.546875 -4.40625 C 5.253906 -4.40625 4.96875 -4.332031 4.6875 -4.1875 C 4.414062 -4.039062 4.144531 -3.847656 3.875 -3.609375 C 3.789062 -3.859375 3.648438 -4.050781 3.453125 -4.1875 C 3.265625 -4.332031 3.023438 -4.40625 2.734375 -4.40625 C 2.578125 -4.40625 2.421875 -4.378906 2.265625 -4.328125 C 2.117188 -4.285156 1.976562 -4.226562 1.84375 -4.15625 C 1.707031 -4.082031 1.578125 -4.003906 1.453125 -3.921875 C 1.335938 -3.835938 1.234375 -3.753906 1.140625 -3.671875 L 1.078125 -4.328125 Z M 0.796875 -4.328125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-16"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.75 -2.125 C 3.769531 -2.195312 3.796875 -2.296875 3.828125 -2.421875 C 3.859375 -2.554688 3.875 -2.695312 3.875 -2.84375 C 3.875 -3.34375 3.742188 -3.722656 3.484375 -3.984375 C 3.222656 -4.253906 2.859375 -4.394531 2.390625 -4.40625 C 2.097656 -4.40625 1.832031 -4.347656 1.59375 -4.234375 C 1.363281 -4.128906 1.160156 -3.972656 0.984375 -3.765625 C 0.816406 -3.566406 0.6875 -3.328125 0.59375 -3.046875 C 0.507812 -2.765625 0.46875 -2.457031 0.46875 -2.125 C 0.46875 -1.789062 0.515625 -1.488281 0.609375 -1.21875 C 0.703125 -0.945312 0.835938 -0.710938 1.015625 -0.515625 C 1.191406 -0.328125 1.40625 -0.179688 1.65625 -0.078125 C 1.90625 0.0234375 2.179688 0.078125 2.484375 0.078125 C 2.578125 0.078125 2.675781 0.0703125 2.78125 0.0625 C 2.882812 0.0625 2.988281 0.0507812 3.09375 0.03125 C 3.195312 0.0078125 3.296875 -0.0078125 3.390625 -0.03125 C 3.484375 -0.0625 3.570312 -0.09375 3.65625 -0.125 L 3.546875 -0.40625 C 3.472656 -0.375 3.394531 -0.347656 3.3125 -0.328125 C 3.226562 -0.304688 3.140625 -0.289062 3.046875 -0.28125 C 2.960938 -0.269531 2.875 -0.257812 2.78125 -0.25 C 2.695312 -0.238281 2.617188 -0.234375 2.546875 -0.234375 C 2.265625 -0.234375 2.019531 -0.273438 1.8125 -0.359375 C 1.601562 -0.453125 1.425781 -0.578125 1.28125 -0.734375 C 1.144531 -0.898438 1.039062 -1.097656 0.96875 -1.328125 C 0.90625 -1.566406 0.867188 -1.832031 0.859375 -2.125 Z M 2.34375 -4.078125 C 2.707031 -4.078125 2.988281 -3.972656 3.1875 -3.765625 C 3.382812 -3.566406 3.484375 -3.269531 3.484375 -2.875 C 3.484375 -2.675781 3.46875 -2.519531 3.4375 -2.40625 L 0.875 -2.40625 C 0.875 -2.644531 0.910156 -2.863281 0.984375 -3.0625 C 1.054688 -3.269531 1.15625 -3.445312 1.28125 -3.59375 C 1.414062 -3.75 1.566406 -3.867188 1.734375 -3.953125 C 1.910156 -4.035156 2.113281 -4.078125 2.34375 -4.078125 Z M 2.34375 -4.078125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-17"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.796875 -4.328125 L 0.796875 1.671875 L 1.1875 1.671875 L 1.1875 -0.265625 C 1.28125 -0.210938 1.375 -0.160156 1.46875 -0.109375 C 1.570312 -0.0664062 1.703125 -0.0234375 1.859375 0.015625 C 2.015625 0.0546875 2.175781 0.078125 2.34375 0.078125 C 2.632812 0.078125 2.910156 0.0234375 3.171875 -0.078125 C 3.429688 -0.179688 3.65625 -0.332031 3.84375 -0.53125 C 4.03125 -0.726562 4.175781 -0.96875 4.28125 -1.25 C 4.394531 -1.53125 4.457031 -1.847656 4.46875 -2.203125 C 4.457031 -2.523438 4.410156 -2.816406 4.328125 -3.078125 C 4.242188 -3.347656 4.117188 -3.582031 3.953125 -3.78125 C 3.796875 -3.976562 3.597656 -4.128906 3.359375 -4.234375 C 3.128906 -4.347656 2.867188 -4.40625 2.578125 -4.40625 C 2.453125 -4.40625 2.320312 -4.382812 2.1875 -4.34375 C 2.050781 -4.3125 1.921875 -4.265625 1.796875 -4.203125 C 1.671875 -4.140625 1.550781 -4.0625 1.4375 -3.96875 C 1.320312 -3.882812 1.222656 -3.789062 1.140625 -3.6875 L 1.078125 -4.328125 Z M 1.1875 -3.359375 C 1.238281 -3.441406 1.3125 -3.523438 1.40625 -3.609375 C 1.5 -3.691406 1.601562 -3.765625 1.71875 -3.828125 C 1.832031 -3.898438 1.957031 -3.957031 2.09375 -4 C 2.226562 -4.050781 2.367188 -4.078125 2.515625 -4.078125 C 2.765625 -4.078125 2.984375 -4.03125 3.171875 -3.9375 C 3.367188 -3.851562 3.53125 -3.722656 3.65625 -3.546875 C 3.789062 -3.378906 3.890625 -3.175781 3.953125 -2.9375 C 4.023438 -2.695312 4.0625 -2.425781 4.0625 -2.125 C 4.050781 -1.832031 4.003906 -1.570312 3.921875 -1.34375 C 3.847656 -1.113281 3.734375 -0.914062 3.578125 -0.75 C 3.429688 -0.582031 3.257812 -0.453125 3.0625 -0.359375 C 2.863281 -0.273438 2.648438 -0.234375 2.421875 -0.234375 C 2.179688 -0.234375 1.957031 -0.265625 1.75 -0.328125 C 1.550781 -0.390625 1.363281 -0.476562 1.1875 -0.59375 Z M 1.1875 -3.359375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-18"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.71875 -4.328125 L 2.140625 -0.421875 L 0.578125 -4.328125 L 0.1875 -4.328125 L 1.953125 0 L 2.34375 0 L 4.109375 -4.328125 Z M 3.71875 -4.328125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-19"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.953125 0 L 3.953125 -4.328125 L 3.5625 -4.328125 L 3.5625 -0.953125 C 3.46875 -0.867188 3.359375 -0.785156 3.234375 -0.703125 C 3.117188 -0.628906 3 -0.554688 2.875 -0.484375 C 2.75 -0.421875 2.617188 -0.367188 2.484375 -0.328125 C 2.347656 -0.296875 2.21875 -0.28125 2.09375 -0.28125 C 1.75 -0.28125 1.492188 -0.382812 1.328125 -0.59375 C 1.171875 -0.800781 1.09375 -1.117188 1.09375 -1.546875 L 1.09375 -4.328125 L 0.71875 -4.328125 L 0.71875 -1.484375 C 0.71875 -1.234375 0.738281 -1.015625 0.78125 -0.828125 C 0.832031 -0.640625 0.910156 -0.472656 1.015625 -0.328125 C 1.117188 -0.191406 1.25 -0.0859375 1.40625 -0.015625 C 1.570312 0.046875 1.769531 0.078125 2 0.078125 C 2.15625 0.078125 2.304688 0.0546875 2.453125 0.015625 C 2.597656 -0.0234375 2.738281 -0.078125 2.875 -0.140625 C 3.019531 -0.210938 3.148438 -0.289062 3.265625 -0.375 C 3.390625 -0.46875 3.503906 -0.5625 3.609375 -0.65625 L 3.671875 0 Z M 3.953125 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-20"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.796875 -6.15625 L 0.796875 0 L 1.1875 0 L 1.1875 -6.25 Z M 0.796875 -6.15625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-21"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.90625 -1.40625 C 2.113281 -1.40625 2.304688 -1.441406 2.484375 -1.515625 C 2.671875 -1.597656 2.832031 -1.707031 2.96875 -1.84375 C 3.113281 -1.976562 3.226562 -2.140625 3.3125 -2.328125 C 3.394531 -2.515625 3.4375 -2.710938 3.4375 -2.921875 C 3.4375 -3.117188 3.40625 -3.296875 3.34375 -3.453125 C 3.28125 -3.617188 3.203125 -3.765625 3.109375 -3.890625 C 3.210938 -3.960938 3.347656 -4.015625 3.515625 -4.046875 C 3.679688 -4.078125 3.851562 -4.078125 4.03125 -4.046875 L 4.03125 -4.390625 C 3.894531 -4.398438 3.769531 -4.394531 3.65625 -4.375 C 3.550781 -4.363281 3.425781 -4.335938 3.28125 -4.296875 C 3.144531 -4.253906 3.023438 -4.179688 2.921875 -4.078125 C 2.785156 -4.179688 2.632812 -4.257812 2.46875 -4.3125 C 2.3125 -4.375 2.144531 -4.40625 1.96875 -4.40625 C 1.75 -4.40625 1.546875 -4.363281 1.359375 -4.28125 C 1.171875 -4.207031 1.007812 -4.097656 0.875 -3.953125 C 0.738281 -3.816406 0.628906 -3.65625 0.546875 -3.46875 C 0.472656 -3.289062 0.4375 -3.097656 0.4375 -2.890625 C 0.4375 -2.535156 0.519531 -2.238281 0.6875 -2 C 0.851562 -1.769531 1.078125 -1.601562 1.359375 -1.5 C 1.285156 -1.457031 1.21875 -1.410156 1.15625 -1.359375 C 1.09375 -1.304688 1.019531 -1.234375 0.9375 -1.140625 C 0.863281 -1.046875 0.828125 -0.921875 0.828125 -0.765625 C 0.828125 -0.617188 0.851562 -0.507812 0.90625 -0.4375 C 0.96875 -0.363281 1.019531 -0.304688 1.0625 -0.265625 C 1.101562 -0.234375 1.148438 -0.207031 1.203125 -0.1875 C 1.097656 -0.144531 0.992188 -0.0859375 0.890625 -0.015625 C 0.796875 0.0546875 0.707031 0.132812 0.625 0.21875 C 0.550781 0.3125 0.488281 0.410156 0.4375 0.515625 C 0.394531 0.617188 0.375 0.722656 0.375 0.828125 C 0.375 0.992188 0.410156 1.140625 0.484375 1.265625 C 0.566406 1.390625 0.679688 1.492188 0.828125 1.578125 C 0.984375 1.671875 1.164062 1.738281 1.375 1.78125 C 1.582031 1.820312 1.8125 1.84375 2.0625 1.84375 C 2.351562 1.84375 2.613281 1.8125 2.84375 1.75 C 3.070312 1.6875 3.269531 1.597656 3.4375 1.484375 C 3.601562 1.378906 3.726562 1.253906 3.8125 1.109375 C 3.90625 0.960938 3.953125 0.800781 3.953125 0.625 C 3.953125 0.457031 3.914062 0.3125 3.84375 0.1875 C 3.769531 0.0625 3.671875 -0.0390625 3.546875 -0.125 C 3.429688 -0.207031 3.296875 -0.269531 3.140625 -0.3125 C 2.992188 -0.351562 2.84375 -0.375 2.6875 -0.375 L 1.703125 -0.375 C 1.523438 -0.375 1.394531 -0.410156 1.3125 -0.484375 C 1.226562 -0.566406 1.1875 -0.675781 1.1875 -0.8125 C 1.1875 -0.925781 1.234375 -1.035156 1.328125 -1.140625 C 1.421875 -1.253906 1.53125 -1.347656 1.65625 -1.421875 C 1.738281 -1.410156 1.820312 -1.40625 1.90625 -1.40625 Z M 1.921875 -1.71875 C 1.765625 -1.71875 1.617188 -1.742188 1.484375 -1.796875 C 1.347656 -1.859375 1.226562 -1.941406 1.125 -2.046875 C 1.019531 -2.148438 0.9375 -2.273438 0.875 -2.421875 C 0.820312 -2.578125 0.796875 -2.75 0.796875 -2.9375 C 0.796875 -3.101562 0.820312 -3.253906 0.875 -3.390625 C 0.9375 -3.523438 1.019531 -3.644531 1.125 -3.75 C 1.226562 -3.851562 1.347656 -3.9375 1.484375 -4 C 1.628906 -4.0625 1.78125 -4.09375 1.9375 -4.09375 C 2.09375 -4.09375 2.238281 -4.0625 2.375 -4 C 2.519531 -3.945312 2.640625 -3.863281 2.734375 -3.75 C 2.835938 -3.644531 2.914062 -3.515625 2.96875 -3.359375 C 3.03125 -3.210938 3.066406 -3.050781 3.078125 -2.875 C 3.066406 -2.707031 3.03125 -2.550781 2.96875 -2.40625 C 2.914062 -2.269531 2.835938 -2.148438 2.734375 -2.046875 C 2.628906 -1.941406 2.507812 -1.859375 2.375 -1.796875 C 2.238281 -1.742188 2.085938 -1.71875 1.921875 -1.71875 Z M 2.15625 1.515625 C 1.707031 1.515625 1.363281 1.453125 1.125 1.328125 C 0.882812 1.203125 0.765625 1.015625 0.765625 0.765625 C 0.765625 0.671875 0.78125 0.582031 0.8125 0.5 C 0.851562 0.414062 0.90625 0.335938 0.96875 0.265625 C 1.03125 0.203125 1.101562 0.144531 1.1875 0.09375 C 1.269531 0.0390625 1.359375 -0.00390625 1.453125 -0.046875 L 2.625 -0.046875 C 2.925781 -0.046875 3.15625 0.015625 3.3125 0.140625 C 3.476562 0.265625 3.5625 0.441406 3.5625 0.671875 C 3.5625 0.796875 3.523438 0.910156 3.453125 1.015625 C 3.390625 1.117188 3.296875 1.207031 3.171875 1.28125 C 3.046875 1.351562 2.894531 1.410156 2.71875 1.453125 C 2.550781 1.492188 2.363281 1.515625 2.15625 1.515625 Z M 2.15625 1.515625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-22"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.546875 -0.21875 C 0.546875 -0.125 0.570312 -0.0507812 0.625 0 C 0.675781 0.0507812 0.742188 0.078125 0.828125 0.078125 C 0.910156 0.078125 0.984375 0.0507812 1.046875 0 C 1.109375 -0.0625 1.140625 -0.144531 1.140625 -0.25 C 1.140625 -0.332031 1.109375 -0.398438 1.046875 -0.453125 C 0.992188 -0.503906 0.929688 -0.535156 0.859375 -0.546875 C 0.765625 -0.535156 0.6875 -0.5 0.625 -0.4375 C 0.570312 -0.375 0.546875 -0.300781 0.546875 -0.21875 Z M 0.546875 -0.21875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-23"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.46875 -2.796875 C 0.46875 -2.367188 0.523438 -1.976562 0.640625 -1.625 C 0.765625 -1.269531 0.941406 -0.960938 1.171875 -0.703125 C 1.410156 -0.453125 1.695312 -0.257812 2.03125 -0.125 C 2.375 0.0078125 2.757812 0.078125 3.1875 0.078125 C 3.414062 0.078125 3.632812 0.0546875 3.84375 0.015625 C 4.050781 -0.0234375 4.238281 -0.0820312 4.40625 -0.15625 L 4.296875 -0.4375 C 4.179688 -0.394531 4.035156 -0.351562 3.859375 -0.3125 C 3.679688 -0.269531 3.492188 -0.25 3.296875 -0.25 C 2.898438 -0.25 2.550781 -0.304688 2.25 -0.421875 C 1.945312 -0.546875 1.691406 -0.722656 1.484375 -0.953125 C 1.285156 -1.179688 1.132812 -1.457031 1.03125 -1.78125 C 0.9375 -2.101562 0.890625 -2.46875 0.890625 -2.875 C 0.890625 -3.269531 0.941406 -3.617188 1.046875 -3.921875 C 1.148438 -4.234375 1.296875 -4.492188 1.484375 -4.703125 C 1.679688 -4.921875 1.914062 -5.082031 2.1875 -5.1875 C 2.457031 -5.300781 2.753906 -5.359375 3.078125 -5.359375 C 3.285156 -5.359375 3.472656 -5.335938 3.640625 -5.296875 C 3.816406 -5.253906 3.96875 -5.210938 4.09375 -5.171875 L 4.203125 -5.4375 C 4.054688 -5.507812 3.882812 -5.566406 3.6875 -5.609375 C 3.5 -5.660156 3.304688 -5.691406 3.109375 -5.703125 C 2.691406 -5.691406 2.316406 -5.613281 1.984375 -5.46875 C 1.660156 -5.320312 1.382812 -5.117188 1.15625 -4.859375 C 0.925781 -4.597656 0.753906 -4.289062 0.640625 -3.9375 C 0.523438 -3.59375 0.46875 -3.210938 0.46875 -2.796875 Z M 0.46875 -2.796875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-24"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.09375 -6.6875 L -0.171875 1.0625 L 0.21875 1.0625 L 3.46875 -6.6875 Z M 3.09375 -6.6875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-25"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.1875 0 L 1.1875 -2.328125 L 2.296875 -2.328125 C 2.566406 -2.328125 2.816406 -2.363281 3.046875 -2.4375 C 3.273438 -2.507812 3.46875 -2.613281 3.625 -2.75 C 3.789062 -2.894531 3.921875 -3.070312 4.015625 -3.28125 C 4.109375 -3.488281 4.160156 -3.722656 4.171875 -3.984375 C 4.160156 -4.234375 4.113281 -4.457031 4.03125 -4.65625 C 3.945312 -4.851562 3.820312 -5.019531 3.65625 -5.15625 C 3.5 -5.300781 3.304688 -5.410156 3.078125 -5.484375 C 2.859375 -5.566406 2.613281 -5.609375 2.34375 -5.609375 L 0.796875 -5.609375 L 0.796875 0 Z M 2.296875 -5.3125 C 2.773438 -5.300781 3.132812 -5.175781 3.375 -4.9375 C 3.625 -4.695312 3.75 -4.351562 3.75 -3.90625 C 3.75 -3.695312 3.710938 -3.515625 3.640625 -3.359375 C 3.578125 -3.203125 3.453125 -3.039062 3.265625 -2.875 C 3.085938 -2.707031 2.78125 -2.625 2.34375 -2.625 L 1.1875 -2.625 L 1.1875 -5.3125 Z M 2.296875 -5.3125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-26"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.1875 -5.609375 L 0.796875 -5.609375 L 0.796875 0 L 1.1875 0 L 1.1875 -1.453125 L 2.359375 -2.921875 L 4.328125 0 L 4.796875 0 L 2.609375 -3.203125 L 4.46875 -5.609375 L 4.03125 -5.609375 L 1.1875 -1.953125 Z M 1.1875 -5.609375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-27"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.1875 0 L 1.1875 -2.40625 L 2.59375 -2.40625 L 3.875 0 L 4.296875 0 L 2.953125 -2.46875 C 3.097656 -2.519531 3.242188 -2.585938 3.390625 -2.671875 C 3.546875 -2.765625 3.6875 -2.875 3.8125 -3 C 3.945312 -3.125 4.050781 -3.273438 4.125 -3.453125 C 4.207031 -3.628906 4.25 -3.828125 4.25 -4.046875 C 4.25 -4.285156 4.203125 -4.5 4.109375 -4.6875 C 4.015625 -4.882812 3.882812 -5.050781 3.71875 -5.1875 C 3.5625 -5.320312 3.367188 -5.425781 3.140625 -5.5 C 2.921875 -5.570312 2.679688 -5.609375 2.421875 -5.609375 L 0.796875 -5.609375 L 0.796875 0 Z M 2.390625 -5.3125 C 2.847656 -5.300781 3.203125 -5.179688 3.453125 -4.953125 C 3.703125 -4.722656 3.828125 -4.398438 3.828125 -3.984375 C 3.828125 -3.804688 3.796875 -3.644531 3.734375 -3.5 C 3.671875 -3.363281 3.585938 -3.238281 3.484375 -3.125 C 3.378906 -3.019531 3.257812 -2.929688 3.125 -2.859375 C 2.988281 -2.796875 2.847656 -2.75 2.703125 -2.71875 L 1.1875 -2.71875 L 1.1875 -5.3125 Z M 2.390625 -5.3125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-28"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.5625 -2.78125 L 3 -2.78125 L 3 -2.484375 L 4.1875 -2.484375 L 4.1875 -0.46875 C 4.082031 -0.414062 3.9375 -0.363281 3.75 -0.3125 C 3.5625 -0.269531 3.351562 -0.25 3.125 -0.25 C 2.757812 -0.25 2.4375 -0.304688 2.15625 -0.421875 C 1.882812 -0.546875 1.648438 -0.722656 1.453125 -0.953125 C 1.265625 -1.179688 1.117188 -1.457031 1.015625 -1.78125 C 0.921875 -2.101562 0.878906 -2.46875 0.890625 -2.875 C 0.890625 -3.269531 0.941406 -3.617188 1.046875 -3.921875 C 1.148438 -4.234375 1.300781 -4.492188 1.5 -4.703125 C 1.707031 -4.921875 1.953125 -5.082031 2.234375 -5.1875 C 2.515625 -5.300781 2.828125 -5.359375 3.171875 -5.359375 C 3.410156 -5.359375 3.625 -5.332031 3.8125 -5.28125 C 4.007812 -5.238281 4.164062 -5.195312 4.28125 -5.15625 L 4.390625 -5.4375 C 4.335938 -5.457031 4.269531 -5.484375 4.1875 -5.515625 C 4.101562 -5.546875 4.007812 -5.570312 3.90625 -5.59375 C 3.800781 -5.625 3.6875 -5.644531 3.5625 -5.65625 C 3.445312 -5.675781 3.328125 -5.691406 3.203125 -5.703125 C 2.765625 -5.691406 2.375 -5.613281 2.03125 -5.46875 C 1.6875 -5.320312 1.398438 -5.117188 1.171875 -4.859375 C 0.941406 -4.597656 0.765625 -4.289062 0.640625 -3.9375 C 0.523438 -3.59375 0.46875 -3.210938 0.46875 -2.796875 C 0.46875 -2.367188 0.523438 -1.976562 0.640625 -1.625 C 0.753906 -1.269531 0.921875 -0.960938 1.140625 -0.703125 C 1.367188 -0.453125 1.644531 -0.257812 1.96875 -0.125 C 2.289062 0.0078125 2.660156 0.078125 3.078125 0.078125 C 3.222656 0.078125 3.367188 0.0664062 3.515625 0.046875 C 3.660156 0.0351562 3.832031 0.00390625 4.03125 -0.046875 C 4.226562 -0.0976562 4.40625 -0.179688 4.5625 -0.296875 Z M 4.5625 -2.78125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-29"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.796875 -5.609375 L 0.4375 -5.609375 L 0.484375 -4.328125 L 0.765625 -4.328125 L 0.796875 -5.3125 L 3.421875 -5.3125 L 1.125 0 L 1.5 0 L 3.796875 -5.3125 Z M 3.796875 -5.609375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-30"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.125 0 C 2.507812 0 2.867188 -0.0625 3.203125 -0.1875 C 3.535156 -0.320312 3.820312 -0.507812 4.0625 -0.75 C 4.300781 -1 4.488281 -1.296875 4.625 -1.640625 C 4.757812 -1.992188 4.828125 -2.382812 4.828125 -2.8125 C 4.828125 -3.207031 4.765625 -3.578125 4.640625 -3.921875 C 4.523438 -4.265625 4.351562 -4.5625 4.125 -4.8125 C 3.90625 -5.0625 3.625 -5.253906 3.28125 -5.390625 C 2.945312 -5.535156 2.5625 -5.609375 2.125 -5.609375 L 0.796875 -5.609375 L 0.796875 0 Z M 1.1875 -0.296875 L 1.1875 -5.3125 L 2.125 -5.3125 C 2.5 -5.300781 2.828125 -5.234375 3.109375 -5.109375 C 3.398438 -4.992188 3.640625 -4.820312 3.828125 -4.59375 C 4.015625 -4.363281 4.15625 -4.09375 4.25 -3.78125 C 4.351562 -3.46875 4.40625 -3.125 4.40625 -2.75 C 4.40625 -2.363281 4.34375 -2.019531 4.21875 -1.71875 C 4.101562 -1.425781 3.941406 -1.171875 3.734375 -0.953125 C 3.523438 -0.742188 3.28125 -0.582031 3 -0.46875 C 2.71875 -0.351562 2.410156 -0.296875 2.078125 -0.296875 Z M 1.1875 -0.296875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-31"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.46875 0 L 4.859375 0 L 4.859375 -5.609375 L 4.46875 -5.609375 L 4.46875 -2.984375 L 1.1875 -2.984375 L 1.1875 -5.609375 L 0.796875 -5.609375 L 0.796875 0 L 1.1875 0 L 1.1875 -2.671875 L 4.46875 -2.671875 Z M 4.46875 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-32"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.421875 -0.28125 C 0.578125 -0.1875 0.785156 -0.101562 1.046875 -0.03125 C 1.316406 0.0390625 1.617188 0.078125 1.953125 0.078125 C 2.222656 0.078125 2.46875 0.046875 2.6875 -0.015625 C 2.914062 -0.0859375 3.109375 -0.1875 3.265625 -0.3125 C 3.421875 -0.4375 3.539062 -0.585938 3.625 -0.765625 C 3.707031 -0.941406 3.75 -1.140625 3.75 -1.359375 C 3.75 -1.691406 3.632812 -1.976562 3.40625 -2.21875 C 3.1875 -2.46875 2.875 -2.679688 2.46875 -2.859375 L 1.921875 -3.0625 C 1.710938 -3.144531 1.539062 -3.226562 1.40625 -3.3125 C 1.269531 -3.394531 1.160156 -3.484375 1.078125 -3.578125 C 0.992188 -3.679688 0.9375 -3.789062 0.90625 -3.90625 C 0.875 -4.019531 0.859375 -4.160156 0.859375 -4.328125 C 0.859375 -4.472656 0.890625 -4.609375 0.953125 -4.734375 C 1.015625 -4.867188 1.101562 -4.976562 1.21875 -5.0625 C 1.332031 -5.15625 1.460938 -5.226562 1.609375 -5.28125 C 1.765625 -5.332031 1.9375 -5.359375 2.125 -5.359375 C 2.363281 -5.359375 2.585938 -5.332031 2.796875 -5.28125 C 3.015625 -5.226562 3.203125 -5.175781 3.359375 -5.125 L 3.46875 -5.421875 C 3.28125 -5.503906 3.070312 -5.566406 2.84375 -5.609375 C 2.625 -5.660156 2.40625 -5.691406 2.1875 -5.703125 C 1.925781 -5.691406 1.691406 -5.648438 1.484375 -5.578125 C 1.273438 -5.503906 1.09375 -5.40625 0.9375 -5.28125 C 0.78125 -5.15625 0.660156 -5.003906 0.578125 -4.828125 C 0.492188 -4.660156 0.453125 -4.476562 0.453125 -4.28125 C 0.453125 -3.914062 0.550781 -3.613281 0.75 -3.375 C 0.945312 -3.144531 1.21875 -2.960938 1.5625 -2.828125 L 2.109375 -2.625 C 2.328125 -2.53125 2.515625 -2.4375 2.671875 -2.34375 C 2.835938 -2.25 2.96875 -2.148438 3.0625 -2.046875 C 3.15625 -1.953125 3.222656 -1.84375 3.265625 -1.71875 C 3.316406 -1.601562 3.34375 -1.472656 3.34375 -1.328125 C 3.34375 -1.160156 3.3125 -1.007812 3.25 -0.875 C 3.1875 -0.75 3.066406 -0.613281 2.890625 -0.46875 C 2.710938 -0.320312 2.421875 -0.25 2.015625 -0.25 C 1.710938 -0.25 1.4375 -0.28125 1.1875 -0.34375 C 0.945312 -0.40625 0.734375 -0.484375 0.546875 -0.578125 Z M 0.421875 -0.28125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-33"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.796875 -6.15625 L 0.796875 -0.328125 C 0.890625 -0.265625 0.992188 -0.207031 1.109375 -0.15625 C 1.222656 -0.101562 1.34375 -0.0546875 1.46875 -0.015625 C 1.59375 0.015625 1.722656 0.0351562 1.859375 0.046875 C 1.992188 0.0664062 2.125 0.078125 2.25 0.078125 C 2.5625 0.078125 2.847656 0.0234375 3.109375 -0.078125 C 3.367188 -0.179688 3.585938 -0.332031 3.765625 -0.53125 C 3.953125 -0.726562 4.097656 -0.96875 4.203125 -1.25 C 4.304688 -1.53125 4.359375 -1.847656 4.359375 -2.203125 C 4.359375 -2.523438 4.3125 -2.820312 4.21875 -3.09375 C 4.125 -3.363281 3.988281 -3.59375 3.8125 -3.78125 C 3.632812 -3.976562 3.429688 -4.128906 3.203125 -4.234375 C 2.972656 -4.347656 2.71875 -4.40625 2.4375 -4.40625 C 2.238281 -4.40625 2.03125 -4.375 1.8125 -4.3125 C 1.59375 -4.25 1.382812 -4.15625 1.1875 -4.03125 L 1.1875 -6.25 Z M 3.96875 -2.125 C 3.957031 -1.832031 3.910156 -1.566406 3.828125 -1.328125 C 3.753906 -1.097656 3.640625 -0.898438 3.484375 -0.734375 C 3.335938 -0.578125 3.160156 -0.453125 2.953125 -0.359375 C 2.753906 -0.273438 2.53125 -0.234375 2.28125 -0.234375 C 2.070312 -0.234375 1.878906 -0.253906 1.703125 -0.296875 C 1.535156 -0.335938 1.363281 -0.40625 1.1875 -0.5 L 1.1875 -3.734375 C 1.363281 -3.835938 1.554688 -3.921875 1.765625 -3.984375 C 1.972656 -4.046875 2.175781 -4.078125 2.375 -4.078125 C 2.613281 -4.078125 2.832031 -4.03125 3.03125 -3.9375 C 3.226562 -3.851562 3.394531 -3.722656 3.53125 -3.546875 C 3.664062 -3.378906 3.769531 -3.171875 3.84375 -2.921875 C 3.925781 -2.679688 3.96875 -2.414062 3.96875 -2.125 Z M 3.96875 -2.125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-34"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.1875 -5.3125 L 1.921875 -5.3125 L 1.921875 0 L 2.296875 0 L 2.296875 -5.3125 L 4.015625 -5.3125 L 4.015625 -5.609375 L 0.1875 -5.609375 Z M 0.1875 -5.3125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-35"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.71875 -5.609375 L 0.796875 -5.609375 L 0.796875 0 L 1.1875 0 L 1.1875 -2.671875 L 3.515625 -2.671875 L 3.515625 -2.984375 L 1.1875 -2.984375 L 1.1875 -5.3125 L 3.71875 -5.3125 Z M 3.71875 -5.609375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-36"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.34375 1.359375 C 0.414062 1.328125 0.492188 1.273438 0.578125 1.203125 C 0.660156 1.128906 0.738281 1.046875 0.8125 0.953125 C 0.894531 0.859375 0.960938 0.75 1.015625 0.625 C 1.066406 0.5 1.09375 0.363281 1.09375 0.21875 C 1.09375 0.113281 1.082031 0.0195312 1.0625 -0.0625 C 1.039062 -0.15625 1.015625 -0.234375 0.984375 -0.296875 C 0.953125 -0.367188 0.914062 -0.425781 0.875 -0.46875 C 0.84375 -0.519531 0.820312 -0.5625 0.8125 -0.59375 L 0.421875 -0.484375 C 0.492188 -0.398438 0.554688 -0.296875 0.609375 -0.171875 C 0.671875 -0.046875 0.703125 0.0976562 0.703125 0.265625 C 0.703125 0.378906 0.679688 0.484375 0.640625 0.578125 C 0.609375 0.671875 0.5625 0.753906 0.5 0.828125 C 0.445312 0.898438 0.390625 0.960938 0.328125 1.015625 C 0.273438 1.066406 0.222656 1.113281 0.171875 1.15625 Z M 0.34375 1.359375 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,69.802856%,89.01825%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 29.811211 18.571887 L 761.69388 18.571887 L 761.69388 593.430232 L 29.811211 593.430232 Z M 29.811211 18.571887 ",
    transform: "matrix(0.891841,0,0,0.89098,42.831121,28.320001)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,69.802856%,89.01825%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 27.831457 20.553552 L 763.678014 20.553552 L 763.678014 591.448567 L 27.831457 591.448567 Z M 27.831457 20.553552 ",
    transform: "matrix(0.891841,0,0,0.89098,42.831121,28.320001)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,69.802856%,89.01825%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 25.847323 22.535218 L 765.657768 22.535218 L 765.657768 589.466901 L 25.847323 589.466901 Z M 25.847323 22.535218 ",
    transform: "matrix(0.891841,0,0,0.89098,42.831121,28.320001)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,69.802856%,89.01825%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 23.867569 24.516883 L 767.641902 24.516883 L 767.641902 587.480851 L 23.867569 587.480851 Z M 23.867569 24.516883 ",
    transform: "matrix(0.891841,0,0,0.89098,42.831121,28.320001)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,69.802856%,89.01825%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 21.883435 26.498549 L 769.621656 26.498549 L 769.621656 585.499186 L 21.883435 585.499186 Z M 21.883435 26.498549 ",
    transform: "matrix(0.891841,0,0,0.89098,42.831121,28.320001)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,69.802856%,89.01825%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 19.899301 28.480214 L 771.60579 28.480214 L 771.60579 583.517521 L 19.899301 583.517521 Z M 19.899301 28.480214 ",
    transform: "matrix(0.891841,0,0,0.89098,42.831121,28.320001)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,69.802856%,89.01825%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 17.919547 30.461879 L 773.589924 30.461879 L 773.589924 581.535855 L 17.919547 581.535855 Z M 17.919547 30.461879 ",
    transform: "matrix(0.891841,0,0,0.89098,42.831121,28.320001)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,69.802856%,89.01825%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 15.935413 32.447929 L 775.569678 32.447929 L 775.569678 579.55419 L 15.935413 579.55419 Z M 15.935413 32.447929 ",
    transform: "matrix(0.891841,0,0,0.89098,42.831121,28.320001)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0.392151%,69.018555%,87.841797%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 203.232412 278.227054 L 588.767618 278.227054 ",
    transform: "matrix(0.891841,0,0,0.89098,42.831121,28.320001)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0.392151%,69.018555%,87.841797%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 149.665173 384.360144 L 642.334857 384.360144 ",
    transform: "matrix(0.891841,0,0,0.89098,42.831121,28.320001)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0.392151%,69.018555%,87.841797%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 71.999245 509.529499 L 275.892015 509.529499 ",
    transform: "matrix(0.891841,0,0,0.89098,42.831121,28.320001)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    },
    d: "M 169.046875 476.304688 C 170.019531 475.015625 170.992188 473.726562 171.96875 472.4375 C 170.660156 471.078125 171.136719 469.710938 173.234375 468.816406 C 172.648438 469.601562 172.0625 470.382812 171.480469 471.164062 C 171.652344 471.316406 171.824219 471.46875 171.996094 471.621094 C 174.386719 470.988281 175.160156 468.628906 176.472656 466.820312 C 175.777344 467.175781 175.082031 467.53125 174.386719 467.886719 C 175.035156 467.292969 175.601562 466.546875 176.355469 466.144531 C 177.527344 465.515625 178.0625 464.625 178.140625 463.082031 C 175.539062 463.4375 172.898438 463.503906 170.464844 464.246094 C 169.171875 464.636719 168.246094 466.214844 167.136719 467.234375 C 165.855469 468.417969 164.4375 469.476562 163.289062 470.777344 C 162.207031 471.996094 161.308594 473.402344 160.488281 474.820312 C 157.527344 479.957031 154.910156 485.316406 151.644531 490.253906 C 146.40625 498.175781 139.796875 504.816406 130.695312 508.207031 C 124.472656 510.519531 117.980469 511.109375 111.417969 509.183594 C 105.097656 507.332031 102.875 500.5625 103.890625 495.804688 C 105.167969 489.785156 108.699219 485.164062 113.34375 481.269531 C 118.550781 476.90625 124.753906 474.574219 131.023438 472.320312 C 141.039062 468.71875 151.371094 466.363281 161.863281 464.808594 C 164.96875 464.347656 166.429688 463.019531 167.71875 460.359375 C 169.6875 456.304688 172.082031 452.4375 174.5 448.625 C 175.644531 446.820312 177.671875 445.933594 179.753906 445.621094 C 181.484375 445.359375 182.285156 446.527344 181.75 448.195312 C 180.6875 451.503906 178.628906 454.238281 176.5625 456.949219 C 175.027344 458.96875 173.371094 460.894531 171.519531 463.164062 C 174.023438 462.890625 176.238281 462.6875 178.433594 462.367188 C 178.792969 462.3125 179.128906 461.777344 179.386719 461.402344 C 180.351562 460.011719 181.261719 458.582031 182.230469 457.191406 C 182.496094 456.8125 182.847656 456.457031 183.238281 456.226562 C 183.511719 456.0625 183.917969 456.128906 184.265625 456.09375 C 184.257812 456.421875 184.371094 456.824219 184.222656 457.074219 C 183.519531 458.296875 182.746094 459.480469 181.992188 460.671875 C 181.722656 461.097656 181.4375 461.511719 181.351562 462.214844 C 181.953125 462.035156 182.617188 461.953125 183.152344 461.652344 C 188.386719 458.730469 193.613281 455.796875 198.804688 452.792969 C 199.417969 452.4375 199.949219 451.726562 200.238281 451.058594 C 201.089844 449.070312 201.796875 447.019531 202.5625 444.992188 C 202.710938 445.035156 202.859375 445.078125 203.003906 445.121094 C 202.300781 447.203125 201.597656 449.285156 200.773438 451.734375 C 201.722656 451.324219 202.355469 451.082031 202.960938 450.785156 C 213.355469 445.703125 224.101562 441.660156 235.574219 439.765625 C 240.714844 438.914062 245.878906 438.363281 251.089844 439.09375 C 251.925781 439.210938 252.761719 439.4375 253.550781 439.738281 C 255.652344 440.539062 256.109375 442.140625 254.558594 443.8125 C 253.351562 445.117188 252 446.378906 250.492188 447.289062 C 246.582031 449.636719 242.546875 451.78125 238.5625 454.007812 C 238.480469 453.863281 238.398438 453.71875 238.316406 453.574219 C 240.09375 452.617188 241.882812 451.6875 243.640625 450.699219 C 246.945312 448.839844 250.472656 447.292969 253.128906 444.476562 C 253.855469 443.707031 254.789062 442.445312 254.589844 441.675781 C 254.394531 440.910156 252.9375 440.074219 251.957031 439.972656 C 248.925781 439.644531 245.832031 439.359375 242.804688 439.585938 C 232.90625 440.324219 223.378906 442.808594 214.195312 446.519531 C 209.910156 448.253906 205.734375 450.261719 201.554688 452.246094 C 200.886719 452.566406 200.320312 453.355469 199.96875 454.0625 C 198.730469 456.546875 197.605469 459.089844 196.277344 461.953125 C 197.976562 461.257812 199.402344 460.628906 200.859375 460.089844 C 205.453125 458.382812 210.015625 456.585938 214.679688 455.097656 C 216.214844 454.609375 218.058594 454.722656 219.6875 454.988281 C 222.292969 455.417969 223.335938 457.40625 223.328125 460.019531 C 223.320312 462.640625 221.863281 464.507812 220.625 466.476562 C 218.667969 469.589844 216.492188 472.5625 214.402344 475.585938 C 214.277344 475.761719 214.050781 475.863281 213.671875 475.871094 C 213.796875 475.628906 213.898438 475.371094 214.042969 475.148438 C 216.375 471.601562 218.773438 468.097656 221.007812 464.492188 C 221.785156 463.242188 222.332031 461.78125 222.683594 460.34375 C 223.289062 457.882812 221.90625 455.984375 219.429688 455.5 C 216.5625 454.945312 213.851562 455.722656 211.25 456.679688 C 206.21875 458.535156 201.253906 460.585938 196.308594 462.660156 C 195.683594 462.921875 195.210938 463.761719 194.875 464.4375 C 193.632812 466.921875 192.480469 469.445312 191.476562 472.113281 C 191.75 471.6875 191.957031 471.191406 192.308594 470.847656 C 193.441406 469.738281 194.601562 468.652344 195.816406 467.640625 C 196.046875 467.449219 196.65625 467.523438 196.964844 467.699219 C 197.132812 467.792969 197.171875 468.425781 197.03125 468.695312 C 195.757812 471.160156 194.433594 473.597656 193.121094 476.042969 C 192.777344 476.679688 192.425781 477.3125 192.074219 477.945312 C 191.941406 477.871094 191.8125 477.800781 191.679688 477.726562 C 193.324219 474.621094 194.972656 471.519531 196.617188 468.414062 C 196.492188 468.320312 196.367188 468.226562 196.242188 468.132812 C 194.78125 468.738281 193.621094 469.78125 192.734375 471.082031 C 191.417969 473.015625 190.171875 474.996094 188.964844 476.996094 C 188.21875 478.230469 187.121094 478.277344 186.015625 477.894531 C 185.082031 477.574219 184.390625 477.679688 183.738281 478.359375 C 184.328125 477.613281 184.917969 476.871094 185.507812 476.125 C 185.128906 477.058594 185.773438 477.398438 186.445312 477.390625 C 187.042969 477.382812 188.082031 477.113281 188.152344 476.789062 C 188.507812 475.179688 188.609375 473.515625 188.832031 471.570312 C 187.535156 473.324219 186.515625 474.699219 185.5 476.074219 C 187.101562 473.410156 188.570312 470.6875 188.910156 467.476562 C 189.082031 467.507812 189.25 467.542969 189.421875 467.574219 C 189.421875 469.550781 189.421875 471.523438 189.421875 473.5 C 189.515625 473.503906 189.609375 473.507812 189.707031 473.507812 C 191.304688 470.257812 192.90625 467.007812 194.507812 463.761719 C 194.40625 463.703125 194.304688 463.644531 194.207031 463.589844 C 190.121094 465.460938 186.042969 467.332031 181.914062 469.222656 C 182.746094 469.546875 183.429688 469.8125 184.027344 470.046875 C 184.710938 469.476562 185.363281 468.933594 186.011719 468.390625 C 186.140625 468.503906 186.265625 468.621094 186.390625 468.734375 C 186.226562 469.097656 186.117188 469.496094 185.898438 469.816406 C 184.777344 471.445312 183.644531 473.066406 182.484375 474.664062 C 181.347656 476.226562 181.152344 477.824219 182.027344 479.273438 C 182.609375 478.953125 183.199219 478.632812 183.785156 478.3125 C 183.480469 478.703125 183.242188 479.199219 182.851562 479.472656 C 181.835938 480.175781 181.054688 479.742188 180.960938 478.46875 C 180.921875 477.957031 180.953125 477.441406 180.640625 476.703125 C 179.816406 477.480469 178.980469 478.242188 178.175781 479.039062 C 176.769531 480.425781 176.074219 480.375 174.917969 478.6875 C 174.710938 478.859375 174.492188 479.007812 174.308594 479.195312 C 173.628906 479.867188 172.863281 480.695312 171.890625 480.058594 C 171.03125 479.492188 170.191406 478.710938 170.679688 477.351562 C 170.890625 476.773438 170.714844 476.058594 170.714844 475.203125 C 170.042969 475.625 169.527344 475.949219 169.011719 476.273438 Z M 164.992188 464.9375 C 164.082031 465.039062 163.25 465.074219 162.441406 465.230469 C 156.664062 466.359375 150.835938 467.296875 145.128906 468.714844 C 139.789062 470.042969 134.523438 471.742188 129.316406 473.542969 C 121.292969 476.316406 113.792969 480 108.578125 487.109375 C 106.003906 490.621094 103.886719 494.347656 104.285156 498.910156 C 104.710938 503.859375 107.132812 507.492188 112.09375 508.839844 C 116.945312 510.160156 121.824219 509.960938 126.679688 508.902344 C 135.011719 507.082031 141.191406 501.886719 146.699219 495.785156 C 151.121094 490.886719 154.261719 485.113281 157.355469 479.335938 C 158.363281 477.453125 159.335938 475.558594 160.328125 473.667969 C 158.386719 474.785156 156.722656 476.097656 155 477.320312 C 154.570312 477.625 153.9375 477.640625 153.398438 477.789062 C 158.527344 474.675781 162.851562 471.011719 164.992188 464.9375 Z M 184.632812 462.214844 C 183.242188 462.8125 181.753906 463.300781 180.429688 464.066406 C 177.917969 465.511719 177.957031 465.734375 178.84375 468.449219 C 179.191406 469.511719 179.59375 469.652344 180.550781 469.21875 C 184.414062 467.460938 188.308594 465.773438 192.171875 464.015625 C 193.238281 463.527344 194.675781 463.148438 195.191406 462.277344 C 196.824219 459.507812 198.101562 456.527344 199.515625 453.628906 C 199.382812 453.511719 199.25 453.394531 199.117188 453.273438 C 194.121094 456.054688 189.125 458.839844 183.957031 461.714844 C 184.332031 461.980469 184.4375 462.042969 184.527344 462.121094 C 184.648438 462.21875 184.757812 462.328125 184.632812 462.214844 Z M 166.617188 463.730469 C 169.910156 463.886719 170.484375 463.453125 171.820312 461.789062 C 174.03125 459.035156 176.230469 456.269531 178.28125 453.394531 C 179.371094 451.875 180.210938 450.15625 181.003906 448.449219 C 181.25 447.917969 181.226562 446.898438 180.878906 446.550781 C 180.503906 446.171875 179.554688 446.117188 178.9375 446.269531 C 176.976562 446.757812 175.492188 448.035156 174.414062 449.695312 C 172.84375 452.105469 171.316406 454.546875 169.917969 457.054688 C 168.734375 459.175781 167.753906 461.410156 166.617188 463.730469 Z M 178.308594 471.742188 C 178.15625 471.527344 178.003906 471.308594 177.847656 471.09375 C 176.878906 471.289062 175.90625 471.476562 174.9375 471.683594 C 171.820312 472.351562 170.074219 476.113281 171.582031 478.878906 C 172.074219 479.785156 172.800781 480.132812 173.433594 479.21875 C 175.128906 476.773438 176.691406 474.242188 178.308594 471.742188 Z M 176.347656 479.589844 C 176.851562 479.347656 177.167969 479.289062 177.34375 479.097656 C 178.820312 477.496094 180.316406 475.902344 181.707031 474.226562 C 182.265625 473.554688 182.632812 472.707031 182.96875 471.886719 C 183.164062 471.398438 183.128906 470.816406 183.199219 470.273438 C 182.683594 470.257812 182.101562 470.085938 181.65625 470.257812 C 178.050781 471.667969 177.015625 475.054688 175.742188 478.214844 C 175.613281 478.53125 176.117188 479.101562 176.347656 479.589844 Z M 163.683594 469.007812 C 163.804688 469.128906 163.925781 469.246094 164.046875 469.363281 C 165.703125 467.808594 167.359375 466.25 169.015625 464.691406 C 168.902344 464.511719 168.792969 464.332031 168.679688 464.152344 C 167.746094 464.460938 166.511719 464.503906 165.945312 465.140625 C 164.972656 466.234375 164.414062 467.699219 163.683594 469.007812 Z M 174.886719 470.292969 C 175 470.484375 175.109375 470.675781 175.21875 470.867188 C 176.285156 470.496094 177.53125 470.335938 178.324219 469.648438 C 178.644531 469.371094 177.980469 467.953125 177.695312 466.757812 C 176.601562 468.136719 175.742188 469.214844 174.886719 470.292969 Z M 179.671875 461.902344 C 179.824219 462.011719 179.980469 462.117188 180.132812 462.226562 C 181.277344 460.566406 182.417969 458.90625 183.5625 457.246094 C 183.382812 457.125 183.207031 457.007812 183.03125 456.886719 C 181.910156 458.558594 180.789062 460.230469 179.671875 461.902344 Z M 179.671875 461.902344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    },
    d: "M 224.03125 473.867188 C 224.34375 473.34375 224.574219 472.742188 224.984375 472.3125 C 226.472656 470.761719 227.421875 468.988281 227.59375 466.820312 C 227.617188 466.558594 227.78125 466.308594 228.097656 466.089844 C 228.019531 466.6875 227.941406 467.289062 227.847656 468 C 229.203125 467.15625 230.460938 466.371094 231.71875 465.589844 C 231.902344 465.734375 232.082031 465.882812 232.265625 466.027344 C 231.910156 466.75 231.628906 467.519531 231.191406 468.183594 C 230.234375 469.628906 229.15625 470.988281 228.226562 472.445312 C 227.902344 472.953125 227.878906 473.648438 227.625 474.613281 C 229.628906 473.6875 230.320312 472.132812 231.230469 470.75 C 232.109375 469.410156 233.117188 468.152344 234.066406 466.859375 C 234.203125 466.953125 234.34375 467.054688 234.480469 467.148438 C 233.589844 468.476562 232.703125 469.800781 231.808594 471.125 C 230.886719 472.488281 230.144531 473.878906 231.078125 475.644531 C 231.449219 475.515625 231.816406 475.386719 232.261719 475.230469 C 230.945312 476.757812 230.871094 476.71875 229.808594 474.097656 C 229.726562 474.113281 229.636719 474.113281 229.558594 474.148438 C 228.886719 474.453125 228.210938 474.765625 227.539062 475.078125 C 227.515625 474.289062 227.21875 473.371094 227.519531 472.734375 C 228.152344 471.402344 229.085938 470.207031 229.925781 468.976562 C 230.433594 468.226562 231 467.519531 231.367188 466.644531 C 229.257812 467.160156 228.074219 468.625 227.226562 470.449219 C 226.554688 471.894531 225.9375 473.371094 225.203125 474.789062 C 224.945312 475.285156 224.421875 475.644531 224.023438 476.066406 C 223.835938 475.984375 223.648438 475.902344 223.460938 475.824219 C 223.664062 475.15625 223.867188 474.488281 224.074219 473.820312 C 224.078125 474.277344 224.078125 474.738281 224.078125 475.199219 C 224.175781 475.21875 224.277344 475.242188 224.378906 475.261719 C 224.875 474.316406 225.371094 473.371094 225.867188 472.421875 C 225.804688 472.390625 225.738281 472.355469 225.675781 472.324219 C 225.128906 472.839844 224.582031 473.351562 224.03125 473.867188 Z M 224.03125 473.867188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    },
    d: "M 169.015625 476.277344 C 167.601562 477.648438 166.28125 479.140625 164.738281 480.351562 C 163.71875 481.148438 162.816406 480.304688 162.199219 479.46875 C 161.550781 479.804688 160.96875 480.101562 160.414062 480.386719 C 162.335938 477.800781 164.179688 475.257812 166.101562 472.769531 C 166.554688 472.179688 167.261719 471.785156 167.851562 471.300781 C 167.992188 471.40625 168.132812 471.507812 168.269531 471.609375 C 168.085938 472.070312 167.996094 472.613281 167.699219 472.984375 C 166.488281 474.492188 165.242188 475.972656 163.953125 477.410156 C 163.332031 478.101562 162.519531 478.941406 163.34375 479.632812 C 163.769531 479.988281 165.152344 479.625 165.832031 479.175781 C 166.828125 478.519531 167.578125 477.484375 168.449219 476.628906 C 168.605469 476.476562 168.84375 476.410156 169.046875 476.304688 Z M 169.015625 476.277344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    },
    d: "M 217.902344 474.328125 C 217.632812 474.507812 217.097656 474.769531 217.125 474.851562 C 217.515625 476.078125 216.523438 476.199219 215.898438 476.609375 C 215.777344 476.542969 215.65625 476.480469 215.535156 476.414062 C 215.941406 475.644531 216.253906 474.804688 216.773438 474.121094 C 218.742188 471.539062 220.8125 469.039062 222.78125 466.457031 C 224.347656 464.398438 225.851562 462.289062 227.316406 460.15625 C 227.851562 459.371094 228.1875 458.449219 228.714844 457.621094 C 228.8125 459.125 227.957031 460.335938 227.152344 461.496094 C 225.382812 464.046875 223.519531 466.53125 221.691406 469.039062 C 221.28125 469.519531 220.871094 469.996094 220.457031 470.476562 C 219.769531 471.296875 219.035156 472.082031 218.410156 472.949219 C 218.132812 473.328125 218.066406 473.863281 217.902344 474.328125 Z M 217.902344 474.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    },
    d: "M 200.285156 475.441406 C 201.472656 473.195312 202.664062 470.953125 203.855469 468.707031 C 203.929688 468.734375 204.007812 468.757812 204.085938 468.785156 C 203.238281 471.03125 202.398438 473.28125 201.425781 475.867188 C 204.234375 474.667969 204.863281 471.742188 207.007812 470.492188 C 207.121094 470.601562 207.238281 470.710938 207.351562 470.816406 C 206.734375 471.726562 206.085938 472.617188 205.503906 473.546875 C 204.410156 475.289062 204.648438 475.722656 206.683594 475.8125 C 206.808594 475.820312 206.929688 475.875 207.105469 475.921875 C 205.644531 476.613281 205.015625 476.382812 203.855469 474.65625 C 203.441406 475.148438 203.089844 475.644531 202.660156 476.058594 C 201.914062 476.773438 201.210938 477.121094 200.917969 475.652344 C 200.894531 475.53125 200.476562 475.484375 200.242188 475.402344 C 200.242188 475.402344 200.285156 475.441406 200.285156 475.441406 Z M 200.285156 475.441406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    },
    d: "M 196.570312 476.28125 C 196.15625 476.796875 195.792969 477.375 195.304688 477.804688 C 195.128906 477.960938 194.398438 477.855469 194.339844 477.707031 C 194.101562 477.085938 193.722656 476.28125 193.933594 475.765625 C 194.527344 474.34375 195.234375 472.90625 196.191406 471.710938 C 197.296875 470.335938 198.644531 469.121094 200.039062 468.039062 C 200.421875 467.742188 201.5625 467.949219 201.996094 468.332031 C 202.351562 468.648438 202.183594 469.5625 201.988281 470.167969 C 201.710938 469.578125 201.453125 468.511719 201.152344 468.5 C 200.457031 468.46875 199.476562 468.75 199.082031 469.265625 C 197.542969 471.265625 196.152344 473.386719 194.789062 475.511719 C 194.527344 475.917969 194.636719 476.558594 194.546875 477.375 C 195.410156 476.925781 196.003906 476.617188 196.59375 476.308594 Z M 196.570312 476.28125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    },
    d: "M 241.1875 473.539062 C 239.660156 474.722656 239.628906 474.714844 237.519531 472.425781 C 237.105469 472.867188 236.761719 473.398438 236.273438 473.707031 C 235.882812 473.953125 235.203125 474.140625 234.867188 473.960938 C 234.554688 473.792969 234.273438 472.984375 234.421875 472.652344 C 235.324219 470.636719 236.351562 468.675781 237.335938 466.695312 C 237.503906 466.785156 237.675781 466.871094 237.84375 466.964844 C 237.261719 468 236.621094 469.015625 236.117188 470.085938 C 235.628906 471.121094 234.6875 472.09375 235.4375 473.765625 C 236.910156 472.339844 238.222656 471.066406 239.664062 469.675781 C 239.261719 470.730469 238.550781 471.675781 238.667969 472.5 C 238.847656 473.742188 240.066406 473.777344 241.1875 473.539062 Z M 241.1875 473.539062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    },
    d: "M 196.59375 476.308594 C 197.796875 474.089844 198.992188 471.863281 200.21875 469.65625 C 200.320312 469.472656 200.648438 469.414062 201.175781 469.132812 C 200.199219 471.691406 198.199219 473.566406 198.46875 476.546875 C 199.230469 476.085938 199.757812 475.765625 200.285156 475.445312 C 200.285156 475.441406 200.242188 475.40625 200.242188 475.402344 C 199.746094 475.988281 199.320312 476.664062 198.710938 477.089844 C 198.5625 477.191406 197.832031 476.464844 197.210938 476 C 197.191406 476.007812 196.878906 476.144531 196.570312 476.28125 Z M 196.59375 476.308594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    },
    d: "M 220.457031 470.476562 C 220.867188 469.996094 221.28125 469.519531 221.691406 469.039062 C 222.84375 467.859375 223.976562 466.660156 225.15625 465.507812 C 225.710938 464.960938 226.351562 464.503906 226.957031 464.003906 C 227.105469 464.101562 227.257812 464.203125 227.40625 464.300781 C 226.882812 465.460938 226.359375 466.625 225.835938 467.785156 C 225.71875 467.738281 225.597656 467.695312 225.480469 467.648438 C 225.699219 467.015625 225.917969 466.382812 226.132812 465.75 C 226.050781 465.691406 225.96875 465.632812 225.886719 465.578125 C 224.027344 467.542969 222.171875 469.507812 220.316406 471.472656 C 220.363281 471.140625 220.410156 470.808594 220.457031 470.476562 Z M 220.457031 470.476562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    },
    d: "M 225.054688 468.964844 C 223.199219 471.566406 221.347656 474.167969 219.492188 476.769531 C 220.449219 473.5625 222.886719 471.351562 224.769531 468.769531 C 224.863281 468.835938 224.960938 468.902344 225.054688 468.964844 Z M 225.054688 468.964844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.392151%,70.195007%,89.01825%)",
      fillOpacity: 1
    },
    d: "M 275.457031 162.269531 L 259.308594 171.515625 L 259.320312 192.816406 C 259.289062 202.597656 267.203125 210.554688 276.996094 210.582031 C 280.234375 210.59375 283.269531 209.734375 285.886719 208.230469 L 298.960938 200.726562 C 304.117188 198.054688 307.644531 192.679688 307.664062 186.472656 L 307.667969 164.226562 L 304.46875 162.359375 L 291.34375 169.757812 L 291.355469 192.914062 C 291.355469 193.902344 291.25 194.882812 291.054688 195.839844 C 290.859375 196.765625 290.574219 197.679688 290.199219 198.550781 C 290.105469 198.777344 290.003906 199 289.894531 199.222656 C 289.503906 199.175781 289.40625 199.15625 288.8125 199.046875 C 287.964844 198.871094 286.28125 198.390625 284.257812 197.085938 C 283.578125 196.621094 282.9375 196.089844 282.355469 195.503906 C 281.769531 194.921875 281.242188 194.277344 280.78125 193.589844 C 280.320312 192.902344 279.921875 192.164062 279.601562 191.402344 C 279.273438 190.625 279.023438 189.8125 278.859375 188.984375 C 278.6875 188.136719 278.648438 187.261719 278.652344 186.382812 L 278.664062 164.140625 Z M 282.578125 206.242188 C 281.703125 206.609375 280.789062 206.890625 279.855469 207.078125 C 278.902344 207.269531 278.019531 207.367188 277.035156 207.363281 C 276.046875 207.359375 275.0625 207.257812 274.109375 207.058594 C 273.179688 206.867188 272.265625 206.582031 271.390625 206.207031 C 270.535156 205.84375 269.707031 205.390625 268.933594 204.863281 C 268.167969 204.34375 267.445312 203.746094 266.789062 203.085938 C 266.132812 202.429688 265.539062 201.703125 265.023438 200.933594 C 264.5 200.15625 264.054688 199.328125 263.691406 198.46875 C 263.324219 197.59375 263.042969 196.679688 262.855469 195.75 C 262.664062 194.796875 262.628906 193.8125 262.632812 192.824219 L 262.628906 173.386719 L 275.328125 165.988281 L 275.335938 186.375 L 275.332031 186.375 C 275.3125 194.121094 280.71875 200.605469 288.007812 202.167969 C 287.722656 202.507812 287.515625 202.835938 287.199219 203.148438 C 286.542969 203.804688 285.816406 204.398438 285.046875 204.914062 C 284.269531 205.433594 283.4375 205.882812 282.578125 206.242188 Z M 304.085938 189.0625 C 303.914062 189.886719 303.660156 190.699219 303.328125 191.472656 C 303.003906 192.234375 302.601562 192.96875 302.132812 193.65625 C 301.671875 194.339844 301.136719 194.980469 300.550781 195.5625 C 299.964844 196.140625 299.320312 196.671875 298.636719 197.128906 C 297.945312 197.59375 297.207031 197.992188 296.445312 198.308594 C 295.585938 198.679688 294.851562 198.886719 294.023438 199.050781 C 293.859375 199.085938 293.605469 199.117188 293.4375 199.144531 C 294.167969 197.210938 294.660156 195.117188 294.667969 192.929688 L 294.671875 171.625 L 304.339844 166.078125 L 304.339844 186.460938 C 304.339844 187.339844 304.261719 188.210938 304.085938 189.0625 Z M 304.085938 189.0625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(17.64679%,23.529053%,28.627014%)",
      fillOpacity: 1
    },
    d: "M 349.066406 189.085938 C 349.066406 193.109375 345.707031 196.398438 341.167969 196.398438 C 336.628906 196.398438 333.355469 193.109375 333.355469 189.085938 L 333.355469 174.660156 L 330.9375 174.660156 L 330.9375 189.121094 C 330.9375 194.304688 334.9375 198.515625 341.167969 198.515625 C 347.394531 198.515625 351.488281 194.304688 351.488281 189.121094 L 351.492188 174.648438 L 349.074219 174.648438 Z M 374.8125 174.660156 L 367.210938 174.648438 L 367.210938 198.203125 L 374.765625 198.203125 C 381.789062 198.203125 386.5625 193.863281 386.5625 186.417969 C 386.5625 179.042969 381.835938 174.660156 374.8125 174.660156 Z M 374.582031 196.101562 L 369.628906 196.089844 L 369.628906 176.761719 L 374.582031 176.769531 C 380.304688 176.769531 384.164062 180.207031 384.164062 186.417969 C 384.164062 192.667969 380.339844 196.101562 374.582031 196.101562 Z M 442.109375 196.386719 C 436.550781 196.386719 432.578125 191.835938 432.578125 186.253906 C 432.578125 180.738281 436.550781 176.484375 442.042969 176.484375 C 446.433594 176.484375 449.164062 179.078125 449.164062 179.078125 L 450.394531 177.382812 C 450.394531 177.382812 447.566406 174.347656 441.976562 174.347656 C 435.285156 174.347656 430.183594 179.507812 430.183594 186.289062 C 430.183594 193.097656 435.152344 198.523438 442.074219 198.523438 C 447.832031 198.523438 451.027344 194.894531 451.027344 194.894531 L 449.695312 193.265625 C 449.695312 193.265625 446.835938 196.386719 442.109375 196.386719 Z M 466.347656 198.199219 L 468.765625 198.199219 L 468.765625 174.652344 L 466.347656 174.652344 Z M 482.667969 176.765625 L 491.128906 176.765625 L 491.128906 198.203125 L 493.546875 198.203125 L 493.546875 176.765625 L 502.011719 176.765625 L 502.011719 174.652344 L 482.667969 174.652344 Z M 532.691406 174.648438 L 530.09375 174.648438 L 522.59375 185.496094 L 522.527344 185.496094 L 514.953125 174.648438 L 512.324219 174.648438 L 521.355469 188.074219 L 521.355469 198.203125 L 523.773438 198.203125 L 523.765625 188.074219 Z M 407.015625 174.652344 L 397.480469 198.203125 L 400 198.203125 L 402.527344 191.921875 L 413.136719 189.75 L 416.550781 198.203125 L 419.070312 198.203125 L 409.535156 174.652344 Z M 403.585938 189.335938 L 408.242188 177.925781 L 408.308594 177.925781 L 412.242188 187.5625 Z M 403.585938 189.335938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,69.802856%,89.01825%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 16.185072 18.571887 L 18.182346 18.571887 L 18.182346 20.566705 L 16.185072 20.566705 Z M 16.185072 18.571887 ",
    transform: "matrix(0.891841,0,0,0.89098,42.831121,28.320001)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,69.802856%,89.01825%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 16.185072 591.43103 L 18.182346 591.43103 L 18.182346 593.430232 L 16.185072 593.430232 Z M 16.185072 591.43103 ",
    transform: "matrix(0.891841,0,0,0.89098,42.831121,28.320001)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,69.802856%,89.01825%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 773.817684 18.571887 L 775.814958 18.571887 L 775.814958 20.566705 L 773.817684 20.566705 Z M 773.817684 18.571887 ",
    transform: "matrix(0.891841,0,0,0.89098,42.831121,28.320001)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,69.802856%,89.01825%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 773.817684 591.43103 L 775.814958 591.43103 L 775.814958 593.430232 L 773.817684 593.430232 Z M 773.817684 591.43103 ",
    transform: "matrix(0.891841,0,0,0.89098,42.831121,28.320001)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 284.64,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 290.385,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 292.395,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 297.33,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 299.34,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 304.5,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 306.51,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 308.715,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 310.725,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 315.285,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 317.295,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 319.5,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 321.51,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 326.445,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 328.455,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 334.32,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 336.33,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 338.34,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 340.35,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 345.54,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 347.55,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 352.485,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 354.495,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 359.655,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 361.665,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 366.33,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 368.34,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use28 || (_use28 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 370.545,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use29 || (_use29 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 372.555,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use30 || (_use30 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 377.115,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use31 || (_use31 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 379.125,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use32 || (_use32 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 381.33,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use33 || (_use33 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 383.34,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use34 || (_use34 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 388.53,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use35 || (_use35 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 390.54,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use36 || (_use36 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 396.285,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use37 || (_use37 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 398.295,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use38 || (_use38 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 402.96,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use39 || (_use39 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 404.97,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use40 || (_use40 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 409.905,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use41 || (_use41 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 411.915,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use42 || (_use42 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 413.925,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use43 || (_use43 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-11",
    x: 416.16,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use44 || (_use44 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 422.745,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use45 || (_use45 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 424.755,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use46 || (_use46 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 429.315,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use47 || (_use47 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 431.325,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use48 || (_use48 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 433.335,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use49 || (_use49 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 435.345,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use50 || (_use50 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 440.535,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use51 || (_use51 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-11",
    x: 442.545,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use52 || (_use52 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 449.13,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use53 || (_use53 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-12",
    x: 451.14,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use54 || (_use54 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 458.985,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use55 || (_use55 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-13",
    x: 460.995,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use56 || (_use56 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 465.915,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use57 || (_use57 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-14",
    x: 467.925,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use58 || (_use58 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 472.215,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use59 || (_use59 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 474.225,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use60 || (_use60 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 479.16,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use61 || (_use61 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 481.17,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use62 || (_use62 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 485.835,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use63 || (_use63 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 487.845,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use64 || (_use64 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 490.05,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use65 || (_use65 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-11",
    x: 492.06,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use66 || (_use66 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 498.645,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use67 || (_use67 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-15",
    x: 500.655,
    y: 99.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use68 || (_use68 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-1",
    x: 363.84,
    y: 125.280001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use69 || (_use69 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-2",
    x: 372.465,
    y: 125.280001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use70 || (_use70 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-3",
    x: 377.625,
    y: 125.280001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use71 || (_use71 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-4",
    x: 381.165,
    y: 125.280001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use72 || (_use72 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-5",
    x: 385.92,
    y: 125.280001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use73 || (_use73 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-6",
    x: 391.8,
    y: 125.280001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use74 || (_use74 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-7",
    x: 394.005,
    y: 125.280001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use75 || (_use75 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-7",
    x: 398.1,
    y: 125.280001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use76 || (_use76 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-8",
    x: 402.195,
    y: 125.280001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use77 || (_use77 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-6",
    x: 404.085,
    y: 125.280001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use78 || (_use78 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-9",
    x: 406.29,
    y: 125.280001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use79 || (_use79 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-10",
    x: 411.54,
    y: 125.280001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use80 || (_use80 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-7",
    x: 418.11,
    y: 125.280001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use81 || (_use81 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-11",
    x: 422.205,
    y: 125.280001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use82 || (_use82 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-1",
    x: 311.04,
    y: 266.400001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use83 || (_use83 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-2",
    x: 333.795,
    y: 266.400001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use84 || (_use84 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-3",
    x: 347.415,
    y: 266.400001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use85 || (_use85 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-2",
    x: 362.925,
    y: 266.400001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use86 || (_use86 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-3",
    x: 376.545,
    y: 266.400001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use87 || (_use87 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-4",
    x: 392.055,
    y: 266.400001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use88 || (_use88 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-5",
    x: 397.89,
    y: 266.400001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use89 || (_use89 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-2",
    x: 414.435,
    y: 266.400001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use90 || (_use90 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-3",
    x: 428.055,
    y: 266.400001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use91 || (_use91 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-6",
    x: 443.565,
    y: 266.400001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use92 || (_use92 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-7",
    x: 459.435,
    y: 266.400001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use93 || (_use93 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-8",
    x: 474.945,
    y: 266.400001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use94 || (_use94 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-12",
    x: 326.88,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use95 || (_use95 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-2",
    x: 333.78,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use96 || (_use96 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-13",
    x: 338.94,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use97 || (_use97 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-6",
    x: 343.305,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use98 || (_use98 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-13",
    x: 345.51,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use99 || (_use99 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-14",
    x: 349.875,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use100 || (_use100 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-4",
    x: 355.68,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use101 || (_use101 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-4",
    x: 360.435,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use102 || (_use102 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-15",
    x: 365.19,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use103 || (_use103 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-13",
    x: 370.485,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use104 || (_use104 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-13",
    x: 374.85,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use105 || (_use105 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-16",
    x: 379.215,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use106 || (_use106 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-14",
    x: 382.56,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use107 || (_use107 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-17",
    x: 388.365,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use108 || (_use108 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-17",
    x: 390.78,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use109 || (_use109 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-18",
    x: 393.195,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use110 || (_use110 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-6",
    x: 398.46,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use111 || (_use111 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-4",
    x: 400.665,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use112 || (_use112 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-19",
    x: 405.42,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use113 || (_use113 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-20",
    x: 411.255,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use114 || (_use114 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-21",
    x: 420.45,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use115 || (_use115 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-17",
    x: 426.465,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use116 || (_use116 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-15",
    x: 428.88,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use117 || (_use117 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-22",
    x: 434.175,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use118 || (_use118 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-15",
    x: 438.03,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use119 || (_use119 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-23",
    x: 443.325,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use120 || (_use120 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-6",
    x: 449.34,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use121 || (_use121 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-22",
    x: 451.545,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use122 || (_use122 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-5",
    x: 455.4,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use123 || (_use123 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-15",
    x: 461.28,
    y: 297.120001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use124 || (_use124 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-1",
    x: 252.48,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use125 || (_use125 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-2",
    x: 263.325,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use126 || (_use126 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-3",
    x: 273.855,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use127 || (_use127 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-4",
    x: 281.565,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use128 || (_use128 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-5",
    x: 293.34,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use129 || (_use129 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-6",
    x: 305.025,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use130 || (_use130 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-7",
    x: 316.8,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use131 || (_use131 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-8",
    x: 321.225,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use132 || (_use132 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-5",
    x: 331.275,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use133 || (_use133 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-9",
    x: 342.96,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use134 || (_use134 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-6",
    x: 354.57,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use135 || (_use135 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-10",
    x: 366.345,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use136 || (_use136 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-11",
    x: 378.39,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use137 || (_use137 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-3",
    x: 388.71,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use138 || (_use138 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-12",
    x: 396.42,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use139 || (_use139 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-5",
    x: 401.265,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use140 || (_use140 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-6",
    x: 412.95,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use141 || (_use141 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-7",
    x: 424.725,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use142 || (_use142 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-13",
    x: 429.15,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use143 || (_use143 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-11",
    x: 442.98,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use144 || (_use144 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-6",
    x: 453.3,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use145 || (_use145 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-5",
    x: 465.075,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use146 || (_use146 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-10",
    x: 476.76,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use147 || (_use147 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-14",
    x: 488.805,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use148 || (_use148 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-15",
    x: 499.395,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use149 || (_use149 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-16",
    x: 510,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use150 || (_use150 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-14",
    x: 517.08,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(18.03894%,23.921204%,28.627014%)",
      fillOpacity: 1
    }
  }, _use151 || (_use151 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-14",
    x: 527.67,
    y: 360.480001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use152 || (_use152 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-1",
    x: 317.76,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use153 || (_use153 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-2",
    x: 325.305,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use154 || (_use154 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-3",
    x: 327.72,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use155 || (_use155 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-2",
    x: 334.605,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use156 || (_use156 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-1",
    x: 337.02,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use157 || (_use157 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-2",
    x: 344.565,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use158 || (_use158 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-4",
    x: 346.98,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use159 || (_use159 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-2",
    x: 354.885,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use160 || (_use160 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-5",
    x: 357.3,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use161 || (_use161 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-2",
    x: 364.35,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use162 || (_use162 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-6",
    x: 366.765,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use163 || (_use163 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-2",
    x: 372.69,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use164 || (_use164 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-7",
    x: 375.105,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use165 || (_use165 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-2",
    x: 381.945,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use166 || (_use166 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-8",
    x: 384.36,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use167 || (_use167 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-2",
    x: 390.555,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use168 || (_use168 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-6",
    x: 392.97,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use169 || (_use169 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-2",
    x: 398.895,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use170 || (_use170 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-6",
    x: 401.31,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use171 || (_use171 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-2",
    x: 407.235,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use172 || (_use172 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-2",
    x: 409.65,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use173 || (_use173 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-2",
    x: 412.065,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use174 || (_use174 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-9",
    x: 414.48,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use175 || (_use175 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-2",
    x: 420.39,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use176 || (_use176 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-8",
    x: 422.805,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use177 || (_use177 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-4",
    x: 431.415,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use178 || (_use178 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-2",
    x: 439.32,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use179 || (_use179 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-7",
    x: 441.735,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use180 || (_use180 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-2",
    x: 448.575,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use181 || (_use181 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-8",
    x: 450.99,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use182 || (_use182 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-2",
    x: 457.185,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use183 || (_use183 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-3",
    x: 459.6,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use184 || (_use184 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-2",
    x: 466.485,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.392151%,69.018555%,87.841797%)",
      fillOpacity: 1
    }
  }, _use185 || (_use185 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-10",
    x: 468.9,
    y: 392.160001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use186 || (_use186 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-1",
    x: 358.56,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use187 || (_use187 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-2",
    x: 363.84,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use188 || (_use188 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-3",
    x: 368.76,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use189 || (_use189 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-4",
    x: 372.975,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use190 || (_use190 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-5",
    x: 376.86,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use191 || (_use191 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-6",
    x: 378.84,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use192 || (_use192 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-7",
    x: 381.99,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use193 || (_use193 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-8",
    x: 386.295,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use194 || (_use194 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-9",
    x: 388.095,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use195 || (_use195 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-3",
    x: 392.91,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use196 || (_use196 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-10",
    x: 397.125,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use197 || (_use197 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-8",
    x: 400.695,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use198 || (_use198 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-4",
    x: 402.495,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use199 || (_use199 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-11",
    x: 406.38,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use200 || (_use200 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-12",
    x: 411.15,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use201 || (_use201 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-13",
    x: 415.965,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use202 || (_use202 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-5",
    x: 418.695,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use203 || (_use203 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-14",
    x: 420.675,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use204 || (_use204 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-15",
    x: 423.57,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use205 || (_use205 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-16",
    x: 431.1,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use206 || (_use206 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-2",
    x: 435.435,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use207 || (_use207 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-8",
    x: 440.355,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use208 || (_use208 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-6",
    x: 442.155,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use209 || (_use209 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-9",
    x: 445.305,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use210 || (_use210 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-16",
    x: 450.12,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use211 || (_use211 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-8",
    x: 454.455,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use212 || (_use212 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-17",
    x: 456.255,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use213 || (_use213 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-3",
    x: 461.175,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use214 || (_use214 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-14",
    x: 465.39,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use215 || (_use215 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-6",
    x: 468.285,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use216 || (_use216 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-5",
    x: 471.435,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use217 || (_use217 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-4",
    x: 473.415,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use218 || (_use218 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-5",
    x: 477.3,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use219 || (_use219 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-17",
    x: 479.28,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use220 || (_use220 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-3",
    x: 484.2,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use221 || (_use221 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-6",
    x: 488.415,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use222 || (_use222 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-5",
    x: 491.565,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use223 || (_use223 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-11",
    x: 493.545,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use224 || (_use224 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-12",
    x: 498.315,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use225 || (_use225 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-8",
    x: 503.13,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use226 || (_use226 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-11",
    x: 504.93,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use227 || (_use227 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-13",
    x: 509.7,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use228 || (_use228 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-8",
    x: 512.43,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use229 || (_use229 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-6",
    x: 514.23,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use230 || (_use230 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-9",
    x: 517.38,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use231 || (_use231 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-5",
    x: 522.195,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use232 || (_use232 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-10",
    x: 524.175,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use233 || (_use233 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-8",
    x: 527.745,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use234 || (_use234 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-5",
    x: 529.545,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use235 || (_use235 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-12",
    x: 531.525,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use236 || (_use236 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-2",
    x: 536.34,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use237 || (_use237 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-5",
    x: 541.26,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use238 || (_use238 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-18",
    x: 543.24,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use239 || (_use239 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-5",
    x: 547.53,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use240 || (_use240 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-2",
    x: 549.51,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use241 || (_use241 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-19",
    x: 554.43,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use242 || (_use242 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-3",
    x: 559.17,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use243 || (_use243 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-20",
    x: 563.385,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use244 || (_use244 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-8",
    x: 565.365,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use245 || (_use245 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-5",
    x: 567.165,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use246 || (_use246 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-12",
    x: 569.145,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use247 || (_use247 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-8",
    x: 573.96,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use248 || (_use248 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-6",
    x: 575.76,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use249 || (_use249 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-9",
    x: 578.91,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use250 || (_use250 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-5",
    x: 583.725,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use251 || (_use251 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-10",
    x: 585.705,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use252 || (_use252 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-8",
    x: 589.275,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use253 || (_use253 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-17",
    x: 591.075,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use254 || (_use254 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-14",
    x: 595.995,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use255 || (_use255 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-11",
    x: 598.89,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use256 || (_use256 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-21",
    x: 603.66,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use257 || (_use257 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-14",
    x: 607.995,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use258 || (_use258 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-3",
    x: 610.89,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use259 || (_use259 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-15",
    x: 615.105,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use260 || (_use260 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-22",
    x: 622.635,
    y: 515.040001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use261 || (_use261 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-23",
    x: 358.56,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use262 || (_use262 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-11",
    x: 363.225,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use263 || (_use263 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-12",
    x: 367.995,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use264 || (_use264 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-13",
    x: 372.81,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use265 || (_use265 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-5",
    x: 375.54,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use266 || (_use266 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-14",
    x: 377.52,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use267 || (_use267 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-15",
    x: 380.415,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use268 || (_use268 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-8",
    x: 387.945,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use269 || (_use269 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-17",
    x: 389.745,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use270 || (_use270 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-14",
    x: 394.665,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use271 || (_use271 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-11",
    x: 397.56,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use272 || (_use272 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-21",
    x: 402.33,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use273 || (_use273 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-14",
    x: 406.665,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use274 || (_use274 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-3",
    x: 409.56,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use275 || (_use275 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-15",
    x: 413.775,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use276 || (_use276 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-8",
    x: 421.305,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use277 || (_use277 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-4",
    x: 423.105,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use278 || (_use278 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-11",
    x: 426.99,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use279 || (_use279 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-15",
    x: 431.76,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use280 || (_use280 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-17",
    x: 439.29,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use281 || (_use281 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-20",
    x: 444.21,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use282 || (_use282 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-16",
    x: 446.19,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use283 || (_use283 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-6",
    x: 450.525,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use284 || (_use284 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-5",
    x: 453.675,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use285 || (_use285 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-11",
    x: 455.655,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use286 || (_use286 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-12",
    x: 460.425,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use287 || (_use287 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-8",
    x: 465.24,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use288 || (_use288 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-3",
    x: 467.04,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use289 || (_use289 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-6",
    x: 471.255,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use290 || (_use290 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-8",
    x: 474.405,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use291 || (_use291 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-4",
    x: 476.205,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use292 || (_use292 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-11",
    x: 480.09,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use293 || (_use293 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-12",
    x: 484.86,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use294 || (_use294 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-13",
    x: 489.675,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use295 || (_use295 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-5",
    x: 492.405,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use296 || (_use296 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-14",
    x: 494.385,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use297 || (_use297 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-15",
    x: 497.28,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use298 || (_use298 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-22",
    x: 504.81,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use299 || (_use299 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-19",
    x: 506.49,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use300 || (_use300 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-2",
    x: 511.23,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use301 || (_use301 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-3",
    x: 516.15,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use302 || (_use302 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-4",
    x: 520.365,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use303 || (_use303 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-5",
    x: 524.25,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use304 || (_use304 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-6",
    x: 526.23,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use305 || (_use305 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-7",
    x: 529.38,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use306 || (_use306 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-22",
    x: 533.685,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use307 || (_use307 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-4",
    x: 535.365,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use308 || (_use308 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-11",
    x: 539.25,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use309 || (_use309 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-15",
    x: 544.02,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use310 || (_use310 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-24",
    x: 551.55,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use311 || (_use311 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-25",
    x: 554.895,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use312 || (_use312 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-26",
    x: 559.32,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use313 || (_use313 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-27",
    x: 564.3,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use314 || (_use314 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-28",
    x: 568.95,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use315 || (_use315 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-26",
    x: 574.08,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use316 || (_use316 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-29",
    x: 579.06,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use317 || (_use317 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-30",
    x: 583.365,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use318 || (_use318 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-31",
    x: 588.645,
    y: 523.680001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use319 || (_use319 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-32",
    x: 106.08,
    y: 496.800001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use320 || (_use320 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-16",
    x: 110.265,
    y: 496.800001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use321 || (_use321 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-33",
    x: 114.6,
    y: 496.800001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use322 || (_use322 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-3",
    x: 119.43,
    y: 496.800001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use323 || (_use323 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-10",
    x: 123.645,
    y: 496.800001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use324 || (_use324 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-6",
    x: 127.215,
    y: 496.800001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use325 || (_use325 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-5",
    x: 130.365,
    y: 496.800001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use326 || (_use326 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-3",
    x: 132.345,
    y: 496.800001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use327 || (_use327 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-12",
    x: 136.56,
    y: 496.800001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use328 || (_use328 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-8",
    x: 141.375,
    y: 496.800001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use329 || (_use329 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-34",
    x: 143.175,
    y: 496.800001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use330 || (_use330 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-9",
    x: 147.375,
    y: 496.800001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use331 || (_use331 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-14",
    x: 152.19,
    y: 496.800001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use332 || (_use332 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-19",
    x: 155.085,
    y: 496.800001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use333 || (_use333 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-12",
    x: 159.825,
    y: 496.800001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use334 || (_use334 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-35",
    x: 106.08,
    y: 507.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use335 || (_use335 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-11",
    x: 110.19,
    y: 507.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use336 || (_use336 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-19",
    x: 114.96,
    y: 507.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use337 || (_use337 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-12",
    x: 119.7,
    y: 507.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use338 || (_use338 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-2",
    x: 124.515,
    y: 507.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use339 || (_use339 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-16",
    x: 129.435,
    y: 507.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use340 || (_use340 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-14",
    x: 133.77,
    y: 507.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use341 || (_use341 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-36",
    x: 136.665,
    y: 507.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use342 || (_use342 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-8",
    x: 138.21,
    y: 507.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use343 || (_use343 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-1",
    x: 140.01,
    y: 507.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use344 || (_use344 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-2",
    x: 145.29,
    y: 507.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use345 || (_use345 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-3",
    x: 150.21,
    y: 507.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use346 || (_use346 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-4",
    x: 154.425,
    y: 507.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use347 || (_use347 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-5",
    x: 158.31,
    y: 507.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use348 || (_use348 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-6",
    x: 160.29,
    y: 507.360001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(45.881653%,48.626709%,50.195312%)",
      fillOpacity: 1
    }
  }, _use349 || (_use349 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-7",
    x: 163.44,
    y: 507.360001
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPythonNanodegree);
export default __webpack_public_path__ + "static/media/python-nanodegree.e5e769cc4f22280ccb79a51df5bf517b.svg";
export { ForwardRef as ReactComponent };